(function(){"use strict";try{if(typeof document<"u"){var o=document.createElement("style");o.appendChild(document.createTextNode('.bootpay-progress-background{position:fixed;display:block;background-color:transparent;left:0;right:0;top:0;bottom:0;text-align:center;z-index:200000;white-space:nowrap}.bootpay-progress-background.blur-off{background-color:transparent}.bootpay-progress-background:before{display:inline-block;height:100%;content:" ";vertical-align:middle}.bootpay-progress-background .progress-message-window{display:inline-block;text-align:center;max-width:600px;border-radius:3px;width:100%;background-color:transparent;padding:0;vertical-align:middle}@media (min-width: 600px){.bootpay-progress-background .progress-message-window{padding:1rem}}.bootpay-progress-background .progress-message-window .bootpay-spinner{display:inline-block;width:50px;height:50px;border-radius:50%;border-top:2px solid rgba(255,255,255,.2);border-right:2px solid rgba(255,255,255,.2);border-bottom:2px solid rgba(255,255,255,.2);border-left:2px solid #ffffff;animation:spin 1s infinite linear}.bootpay-progress-background .progress-message-window .alfred-text{margin-top:1rem}.bootpay-progress-background .progress-message-window .alfred-text span.alfred-inner-text{font-weight:400;color:#eee}@keyframes spin{0%{transform:rotate(0);border-left:2px solid #ffffff;border-top:2px solid rgba(255,255,255,.2);border-right:2px solid rgba(255,255,255,.2);border-bottom:2px solid rgba(255,255,255,.2)}50%{transform:rotate(180deg);border-left:3px solid #ffffff;border-top:2px solid rgba(255,255,255,.4);border-right:2px solid rgba(255,255,255,.4);border-bottom:2px solid rgba(255,255,255,.4)}to{transform:rotate(360deg);border-left:2px solid #ffffff;border-top:2px solid rgba(255,255,255,.2);border-right:2px solid rgba(255,255,255,.2);border-bottom:2px solid rgba(255,255,255,.2)}}body.bootpay-open{position:fixed!important;left:0;right:0;bottom:0;top:0;padding:0;margin:0;height:100vh!important;overflow:hidden!important;-webkit-overflow-scrolling:auto!important}body.bootpay-open.bootpay-mobile .bootpay-payment-background{background-color:transparent}@media (min-width: 600px){body.bootpay-open.bootpay-mobile .bootpay-payment-background{background-color:#000000b3}}body.bootpay-open .bootpay-payment-background{position:fixed;left:0;right:0;top:0;bottom:0;display:block;text-align:center;background-color:#000000b3;z-index:9999}body.bootpay-open .bootpay-payment-background:before{display:inline-block;vertical-align:middle;height:100%;content:" "}body.bootpay-open .bootpay-payment-background.__alert{padding:1rem}body.bootpay-open .bootpay-payment-background.__alert:before{display:inline-block;vertical-align:middle;height:100%;content:" "}body.bootpay-open .bootpay-payment-background.__alert>.bootpay-confirm-window{position:absolute;max-width:400px;width:100%;background-color:#fff;border-radius:12px;left:50%;top:50%;transform:translate(-50%,-50%);overflow:hidden;box-shadow:0 0 10px #0000001a}body.bootpay-open .bootpay-payment-background.__alert>.bootpay-confirm-window.fade-in{animation:__bootpay-fade-in .1s linear}body.bootpay-open .bootpay-payment-background.__alert>.bootpay-confirm-window.fade-out{animation:__bootpay-fade-out .1s linear}@media (max-width: 768px){body.bootpay-open .bootpay-payment-background.__alert>.bootpay-confirm-window{left:1rem;right:1rem;width:auto;top:50%;transform:translateY(-50%)}}body.bootpay-open .bootpay-payment-background.__alert>.bootpay-confirm-window>.bootpay__alert-header{padding:1rem;text-align:left;font-size:20px;font-weight:600;position:relative}body.bootpay-open .bootpay-payment-background.__alert>.bootpay-confirm-window>.bootpay__alert-header>.bootpay-close-btn{top:40%;transform:translateY(-50%);padding:0;right:1rem}@media (min-width: 600px){body.bootpay-open .bootpay-payment-background.__alert>.bootpay-confirm-window>.bootpay__alert-header>.bootpay-close-btn{right:8px;top:50%;transform:translateY(-55%)}body.bootpay-open .bootpay-payment-background.__alert>.bootpay-confirm-window>.bootpay__alert-header>.bootpay-close-btn:before,body.bootpay-open .bootpay-payment-background.__alert>.bootpay-confirm-window>.bootpay__alert-header>.bootpay-close-btn:after{background-color:#333;width:1px}}body.bootpay-open .bootpay-payment-background.__alert>.bootpay-confirm-window>.bootpay__alert-body{padding:1.5rem 1rem;text-align:center;font-size:16px;color:#333;line-height:1.5}body.bootpay-open .bootpay-payment-background.__alert>.bootpay-confirm-window>.bootpay__alert-footer{display:flex;justify-content:flex-end;border-top:1px solid #f2f2f2}body.bootpay-open .bootpay-payment-background.__alert>.bootpay-confirm-window>.bootpay__alert-footer>button.bootpay__alert-close{flex:0 1 50%;padding:1rem;background-color:#fff;color:#333;font-size:16px;cursor:pointer;border:0;outline:none}body.bootpay-open .bootpay-payment-background.__alert>.bootpay-confirm-window>.bootpay__alert-footer>button.bootpay__alert-close.border-right{border-right:1px solid #f2f2f2}body.bootpay-open .bootpay-payment-background.__alert>.bootpay-confirm-window>.bootpay__alert-footer>button.bootpay__alert-close:hover{background-color:#e0e0e0}body.bootpay-open .bootpay-payment-background.__alert>.bootpay-confirm-window>.bootpay__alert-footer>button.bootpay__alert-close.bootpay-primary{color:#507cf3;font-weight:600}body.bootpay-open .bootpay-payment-background.__alert>.bootpay-confirm-window>.bootpay__alert-footer>button.bootpay__alert-close.bootpay-primary:hover{color:#3f6be2}body.bootpay-open .bootpay-payment-background>.bootpay-payment-window{position:relative;display:inline-block;vertical-align:middle}body.bootpay-open .bootpay-payment-background>.bootpay-payment-window.__mobile{max-width:470px;height:90%}@media (max-width: 768px){body.bootpay-open .bootpay-payment-background>.bootpay-payment-window{position:absolute;left:0;right:0;top:0;bottom:0;border-radius:0!important}body.bootpay-open .bootpay-payment-background>.bootpay-payment-window.__mobile{position:absolute;max-width:inherit;left:0;right:0;top:0;bottom:0;height:100%}body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>iframe{width:100%!important;height:100%!important;border-radius:0}body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>iframe.transparent{background:transparent!important}}body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>button.bootpay-payment-close{position:absolute;display:none;top:-32px;right:4px;color:#fff;font-size:32px;text-decoration:none;outline:none;box-shadow:none;border:0;background-color:transparent}body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>button.bootpay-payment-close:before,body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>button.bootpay-payment-close:after{width:2px!important;background-color:#fff!important}@media (max-width: 768px){body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>button.bootpay-payment-close{top:1rem;right:16px;color:#000;padding:0}body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>button.bootpay-payment-close:before,body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>button.bootpay-payment-close:after{width:2px!important;background-color:#000!important}}body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>.bootpay-popup-window{position:relative;width:400px;height:600px;display:none;background-color:#fff;border-radius:5px;overflow:hidden}@media (max-width: 768px){body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>.bootpay-popup-window{position:absolute;left:0;top:0;bottom:0;right:0;width:100%;height:100%;border-radius:0}}body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>.bootpay-popup-window>.header{position:absolute;left:0;right:0;top:0;height:50px;color:#333;background-color:#fff;text-align:left}body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>.bootpay-popup-window>.body{position:absolute;left:0;right:0;top:50px;bottom:72px;padding:1rem;text-align:left;font-size:14px}body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>.bootpay-popup-window>.body>#bootpay-item-name-id{font-size:16px;color:#888;font-weight:400!important;text-align:center}body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>.bootpay-popup-window>.body>#bootpay-price-id{font-size:36px;color:#333;font-weight:700;text-align:center;line-height:normal}body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>.bootpay-popup-window>.body>.agree-text{position:absolute;bottom:1rem;left:0;right:0;color:#888;font-size:14px;text-align:center}body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>.bootpay-popup-window>.footer{position:absolute;left:0;right:0;bottom:0;height:72px;padding:0 1rem;margin:0}body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>.bootpay-popup-window>.footer>button.bootpay-button{display:block;width:100%;padding:1rem;outline:none;border:none;background-color:#507cf3;border-radius:5px;color:#fff;font-size:16px}body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>.bootpay-popup-window>.footer>button.bootpay-button:hover,body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>.bootpay-popup-window>.footer>button.bootpay-button:active{outline:none;box-shadow:none}body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>iframe{width:100%;height:100%;display:none;border:0!important;outline:0!important;border-radius:0;box-shadow:none}@media (min-width: 600px){body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>iframe{width:0;height:0;border:0;outline:0;border-radius:0!important;box-shadow:none!important}}body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>iframe.rounded-iframe{border-radius:0}@media (min-width: 600px){body.bootpay-open .bootpay-payment-background>.bootpay-payment-window>iframe.rounded-iframe{width:0;height:0;border:0;outline:0;border-radius:20px!important;box-shadow:none!important}}body.bootpay-open .bootpay-payment-background #__bootpay-modal-iframe.slide-up{animation:__bootpay-slide-up .3s linear}body.bootpay-open .bootpay-payment-background #__bootpay-modal-iframe.slide-down{animation:__bootpay-slide-down .3s linear}body.bootpay-open .bootpay-payment-background>.bootpay-confirm-window>iframe{display:none;width:1px;height:1px;background:transparent;border:0!important;outline:0!important}.bootpay-close-btn{position:absolute;box-shadow:none;background-color:transparent;outline:0;z-index:10001;right:8px;top:8px;height:21px;width:21px;border:0!important;outline:none!important}@media (min-width: 600px){.bootpay-close-btn{right:4px;top:-32px;width:25px;height:25px;background:transparent;outline:none!important;border:0!important}}.bootpay-close-btn.active,.bootpay-close-btn:focus{outline:none!important;border:0!important}.bootpay-close-btn:before,.bootpay-close-btn:after{position:absolute;left:8px;top:2px;content:" ";height:24px;width:1px;background-color:#333}@media (min-width: 600px){.bootpay-close-btn:before,.bootpay-close-btn:after{height:23px;top:0;width:2px;background-color:#fff}}.bootpay-close-btn:before{transform:rotate(45deg)}.bootpay-close-btn:after{transform:rotate(-45deg)}@keyframes __bootpay-slide-up{0%{transform:translateY(150%);opacity:0}to{transform:translateY(0);opacity:1}}@keyframes __bootpay-slide-down{0%{transform:translateY(0);opacity:1}to{transform:translateY(150%);opacity:0}}@keyframes __bootpay-fade-in{0%{opacity:0;scale:.9}to{opacity:1;scale:1}}@keyframes __bootpay-fade-out{0%{opacity:1;scale:1}to{opacity:0;scale:.9}}.__bootpay-store-el-fullscreen{position:absolute;left:0;right:0;top:0;bottom:0;height:100%}.bootpay-store-iframe-container{width:100%;height:100%}.bootpay-store-iframe-container>iframe{width:100%;border:0;outline:none;overflow:scroll}.bootpay-store-iframe-container>.bootpay-store-overlay{position:fixed;left:0;right:0;top:0;bottom:0;background-color:#000000b3;z-index:100000;text-align:center;display:none}.bootpay-store-iframe-container>.bootpay-store-overlay.fade-in{animation:fadeIn .2s ease}.bootpay-store-iframe-container>.bootpay-store-overlay.fade-out{animation:fadeOut .2s ease}.bootpay-store-iframe-container>.bootpay-store-overlay:before{display:inline-block;vertical-align:middle;height:100%;content:" "}@media (max-width: 600px){.bootpay-store-iframe-container>.bootpay-store-overlay:before{display:block;height:inherit;vertical-align:inherit}}.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-overlay-iframe-container{display:inline-block;vertical-align:middle}@media (max-width: 600px){.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-overlay-iframe-container{width:100%!important;height:100%!important}}.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-alert-container{display:inline-block;background-color:#fff;vertical-align:middle;max-width:450px;width:100%;text-align:left;border-radius:12px;overflow:hidden}@media (max-width: 768px){.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-alert-container{margin:1rem}}.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-alert-container.zoom-in{animation:zoomIn .2s ease}.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-alert-container.zoom-out{animation:zoomOut .2s ease}.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-alert-container>.bootpay-store-alert-header{position:relative;padding:1rem 1.5rem;font-size:18px}.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-alert-container>.bootpay-store-alert-header .bootpay-close-btn{position:absolute;box-shadow:none;background-color:transparent;outline:0;z-index:10001;right:1rem;top:50%;transform:translateY(-50%);height:21px;width:21px;border:0!important;outline:none!important}.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-alert-container>.bootpay-store-alert-header .bootpay-close-btn.active,.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-alert-container>.bootpay-store-alert-header .bootpay-close-btn:focus{outline:none!important;border:0!important}.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-alert-container>.bootpay-store-alert-header .bootpay-close-btn:before,.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-alert-container>.bootpay-store-alert-header .bootpay-close-btn:after{position:absolute;left:8px;top:0;content:" ";height:24px;width:1px;background-color:#888}.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-alert-container>.bootpay-store-alert-header .bootpay-close-btn:before{transform:rotate(45deg)}.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-alert-container>.bootpay-store-alert-header .bootpay-close-btn:after{transform:rotate(-45deg)}.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-alert-container>.bootpay-store-alert-body{padding:1rem 1.5rem 2rem}.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-alert-container>.bootpay-store-alert-footer>.bootpay-store-alert-button-grid{display:flex;width:100%}.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-alert-container>.bootpay-store-alert-footer>.bootpay-store-alert-button-grid>.bootpay-store-cols{flex:0 50%}.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-alert-container>.bootpay-store-alert-footer button.bootpay-btn{display:block;box-shadow:none;background-color:transparent;border:0!important;outline:none!important;width:100%;padding:1rem 0}.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-alert-container>.bootpay-store-alert-footer button.bootpay-btn.bootpay-alert-cancel-button{background-color:#f1f1f1;color:#333;font-size:18px;font-weight:500}.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-alert-container>.bootpay-store-alert-footer button.bootpay-btn.bootpay-alert-cancel-button:hover{opacity:.8}.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-alert-container>.bootpay-store-alert-footer button.bootpay-btn.bootpay-alert-confirm-button{background-color:#507cf3;color:#fff;font-size:18px;font-weight:500}.bootpay-store-iframe-container>.bootpay-store-overlay>.bootpay-store-alert-container>.bootpay-store-alert-footer button.bootpay-btn.bootpay-alert-confirm-button:hover{opacity:.8}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}@keyframes zoomIn{0%{transform:scale(.9)}to{transform:scale(1)}}@keyframes zoomOut{0%{transform:scale(1)}to{transform:scale(.9)}}')),document.head.appendChild(o)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
const te = {
  PLATFORM: {
    JS: 1,
    ANDROID: 2,
    IOS: 3,
    REST: 4
  },
  STORAGE_PREFIX(t) {
    return `__bootpay_track_${t}__`;
  }
}, J0 = () => "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (t) => {
  let e = Math.random() * 16 | 0;
  return (t == "x" ? e : e & 3 | 8).toString(16);
}), re = (t) => {
  let e = !1;
  return typeof t == "string" || Array.isArray(t) ? e = t.length === 0 : e = t == null || st(t, "object") && t.constructor === Object && Object.keys(t).length === 0, e;
}, M = (t) => !re(t), st = (t, e) => typeof t === e, Ds = (t, e = void 0) => {
  if (M(e)) {
    const r = typeof e != "string" ? new URLSearchParams(JSON.parse(JSON.stringify(e))).toString() : e;
    return /\?/.test(t) ? `${t}&${r}` : `${t}?${r}`;
  } else
    return t;
}, wt = (t, e) => {
  for (let r in e)
    e.hasOwnProperty(r) && (t[r] = e[r]);
  return t;
};
var N = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ze(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Fs(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function s() {
      return this instanceof s ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(s) {
    var n = Object.getOwnPropertyDescriptor(t, s);
    Object.defineProperty(r, s, n.get ? n : {
      enumerable: !0,
      get: function() {
        return t[s];
      }
    });
  }), r;
}
var Z0 = { exports: {} };
function Hs(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var $t = { exports: {} };
const Ms = {}, Ns = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ms
}, Symbol.toStringTag, { value: "Module" })), Ls = /* @__PURE__ */ Fs(Ns);
var Gr;
function W() {
  return Gr || (Gr = 1, function(t, e) {
    (function(r, s) {
      t.exports = s();
    })(N, function() {
      var r = r || function(s, n) {
        var i;
        if (typeof window < "u" && window.crypto && (i = window.crypto), typeof self < "u" && self.crypto && (i = self.crypto), typeof globalThis < "u" && globalThis.crypto && (i = globalThis.crypto), !i && typeof window < "u" && window.msCrypto && (i = window.msCrypto), !i && typeof N < "u" && N.crypto && (i = N.crypto), !i && typeof Hs == "function")
          try {
            i = Ls;
          } catch {
          }
        var x = function() {
          if (i) {
            if (typeof i.getRandomValues == "function")
              try {
                return i.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof i.randomBytes == "function")
              try {
                return i.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, d = Object.create || /* @__PURE__ */ function() {
          function l() {
          }
          return function(f) {
            var m;
            return l.prototype = f, m = new l(), l.prototype = null, m;
          };
        }(), p = {}, a = p.lib = {}, c = a.Base = /* @__PURE__ */ function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(l) {
              var f = d(this);
              return l && f.mixIn(l), (!f.hasOwnProperty("init") || this.init === f.init) && (f.init = function() {
                f.$super.init.apply(this, arguments);
              }), f.init.prototype = f, f.$super = this, f;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var l = this.extend();
              return l.init.apply(l, arguments), l;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(l) {
              for (var f in l)
                l.hasOwnProperty(f) && (this[f] = l[f]);
              l.hasOwnProperty("toString") && (this.toString = l.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), y = a.WordArray = c.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(l, f) {
            l = this.words = l || [], f != n ? this.sigBytes = f : this.sigBytes = l.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(l) {
            return (l || u).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(l) {
            var f = this.words, m = l.words, b = this.sigBytes, E = l.sigBytes;
            if (this.clamp(), b % 4)
              for (var k = 0; k < E; k++) {
                var S = m[k >>> 2] >>> 24 - k % 4 * 8 & 255;
                f[b + k >>> 2] |= S << 24 - (b + k) % 4 * 8;
              }
            else
              for (var A = 0; A < E; A += 4)
                f[b + A >>> 2] = m[A >>> 2];
            return this.sigBytes += E, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var l = this.words, f = this.sigBytes;
            l[f >>> 2] &= 4294967295 << 32 - f % 4 * 8, l.length = s.ceil(f / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var l = c.clone.call(this);
            return l.words = this.words.slice(0), l;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(l) {
            for (var f = [], m = 0; m < l; m += 4)
              f.push(x());
            return new y.init(f, l);
          }
        }), o = p.enc = {}, u = o.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(l) {
            for (var f = l.words, m = l.sigBytes, b = [], E = 0; E < m; E++) {
              var k = f[E >>> 2] >>> 24 - E % 4 * 8 & 255;
              b.push((k >>> 4).toString(16)), b.push((k & 15).toString(16));
            }
            return b.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(l) {
            for (var f = l.length, m = [], b = 0; b < f; b += 2)
              m[b >>> 3] |= parseInt(l.substr(b, 2), 16) << 24 - b % 8 * 4;
            return new y.init(m, f / 2);
          }
        }, h = o.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(l) {
            for (var f = l.words, m = l.sigBytes, b = [], E = 0; E < m; E++) {
              var k = f[E >>> 2] >>> 24 - E % 4 * 8 & 255;
              b.push(String.fromCharCode(k));
            }
            return b.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(l) {
            for (var f = l.length, m = [], b = 0; b < f; b++)
              m[b >>> 2] |= (l.charCodeAt(b) & 255) << 24 - b % 4 * 8;
            return new y.init(m, f);
          }
        }, v = o.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(l) {
            try {
              return decodeURIComponent(escape(h.stringify(l)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(l) {
            return h.parse(unescape(encodeURIComponent(l)));
          }
        }, g = a.BufferedBlockAlgorithm = c.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new y.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(l) {
            typeof l == "string" && (l = v.parse(l)), this._data.concat(l), this._nDataBytes += l.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(l) {
            var f, m = this._data, b = m.words, E = m.sigBytes, k = this.blockSize, S = k * 4, A = E / S;
            l ? A = s.ceil(A) : A = s.max((A | 0) - this._minBufferSize, 0);
            var _ = A * k, w = s.min(_ * 4, E);
            if (_) {
              for (var B = 0; B < _; B += k)
                this._doProcessBlock(b, B);
              f = b.splice(0, _), m.sigBytes -= w;
            }
            return new y.init(f, w);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var l = c.clone.call(this);
            return l._data = this._data.clone(), l;
          },
          _minBufferSize: 0
        });
        a.Hasher = g.extend({
          /**
           * Configuration options.
           */
          cfg: c.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(l) {
            this.cfg = this.cfg.extend(l), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            g.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(l) {
            return this._append(l), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(l) {
            l && this._append(l);
            var f = this._doFinalize();
            return f;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(l) {
            return function(f, m) {
              return new l.init(m).finalize(f);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(l) {
            return function(f, m) {
              return new $.HMAC.init(l, m).finalize(f);
            };
          }
        });
        var $ = p.algo = {};
        return p;
      }(Math);
      return r;
    });
  }($t)), $t.exports;
}
(function(t, e) {
  (function(r, s) {
    t.exports = s(W());
  })(N, function(r) {
    return r.enc.Utf8;
  });
})(Z0);
var qs = Z0.exports;
const Xr = /* @__PURE__ */ ze(qs);
var Et = { exports: {} }, Vr;
function Re() {
  return Vr || (Vr = 1, function(t, e) {
    (function(r, s) {
      t.exports = s(W());
    })(N, function(r) {
      return function() {
        var s = r, n = s.lib, i = n.WordArray, x = s.enc;
        x.Base64 = {
          /**
           * Converts a word array to a Base64 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Base64 string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
           */
          stringify: function(p) {
            var a = p.words, c = p.sigBytes, y = this._map;
            p.clamp();
            for (var o = [], u = 0; u < c; u += 3)
              for (var h = a[u >>> 2] >>> 24 - u % 4 * 8 & 255, v = a[u + 1 >>> 2] >>> 24 - (u + 1) % 4 * 8 & 255, g = a[u + 2 >>> 2] >>> 24 - (u + 2) % 4 * 8 & 255, $ = h << 16 | v << 8 | g, l = 0; l < 4 && u + l * 0.75 < c; l++)
                o.push(y.charAt($ >>> 6 * (3 - l) & 63));
            var f = y.charAt(64);
            if (f)
              for (; o.length % 4; )
                o.push(f);
            return o.join("");
          },
          /**
           * Converts a Base64 string to a word array.
           *
           * @param {string} base64Str The Base64 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
           */
          parse: function(p) {
            var a = p.length, c = this._map, y = this._reverseMap;
            if (!y) {
              y = this._reverseMap = [];
              for (var o = 0; o < c.length; o++)
                y[c.charCodeAt(o)] = o;
            }
            var u = c.charAt(64);
            if (u) {
              var h = p.indexOf(u);
              h !== -1 && (a = h);
            }
            return d(p, a, y);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function d(p, a, c) {
          for (var y = [], o = 0, u = 0; u < a; u++)
            if (u % 4) {
              var h = c[p.charCodeAt(u - 1)] << u % 4 * 2, v = c[p.charCodeAt(u)] >>> 6 - u % 4 * 2, g = h | v;
              y[o >>> 2] |= g << 24 - o % 4 * 8, o++;
            }
          return i.create(y, o);
        }
      }(), r.enc.Base64;
    });
  }(Et)), Et.exports;
}
var Ws = Re();
const Ce = /* @__PURE__ */ ze(Ws);
class Ae {
  $blank(e) {
    return re(e);
  }
  $present(e) {
    return !this.$blank(e);
  }
  $type(e, r) {
    return st(e, r);
  }
  $uuid() {
    return J0();
  }
  $encrypt(e) {
    return this.$type(e, "object") && (e = JSON.stringify(e)), Ce.stringify(Xr.parse(e));
  }
  $decrypt(e) {
    return Xr.stringify(Ce.parse(e));
  }
  getUserAgent() {
    return window.navigator.userAgent;
  }
}
const Qe = {
  debug: 1,
  info: 2,
  warning: 3,
  error: 4
}, F = {
  level: Qe.warning,
  /**
   * 로그 레벨을 설정한다
   * Comment by John
   * @date: 2021-02-18
   * @param logLevel: number
   */
  setLogLevel(t) {
    this.level = t;
  },
  messageStringify(t, e) {
    try {
      return e = `${t}: ${st(e, "object") ? JSON.stringify(e) : e}`;
    } catch (r) {
      console.error(`log parse error: ${r}`);
    }
  },
  debug(t, e) {
    this.level <= Qe.debug && console.log(this.messageStringify(t, e));
  },
  info(t, e) {
    this.level <= Qe.info && console.info(this.messageStringify(t, e));
  },
  warn(t, e) {
    this.level <= Qe.warning && console.warn(this.messageStringify(t, e));
  },
  error(t, e) {
    this.level <= Qe.error && console.error(this.messageStringify(t, e));
  }
};
class zs extends Ae {
  constructor() {
    super(), this.$storage = {};
  }
  /**
   * Local Storage 에 데이터를 가져온다
   * Comment by Gosomi
   * @date: 2021-02-18
   * @param key: string
   * @returns string
   */
  get(e) {
    let r = "";
    try {
      r = window.localStorage.getItem(e);
    } catch {
      r = this.$storage[e];
    }
    return this.$present(r) ? this.$decrypt(r) : void 0;
  }
  /**
   * Local Storage에 데이터를 저장
   * Comment by Gosomi
   * @date: 2021-02-18
   * @param key: string
   * @param value: any
   * @returns any
   */
  set(e, r) {
    try {
      window.localStorage.setItem(e, this.$encrypt(r));
    } catch {
      this.$storage[e] = this.$encrypt(r);
    }
    return r;
  }
  /**
   * 현재 사용자의 고유 UUID를 Local Storage에서 가져온다
   * Comment by Gosomi
   * @date: 2021-02-18
   * @returns string
   */
  currentUserUUID() {
    const e = te.STORAGE_PREFIX("uuid"), r = this.get(e);
    return this.$blank(r) ? this.set(e, this.$uuid()) : r;
  }
  /**
   * UUID를 외부 값으로 설정
   * Comment by GOSOMI
   * @date: 2021-12-22
   * @param uuid: string
   * @returns string
   */
  setUUID(e) {
    const r = te.STORAGE_PREFIX("uuid");
    return this.set(r, e);
  }
  /**
   * Local Storage 에서 JSON -> Object 변환해서 가져온다
   * Comment by Gosomi
   * @date: 2021-02-18
   * @param key: string
   * @returns object
   */
  getToJSON(e) {
    const r = this.get(e);
    return this.$present(r) ? this.caseMarshalToJson(r) : r;
  }
  /**
   * Local Storage 에서 Object -> JSON으로 데이터를 변환해서 저장한다
   * Comment by Gosomi
   * @date: 2021-02-18
   * @param key: string
   * @param value: any
   * @returns any
   */
  setToJSON(e, r) {
    return this.set(e, JSON.stringify(r)), r;
  }
  caseMarshalToJson(e) {
    try {
      return JSON.parse(e);
    } catch {
      return JSON.parse(e.replace(/\\\"/g, '"'));
    }
  }
}
class js extends zs {
  constructor() {
    super(), this.currentUserUUID();
  }
  /**
   * 현재 결제의 Session key를 가져온다. 1800초 ( 30분 ) 초과되면 세션을 갱신한다
   * Comment by Gosomi
   * @date: 2021-02-18
   * @returns string
   */
  currentSessionKey() {
    const e = Math.round((/* @__PURE__ */ new Date()).getTime() / 1e3), r = te.STORAGE_PREFIX("session"), s = this.getToJSON(r);
    return this.$blank(s) || s.time + 1800 < e ? this.setToJSON(r, {
      time: e,
      term: this.$blank(s) ? -1 : e - s.time,
      uuid: `${this.$uuid()}-${e}`
    }).uuid : s.uuid;
  }
  /**
   * 재방문 시간을 리턴한다
   * Comment by GOSOMI
   * @date: 2021-05-12
   * @returns number
   */
  currentTimeTerm() {
    const e = te.STORAGE_PREFIX("session"), r = this.getToJSON(e);
    return this.$blank(r.term) ? -1 : r.term;
  }
  currentTime() {
    const e = te.STORAGE_PREFIX("session"), r = this.getToJSON(e);
    return this.$blank(r.time) ? -1 : r.time;
  }
  setTime(e) {
    const r = Math.round((/* @__PURE__ */ new Date()).getTime() / 1e3), s = te.STORAGE_PREFIX("session"), n = this.getToJSON(s), i = this.$blank(n) ? {
      time: e > 0 ? e : r,
      term: e > 0 ? r - e : -1,
      uuid: `${this.$uuid()}-${r}`
    } : n;
    i.time = e, this.setToJSON(s, i);
  }
  /**
   * 사용할 기본 키를 조합한다
   * Comment by GOSOMI
   * @date: 2021-05-20
   */
  generateKey() {
    return `${this.$uuid()}-${(/* @__PURE__ */ new Date()).getTime()}`;
  }
  /**
   * 사용자 정보를 저장
   * Comment by GOSOMI
   * @date: 2022-03-02      @returns
   */
  setUser(e) {
    return this.set(te.STORAGE_PREFIX("user"), e === void 0 ? void 0 : JSON.stringify(e)), e;
  }
  /**
   * 사용자 정보를 가져온다
   * Comment by GOSOMI
   * @date: 2022-03-02
   */
  getUser() {
    try {
      return JSON.parse(this.get(te.STORAGE_PREFIX("user")));
    } catch (e) {
      F.error("User Storage", `사용자 정보를 추출하는데 실패하였습니다. [ ${e.message} ]`);
      return;
    }
  }
}
const Te = new js(), Ks = "@bootpay/client-js", Gs = "5.1.4", Xs = "dist/index.es.js", Vs = "dist/src/index.d.ts", Ys = "dist/index.css", Js = {
  test: 'echo "Error: no test specified" && exit 1',
  build: "rm -rf ./dist && vite build",
  deploy: "NODE_ENV=production ./node_modules/.bin/webpack --output-path=./dist --mode=production && gzip -kf dist/*.min.js && ./webview.sh $npm_package_version"
}, Zs = {
  typescript: "^5.5.4"
}, Qs = {
  "@types/ws": "^8.5.5",
  "@types/node": "^18.15.3",
  "@webpack-cli/serve": "^2.0.5",
  "webpack-dev-server": "^4.15.1",
  webpack: "^5.87.0",
  "webpack-cli": "^5.1.4",
  axios: "^0.27.2",
  "crypto-js": "^4.1.1",
  "@types/crypto-js": "^4.1.1",
  "@babel/core": "^7.22.5",
  "@babel/plugin-transform-regenerator": "^7.22.5",
  "@babel/plugin-transform-runtime": "^7.22.5",
  "@babel/plugin-transform-object-assign": "^7.22.5",
  "@babel/plugin-proposal-class-properties": "^7.18.6",
  "@babel/plugin-transform-destructuring": "^7.24.8",
  "@babel/preset-env": "^7.22.5",
  "@babel/preset-typescript": "^7.22.5",
  "@babel/runtime-corejs3": "^7.22.5",
  "@babel/plugin-transform-classes": "^7.22.5",
  "core-js": "^3.31.0",
  "babel-loader": "^9.1.2",
  "css-loader": "^6.8.1",
  sass: "^1.63.4",
  "sass-loader": "^13.3.2",
  "style-loader": "^3.3.3",
  vite: "^5.4.3",
  "vite-plugin-dts": "^3.6.4",
  "vite-plugin-tsconfig": "^1.0.4",
  "vite-plugin-css-injected-by-js": "^3.3.0"
}, en = {
  "@webpack-cli/serve": "^1.3.1"
}, tn = [], rn = "", sn = "ISC", nn = "", $e = {
  name: Ks,
  version: Gs,
  main: Xs,
  types: Vs,
  styles: Ys,
  scripts: Js,
  dependencies: Zs,
  devDependencies: Qs,
  resolutions: en,
  keywords: tn,
  author: rn,
  license: sn,
  description: nn
}, D = {
  mode: "production",
  locale: "ko",
  isSetLocale: !1,
  packageVersion: $e.version,
  applicationId: "",
  API_URL: {
    development: "https://dev-api.bootpay.co.kr/v2",
    stage: "https://stage-api.bootpay.co.kr/v2",
    production: "https://api.bootpay.co.kr/v2"
  },
  ANALYTICS_URL: {
    development: "https://dev-analytics.bootpay.co.kr",
    stage: "https://stage-analytics.bootpay.co.kr",
    production: "https://analytics.bootpay.co.kr"
  },
  DOOR_URL: {
    development: "https://door-dev.bootpay.co.kr",
    stage: "https://door-stage.bootpay.co.kr",
    production: "https://door.bootpay.co.kr"
  },
  WIDGET_URL: {
    development: "https://dev-widget.bootpay.co.kr",
    stage: "https://stage-widget.bootpay.co.kr",
    production: "https://widget.bootpay.co.kr"
  },
  sdkNames: {
    android: 100,
    android_react_native: 101,
    android_flutter: 102,
    android_unity: 103,
    ios: 200,
    ios_react_native: 201,
    ios_flutter: 202,
    ios_unity: 203,
    ios_objc: 204,
    ios_swift_ui: 205,
    mac_swift: 206,
    mac_flutter: 207
  },
  sdkVersion: "",
  sdkName: 0,
  set(t) {
    this.mode = t;
  },
  setApplicationId(t) {
    return this.applicationId = t, this.currentApplicationId(void 0);
  },
  setLocale(t) {
    this.locale = t, this.isSetLocale = !0;
  },
  currentApplicationId(t = void 0) {
    return t === void 0 ? this.applicationId : t;
  },
  setDevelopmentHost(t) {
    this.API_URL.development = this.API_URL.development.replace(/dev-api.bootpay.co.kr\/v2/gi, t);
  },
  setVersion(t, e, r = void 0) {
    this.sdkName = this.sdkNames[e] === void 0 ? 0 : this.sdkNames[e], this.sdkVersion = t, this.packageVersion = r === void 0 || r === "" ? $e.version : r;
  },
  toApi(t) {
    return [this.API_URL[this.mode], t].join("/");
  },
  toDoor(t) {
    return [this.DOOR_URL[this.mode], t].join("/");
  },
  toWidget(t) {
    return [this.WIDGET_URL[this.mode], t].join("/");
  },
  isMobile() {
    if (typeof window > "u") return !1;
    const t = window.navigator.userAgent || window.navigator.vendor;
    return /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/.test(t);
  },
  isMobileSafari() {
    if (typeof window > "u") return !1;
    const t = window.navigator.userAgent;
    return (t.match(/iPad/i) || t.match(/iPhone/i)) && !t.match(/CriOS/i);
  },
  toAnalytics(t) {
    return [this.ANALYTICS_URL[this.mode], t].join("/");
  }
};
class pe extends Error {
  constructor(e) {
    super(), this.name = "BootpayEventError", this.eventMessage = e;
  }
}
const Se = {
  __BOOTPAY_NAMESPACE: {},
  isBind: !1,
  initialize() {
    this.isBind || (typeof window < "u" && (window.addBootpayEventListener = this.on, window.removeBootpayEventListener = this.off, window.resetBootpayEventListener = function(t, e, r) {
      this.removeBootpayEventListener(t).addBootpayEventListener(t, e, r);
    }), typeof document < "u" && (document.addBootpayEventListener = this.on, document.removeBootpayEventListener = this.off, document.resetBootpayEventListener = function(t, e, r) {
      this.removeBootpayEventListener(t).addBootpayEventListener(t, e, r);
    }), typeof Element < "u" && (Element.prototype.addBootpayEventListener = this.on, Element.prototype.removeBootpayEventListener = this.off, Element.prototype.resetBootpayEventListener = function(t, e, r) {
      this.removeBootpayEventListener(t).addBootpayEventListener(t, e, r);
    }), this.isBind = !0);
  },
  on(t, e, r = void 0) {
    return re(Se.__BOOTPAY_NAMESPACE) && (Se.__BOOTPAY_NAMESPACE = {}), this.addEventListener(t.split(".")[0], e, r || !1), Se.__BOOTPAY_NAMESPACE[t] = e, this;
  },
  off(t) {
    return M(Se.__BOOTPAY_NAMESPACE) && M(Se.__BOOTPAY_NAMESPACE[t]) && this.removeEventListener(t.split(".")[0], Se.__BOOTPAY_NAMESPACE[t]), this;
  }
};
class ot extends Ae {
  constructor(e) {
    super(), this.$resolve = null, this.$reject = null, this.$messageEventName = (e == null ? void 0 : e.messageEventName) ?? "message.BootpayEvent", this.$eventHooks = (e == null ? void 0 : e.messageEventHooks) ?? {}, this.afterBind = e == null ? void 0 : e.afterBind, Se.initialize();
  }
  bind(e, r) {
    this.$messageEventName && window.resetBootpayEventListener(this.$messageEventName, (s) => {
      const n = this.parseEvent(s.data);
      if (F.debug("event received", JSON.stringify(n)), M(n) && M(n.event)) {
        const i = this.hookFunction(n.hook);
        if (M(i) && M(i[n.event]))
          return i[n.event](n.data, this);
        F.debug("event", `${this.$messageEventName}: ${n.event} is not defined`);
      }
    }), this.afterBind && this.afterBind(), this.setCallbackFunction(e, r);
  }
  hookFunction(e) {
    return this.$eventHooks[e];
  }
  reject(e) {
    M(this.$reject) && this.$reject(e);
  }
  resolve(e) {
    M(this.$resolve) && this.$resolve(e);
  }
  /**
   * 함수를 class instnace variables에 넣는다
   * Comment by GOSOMI
   * @date: 2021-05-11
   * @param resolve: Function
   * @param reject: Function
   */
  setCallbackFunction(e, r) {
    this.$resolve = e, this.$reject = r;
  }
  /**
   * event 데이터를 파싱한다
   * Comment by Gosomi
   * @date: 2021-02-19
   * @param data: string
   */
  parseEvent(e) {
    let r = {};
    if (this.$present(e) && this.$type(e, "string")) {
      try {
        r = JSON.parse(e);
      } catch (s) {
        F.info("json parsing failed", `data: ${e}, message: ${tt(s)} JSON 파싱 형태가 아닌 이벤트 입니다.`);
      }
      return r.bootpay_event ? (delete r.bootpay_event, r) : null;
    } else
      return null;
  }
}
const tt = (t) => typeof t == "string" ? t.toUpperCase() : t instanceof Error ? t.message : t;
class ge extends Ae {
  constructor() {
    super(), this.$windowId = "", this.$template = "";
  }
  defaultIframeHtml() {
    return `
            <iframe id="${this.$iFrameId}" src="" frameborder="0" allowtransparency="true" scrolling="no" style="background: transparent; width: 100%; height: 100%;"></iframe>            
        `;
  }
  byId(e) {
    return document.getElementById(e);
  }
  /**
   * Template body append
   * Comment by GOSOMI
   * @date: 2022-02-16
   */
  createTemplateHtml() {
    this.byId(this.$windowId) === null && document.body.insertAdjacentHTML("beforeend", this.$template);
  }
  bodyOpen(e = void 0) {
    const r = document.querySelector("body");
    this.$present(r.className) ? r.className = `${r.className} bootpay-open` : r.className = "bootpay-open", this.$present(e) && (r.className = `${r.className} ${e}`);
  }
  bodyClose() {
    const e = document.querySelector("body");
    e.className = e.className.replace("bootpay-open", "");
  }
  templateResize(e, r) {
    const s = this.byId(e);
    if (s !== void 0)
      for (let n in Object.keys(r)) {
        let i = Object.keys(r)[n], x = r[i];
        this.$present(x) && !String(x).match(/%/) && !String(x).match(/vh/) && (i.match(/width/) || i.match(/Width/) || i.match(/height/) || i.match(/Height/)) && (x = `${String(r[i]).replace(/px/gi, "")}px`), s.style.setProperty(i, x);
      }
  }
  /**
   * render가 되었는지 체크한다
   * Comment by GOSOMI
   * @date: 2024-02-22
   */
  isRendered() {
    const e = document.getElementById(this.$iFrameId);
    return F.debug("isRendered", `iFrameElement: ${e}`), e !== null && e.src !== null && e.src !== "";
  }
  /**
   * child iframe에 PostMessage를 보낸다
   * Comment by GOSOMI
   * @date: 2023-06-15
   */
  postMessage(e, r = void 0) {
    var n;
    const s = this.byId(this.$iFrameId);
    (n = s == null ? void 0 : s.contentWindow) == null || n.postMessage(JSON.stringify({
      bootpay_event: !0,
      event: e,
      data: r
    }), "*");
  }
}
class on extends ge {
  constructor() {
    super(), this.$alfredId = "bootpay-alfred-progress-id", this.$alfredTextId = "__alfred-text-message__";
  }
  /**
   * Template 파일
   * Comment by GOSOMI
   * @date: 2021-04-13
   * @param message: string
   * @returns void
   */
  template(e) {
    return `
<div class="bootpay-progress-background" id="${this.$alfredId}" style="display: none;">
<div class="progress-message-window">
    <div class="alfred-loading">
      <div class="bootpay-spinner"></div>                  
    </div>
    <div class="alfred-text">
      <span class="alfred-inner-text" id="${this.$alfredTextId}">${e}</span>
    </div>
</div>    
</div>
    `;
  }
  /**
   * Progress 창을 보여준다
   * Comment by GOSOMI
   * @date: 2021-04-13
   * @param message: String
   * @returns void
   */
  showProgress(e) {
    this.$present(this.byId(this.$alfredId)) ? this.byId(this.$alfredTextId).innerText = e : document.body.insertAdjacentHTML("beforeend", this.template(e)), this.byId(this.$alfredId).style.setProperty("display", "block");
  }
  /**
   * Progress 창을 닫는다
   * Comment by GOSOMI
   * @date: 2021-04-13
   */
  hideProgress() {
    try {
      this.byId(this.$alfredId).outerHTML = "";
    } catch {
    }
  }
}
const he = new on();
var $r = { exports: {} }, Q0 = function(e, r) {
  return function() {
    for (var n = new Array(arguments.length), i = 0; i < n.length; i++)
      n[i] = arguments[i];
    return e.apply(r, n);
  };
}, an = Q0, Er = Object.prototype.toString, kr = /* @__PURE__ */ function(t) {
  return function(e) {
    var r = Er.call(e);
    return t[r] || (t[r] = r.slice(8, -1).toLowerCase());
  };
}(/* @__PURE__ */ Object.create(null));
function Oe(t) {
  return t = t.toLowerCase(), function(r) {
    return kr(r) === t;
  };
}
function Sr(t) {
  return Array.isArray(t);
}
function pt(t) {
  return typeof t > "u";
}
function cn(t) {
  return t !== null && !pt(t) && t.constructor !== null && !pt(t.constructor) && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
}
var es = Oe("ArrayBuffer");
function dn(t) {
  var e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && es(t.buffer), e;
}
function ln(t) {
  return typeof t == "string";
}
function un(t) {
  return typeof t == "number";
}
function ts(t) {
  return t !== null && typeof t == "object";
}
function lt(t) {
  if (kr(t) !== "object")
    return !1;
  var e = Object.getPrototypeOf(t);
  return e === null || e === Object.prototype;
}
var pn = Oe("Date"), hn = Oe("File"), fn = Oe("Blob"), xn = Oe("FileList");
function Br(t) {
  return Er.call(t) === "[object Function]";
}
function vn(t) {
  return ts(t) && Br(t.pipe);
}
function yn(t) {
  var e = "[object FormData]";
  return t && (typeof FormData == "function" && t instanceof FormData || Er.call(t) === e || Br(t.toString) && t.toString() === e);
}
var mn = Oe("URLSearchParams");
function gn(t) {
  return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
}
function bn() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function Pr(t, e) {
  if (!(t === null || typeof t > "u"))
    if (typeof t != "object" && (t = [t]), Sr(t))
      for (var r = 0, s = t.length; r < s; r++)
        e.call(null, t[r], r, t);
    else
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && e.call(null, t[n], n, t);
}
function gr() {
  var t = {};
  function e(n, i) {
    lt(t[i]) && lt(n) ? t[i] = gr(t[i], n) : lt(n) ? t[i] = gr({}, n) : Sr(n) ? t[i] = n.slice() : t[i] = n;
  }
  for (var r = 0, s = arguments.length; r < s; r++)
    Pr(arguments[r], e);
  return t;
}
function _n(t, e, r) {
  return Pr(e, function(n, i) {
    r && typeof n == "function" ? t[i] = an(n, r) : t[i] = n;
  }), t;
}
function wn(t) {
  return t.charCodeAt(0) === 65279 && (t = t.slice(1)), t;
}
function $n(t, e, r, s) {
  t.prototype = Object.create(e.prototype, s), t.prototype.constructor = t, r && Object.assign(t.prototype, r);
}
function En(t, e, r) {
  var s, n, i, x = {};
  e = e || {};
  do {
    for (s = Object.getOwnPropertyNames(t), n = s.length; n-- > 0; )
      i = s[n], x[i] || (e[i] = t[i], x[i] = !0);
    t = Object.getPrototypeOf(t);
  } while (t && (!r || r(t, e)) && t !== Object.prototype);
  return e;
}
function kn(t, e, r) {
  t = String(t), (r === void 0 || r > t.length) && (r = t.length), r -= e.length;
  var s = t.indexOf(e, r);
  return s !== -1 && s === r;
}
function Sn(t) {
  if (!t) return null;
  var e = t.length;
  if (pt(e)) return null;
  for (var r = new Array(e); e-- > 0; )
    r[e] = t[e];
  return r;
}
var Bn = /* @__PURE__ */ function(t) {
  return function(e) {
    return t && e instanceof t;
  };
}(typeof Uint8Array < "u" && Object.getPrototypeOf(Uint8Array)), Q = {
  isArray: Sr,
  isArrayBuffer: es,
  isBuffer: cn,
  isFormData: yn,
  isArrayBufferView: dn,
  isString: ln,
  isNumber: un,
  isObject: ts,
  isPlainObject: lt,
  isUndefined: pt,
  isDate: pn,
  isFile: hn,
  isBlob: fn,
  isFunction: Br,
  isStream: vn,
  isURLSearchParams: mn,
  isStandardBrowserEnv: bn,
  forEach: Pr,
  merge: gr,
  extend: _n,
  trim: gn,
  stripBOM: wn,
  inherits: $n,
  toFlatObject: En,
  kindOf: kr,
  kindOfTest: Oe,
  endsWith: kn,
  toArray: Sn,
  isTypedArray: Bn,
  isFileList: xn
}, Ne = Q;
function Yr(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var rs = function(e, r, s) {
  if (!r)
    return e;
  var n;
  if (s)
    n = s(r);
  else if (Ne.isURLSearchParams(r))
    n = r.toString();
  else {
    var i = [];
    Ne.forEach(r, function(p, a) {
      p === null || typeof p > "u" || (Ne.isArray(p) ? a = a + "[]" : p = [p], Ne.forEach(p, function(y) {
        Ne.isDate(y) ? y = y.toISOString() : Ne.isObject(y) && (y = JSON.stringify(y)), i.push(Yr(a) + "=" + Yr(y));
      }));
    }), n = i.join("&");
  }
  if (n) {
    var x = e.indexOf("#");
    x !== -1 && (e = e.slice(0, x)), e += (e.indexOf("?") === -1 ? "?" : "&") + n;
  }
  return e;
}, Pn = Q;
function xt() {
  this.handlers = [];
}
xt.prototype.use = function(e, r, s) {
  return this.handlers.push({
    fulfilled: e,
    rejected: r,
    synchronous: s ? s.synchronous : !1,
    runWhen: s ? s.runWhen : null
  }), this.handlers.length - 1;
};
xt.prototype.eject = function(e) {
  this.handlers[e] && (this.handlers[e] = null);
};
xt.prototype.forEach = function(e) {
  Pn.forEach(this.handlers, function(s) {
    s !== null && e(s);
  });
};
var In = xt, Cn = Q, Tn = function(e, r) {
  Cn.forEach(e, function(n, i) {
    i !== r && i.toUpperCase() === r.toUpperCase() && (e[r] = n, delete e[i]);
  });
}, ss = Q;
function qe(t, e, r, s, n) {
  Error.call(this), this.message = t, this.name = "AxiosError", e && (this.code = e), r && (this.config = r), s && (this.request = s), n && (this.response = n);
}
ss.inherits(qe, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
var ns = qe.prototype, is = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED"
  // eslint-disable-next-line func-names
].forEach(function(t) {
  is[t] = { value: t };
});
Object.defineProperties(qe, is);
Object.defineProperty(ns, "isAxiosError", { value: !0 });
qe.from = function(t, e, r, s, n, i) {
  var x = Object.create(ns);
  return ss.toFlatObject(t, x, function(p) {
    return p !== Error.prototype;
  }), qe.call(x, t.message, e, r, s, n), x.name = t.name, i && Object.assign(x, i), x;
};
var je = qe, os = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, ve = Q;
function Rn(t, e) {
  e = e || new FormData();
  var r = [];
  function s(i) {
    return i === null ? "" : ve.isDate(i) ? i.toISOString() : ve.isArrayBuffer(i) || ve.isTypedArray(i) ? typeof Blob == "function" ? new Blob([i]) : Buffer.from(i) : i;
  }
  function n(i, x) {
    if (ve.isPlainObject(i) || ve.isArray(i)) {
      if (r.indexOf(i) !== -1)
        throw Error("Circular reference detected in " + x);
      r.push(i), ve.forEach(i, function(p, a) {
        if (!ve.isUndefined(p)) {
          var c = x ? x + "." + a : a, y;
          if (p && !x && typeof p == "object") {
            if (ve.endsWith(a, "{}"))
              p = JSON.stringify(p);
            else if (ve.endsWith(a, "[]") && (y = ve.toArray(p))) {
              y.forEach(function(o) {
                !ve.isUndefined(o) && e.append(c, s(o));
              });
              return;
            }
          }
          n(p, c);
        }
      }), r.pop();
    } else
      e.append(x, s(i));
  }
  return n(t), e;
}
var as = Rn, kt, Jr;
function An() {
  if (Jr) return kt;
  Jr = 1;
  var t = je;
  return kt = function(r, s, n) {
    var i = n.config.validateStatus;
    !n.status || !i || i(n.status) ? r(n) : s(new t(
      "Request failed with status code " + n.status,
      [t.ERR_BAD_REQUEST, t.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
      n.config,
      n.request,
      n
    ));
  }, kt;
}
var St, Zr;
function On() {
  if (Zr) return St;
  Zr = 1;
  var t = Q;
  return St = t.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    /* @__PURE__ */ function() {
      return {
        write: function(s, n, i, x, d, p) {
          var a = [];
          a.push(s + "=" + encodeURIComponent(n)), t.isNumber(i) && a.push("expires=" + new Date(i).toGMTString()), t.isString(x) && a.push("path=" + x), t.isString(d) && a.push("domain=" + d), p === !0 && a.push("secure"), document.cookie = a.join("; ");
        },
        read: function(s) {
          var n = document.cookie.match(new RegExp("(^|;\\s*)(" + s + ")=([^;]*)"));
          return n ? decodeURIComponent(n[3]) : null;
        },
        remove: function(s) {
          this.write(s, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), St;
}
var Un = function(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}, Dn = function(e, r) {
  return r ? e.replace(/\/+$/, "") + "/" + r.replace(/^\/+/, "") : e;
}, Fn = Un, Hn = Dn, cs = function(e, r) {
  return e && !Fn(r) ? Hn(e, r) : r;
}, Bt, Qr;
function Mn() {
  if (Qr) return Bt;
  Qr = 1;
  var t = Q, e = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return Bt = function(s) {
    var n = {}, i, x, d;
    return s && t.forEach(s.split(`
`), function(a) {
      if (d = a.indexOf(":"), i = t.trim(a.substr(0, d)).toLowerCase(), x = t.trim(a.substr(d + 1)), i) {
        if (n[i] && e.indexOf(i) >= 0)
          return;
        i === "set-cookie" ? n[i] = (n[i] ? n[i] : []).concat([x]) : n[i] = n[i] ? n[i] + ", " + x : x;
      }
    }), n;
  }, Bt;
}
var Pt, e0;
function Nn() {
  if (e0) return Pt;
  e0 = 1;
  var t = Q;
  return Pt = t.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var r = /(msie|trident)/i.test(navigator.userAgent), s = document.createElement("a"), n;
      function i(x) {
        var d = x;
        return r && (s.setAttribute("href", d), d = s.href), s.setAttribute("href", d), {
          href: s.href,
          protocol: s.protocol ? s.protocol.replace(/:$/, "") : "",
          host: s.host,
          search: s.search ? s.search.replace(/^\?/, "") : "",
          hash: s.hash ? s.hash.replace(/^#/, "") : "",
          hostname: s.hostname,
          port: s.port,
          pathname: s.pathname.charAt(0) === "/" ? s.pathname : "/" + s.pathname
        };
      }
      return n = i(window.location.href), function(d) {
        var p = t.isString(d) ? i(d) : d;
        return p.protocol === n.protocol && p.host === n.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return function() {
        return !0;
      };
    }()
  ), Pt;
}
var It, t0;
function vt() {
  if (t0) return It;
  t0 = 1;
  var t = je, e = Q;
  function r(s) {
    t.call(this, s ?? "canceled", t.ERR_CANCELED), this.name = "CanceledError";
  }
  return e.inherits(r, t, {
    __CANCEL__: !0
  }), It = r, It;
}
var Ct, r0;
function Ln() {
  return r0 || (r0 = 1, Ct = function(e) {
    var r = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
    return r && r[1] || "";
  }), Ct;
}
var Tt, s0;
function n0() {
  if (s0) return Tt;
  s0 = 1;
  var t = Q, e = An(), r = On(), s = rs, n = cs, i = Mn(), x = Nn(), d = os, p = je, a = vt(), c = Ln();
  return Tt = function(o) {
    return new Promise(function(h, v) {
      var g = o.data, $ = o.headers, l = o.responseType, f;
      function m() {
        o.cancelToken && o.cancelToken.unsubscribe(f), o.signal && o.signal.removeEventListener("abort", f);
      }
      t.isFormData(g) && t.isStandardBrowserEnv() && delete $["Content-Type"];
      var b = new XMLHttpRequest();
      if (o.auth) {
        var E = o.auth.username || "", k = o.auth.password ? unescape(encodeURIComponent(o.auth.password)) : "";
        $.Authorization = "Basic " + btoa(E + ":" + k);
      }
      var S = n(o.baseURL, o.url);
      b.open(o.method.toUpperCase(), s(S, o.params, o.paramsSerializer), !0), b.timeout = o.timeout;
      function A() {
        if (b) {
          var B = "getAllResponseHeaders" in b ? i(b.getAllResponseHeaders()) : null, I = !l || l === "text" || l === "json" ? b.responseText : b.response, O = {
            data: I,
            status: b.status,
            statusText: b.statusText,
            headers: B,
            config: o,
            request: b
          };
          e(function(H) {
            h(H), m();
          }, function(H) {
            v(H), m();
          }, O), b = null;
        }
      }
      if ("onloadend" in b ? b.onloadend = A : b.onreadystatechange = function() {
        !b || b.readyState !== 4 || b.status === 0 && !(b.responseURL && b.responseURL.indexOf("file:") === 0) || setTimeout(A);
      }, b.onabort = function() {
        b && (v(new p("Request aborted", p.ECONNABORTED, o, b)), b = null);
      }, b.onerror = function() {
        v(new p("Network Error", p.ERR_NETWORK, o, b, b)), b = null;
      }, b.ontimeout = function() {
        var I = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded", O = o.transitional || d;
        o.timeoutErrorMessage && (I = o.timeoutErrorMessage), v(new p(
          I,
          O.clarifyTimeoutError ? p.ETIMEDOUT : p.ECONNABORTED,
          o,
          b
        )), b = null;
      }, t.isStandardBrowserEnv()) {
        var _ = (o.withCredentials || x(S)) && o.xsrfCookieName ? r.read(o.xsrfCookieName) : void 0;
        _ && ($[o.xsrfHeaderName] = _);
      }
      "setRequestHeader" in b && t.forEach($, function(I, O) {
        typeof g > "u" && O.toLowerCase() === "content-type" ? delete $[O] : b.setRequestHeader(O, I);
      }), t.isUndefined(o.withCredentials) || (b.withCredentials = !!o.withCredentials), l && l !== "json" && (b.responseType = o.responseType), typeof o.onDownloadProgress == "function" && b.addEventListener("progress", o.onDownloadProgress), typeof o.onUploadProgress == "function" && b.upload && b.upload.addEventListener("progress", o.onUploadProgress), (o.cancelToken || o.signal) && (f = function(B) {
        b && (v(!B || B && B.type ? new a() : B), b.abort(), b = null);
      }, o.cancelToken && o.cancelToken.subscribe(f), o.signal && (o.signal.aborted ? f() : o.signal.addEventListener("abort", f))), g || (g = null);
      var w = c(S);
      if (w && ["http", "https", "file"].indexOf(w) === -1) {
        v(new p("Unsupported protocol " + w + ":", p.ERR_BAD_REQUEST, o));
        return;
      }
      b.send(g);
    });
  }, Tt;
}
var Rt, i0;
function qn() {
  return i0 || (i0 = 1, Rt = null), Rt;
}
var Z = Q, o0 = Tn, a0 = je, Wn = os, zn = as, jn = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function c0(t, e) {
  !Z.isUndefined(t) && Z.isUndefined(t["Content-Type"]) && (t["Content-Type"] = e);
}
function Kn() {
  var t;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (t = n0()), t;
}
function Gn(t, e, r) {
  if (Z.isString(t))
    try {
      return (e || JSON.parse)(t), Z.trim(t);
    } catch (s) {
      if (s.name !== "SyntaxError")
        throw s;
    }
  return (0, JSON.stringify)(t);
}
var yt = {
  transitional: Wn,
  adapter: Kn(),
  transformRequest: [function(e, r) {
    if (o0(r, "Accept"), o0(r, "Content-Type"), Z.isFormData(e) || Z.isArrayBuffer(e) || Z.isBuffer(e) || Z.isStream(e) || Z.isFile(e) || Z.isBlob(e))
      return e;
    if (Z.isArrayBufferView(e))
      return e.buffer;
    if (Z.isURLSearchParams(e))
      return c0(r, "application/x-www-form-urlencoded;charset=utf-8"), e.toString();
    var s = Z.isObject(e), n = r && r["Content-Type"], i;
    if ((i = Z.isFileList(e)) || s && n === "multipart/form-data") {
      var x = this.env && this.env.FormData;
      return zn(i ? { "files[]": e } : e, x && new x());
    } else if (s || n === "application/json")
      return c0(r, "application/json"), Gn(e);
    return e;
  }],
  transformResponse: [function(e) {
    var r = this.transitional || yt.transitional, s = r && r.silentJSONParsing, n = r && r.forcedJSONParsing, i = !s && this.responseType === "json";
    if (i || n && Z.isString(e) && e.length)
      try {
        return JSON.parse(e);
      } catch (x) {
        if (i)
          throw x.name === "SyntaxError" ? a0.from(x, a0.ERR_BAD_RESPONSE, this, null, this.response) : x;
      }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: qn()
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
Z.forEach(["delete", "get", "head"], function(e) {
  yt.headers[e] = {};
});
Z.forEach(["post", "put", "patch"], function(e) {
  yt.headers[e] = Z.merge(jn);
});
var Ir = yt, Xn = Q, Vn = Ir, Yn = function(e, r, s) {
  var n = this || Vn;
  return Xn.forEach(s, function(x) {
    e = x.call(n, e, r);
  }), e;
}, At, d0;
function ds() {
  return d0 || (d0 = 1, At = function(e) {
    return !!(e && e.__CANCEL__);
  }), At;
}
var l0 = Q, Ot = Yn, Jn = ds(), Zn = Ir, Qn = vt();
function Ut(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new Qn();
}
var ei = function(e) {
  Ut(e), e.headers = e.headers || {}, e.data = Ot.call(
    e,
    e.data,
    e.headers,
    e.transformRequest
  ), e.headers = l0.merge(
    e.headers.common || {},
    e.headers[e.method] || {},
    e.headers
  ), l0.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(n) {
      delete e.headers[n];
    }
  );
  var r = e.adapter || Zn.adapter;
  return r(e).then(function(n) {
    return Ut(e), n.data = Ot.call(
      e,
      n.data,
      n.headers,
      e.transformResponse
    ), n;
  }, function(n) {
    return Jn(n) || (Ut(e), n && n.response && (n.response.data = Ot.call(
      e,
      n.response.data,
      n.response.headers,
      e.transformResponse
    ))), Promise.reject(n);
  });
}, le = Q, ls = function(e, r) {
  r = r || {};
  var s = {};
  function n(c, y) {
    return le.isPlainObject(c) && le.isPlainObject(y) ? le.merge(c, y) : le.isPlainObject(y) ? le.merge({}, y) : le.isArray(y) ? y.slice() : y;
  }
  function i(c) {
    if (le.isUndefined(r[c])) {
      if (!le.isUndefined(e[c]))
        return n(void 0, e[c]);
    } else return n(e[c], r[c]);
  }
  function x(c) {
    if (!le.isUndefined(r[c]))
      return n(void 0, r[c]);
  }
  function d(c) {
    if (le.isUndefined(r[c])) {
      if (!le.isUndefined(e[c]))
        return n(void 0, e[c]);
    } else return n(void 0, r[c]);
  }
  function p(c) {
    if (c in r)
      return n(e[c], r[c]);
    if (c in e)
      return n(void 0, e[c]);
  }
  var a = {
    url: x,
    method: x,
    data: x,
    baseURL: d,
    transformRequest: d,
    transformResponse: d,
    paramsSerializer: d,
    timeout: d,
    timeoutMessage: d,
    withCredentials: d,
    adapter: d,
    responseType: d,
    xsrfCookieName: d,
    xsrfHeaderName: d,
    onUploadProgress: d,
    onDownloadProgress: d,
    decompress: d,
    maxContentLength: d,
    maxBodyLength: d,
    beforeRedirect: d,
    transport: d,
    httpAgent: d,
    httpsAgent: d,
    cancelToken: d,
    socketPath: d,
    responseEncoding: d,
    validateStatus: p
  };
  return le.forEach(Object.keys(e).concat(Object.keys(r)), function(y) {
    var o = a[y] || i, u = o(y);
    le.isUndefined(u) && o !== p || (s[y] = u);
  }), s;
}, Dt, u0;
function us() {
  return u0 || (u0 = 1, Dt = {
    version: "0.27.2"
  }), Dt;
}
var ti = us().version, we = je, Cr = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(t, e) {
  Cr[t] = function(s) {
    return typeof s === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
var p0 = {};
Cr.transitional = function(e, r, s) {
  function n(i, x) {
    return "[Axios v" + ti + "] Transitional option '" + i + "'" + x + (s ? ". " + s : "");
  }
  return function(i, x, d) {
    if (e === !1)
      throw new we(
        n(x, " has been removed" + (r ? " in " + r : "")),
        we.ERR_DEPRECATED
      );
    return r && !p0[x] && (p0[x] = !0, console.warn(
      n(
        x,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), e ? e(i, x, d) : !0;
  };
};
function ri(t, e, r) {
  if (typeof t != "object")
    throw new we("options must be an object", we.ERR_BAD_OPTION_VALUE);
  for (var s = Object.keys(t), n = s.length; n-- > 0; ) {
    var i = s[n], x = e[i];
    if (x) {
      var d = t[i], p = d === void 0 || x(d, i, t);
      if (p !== !0)
        throw new we("option " + i + " must be " + p, we.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new we("Unknown option " + i, we.ERR_BAD_OPTION);
  }
}
var si = {
  assertOptions: ri,
  validators: Cr
}, ps = Q, ni = rs, h0 = In, f0 = ei, mt = ls, ii = cs, hs = si, Le = hs.validators;
function We(t) {
  this.defaults = t, this.interceptors = {
    request: new h0(),
    response: new h0()
  };
}
We.prototype.request = function(e, r) {
  typeof e == "string" ? (r = r || {}, r.url = e) : r = e || {}, r = mt(this.defaults, r), r.method ? r.method = r.method.toLowerCase() : this.defaults.method ? r.method = this.defaults.method.toLowerCase() : r.method = "get";
  var s = r.transitional;
  s !== void 0 && hs.assertOptions(s, {
    silentJSONParsing: Le.transitional(Le.boolean),
    forcedJSONParsing: Le.transitional(Le.boolean),
    clarifyTimeoutError: Le.transitional(Le.boolean)
  }, !1);
  var n = [], i = !0;
  this.interceptors.request.forEach(function(u) {
    typeof u.runWhen == "function" && u.runWhen(r) === !1 || (i = i && u.synchronous, n.unshift(u.fulfilled, u.rejected));
  });
  var x = [];
  this.interceptors.response.forEach(function(u) {
    x.push(u.fulfilled, u.rejected);
  });
  var d;
  if (!i) {
    var p = [f0, void 0];
    for (Array.prototype.unshift.apply(p, n), p = p.concat(x), d = Promise.resolve(r); p.length; )
      d = d.then(p.shift(), p.shift());
    return d;
  }
  for (var a = r; n.length; ) {
    var c = n.shift(), y = n.shift();
    try {
      a = c(a);
    } catch (o) {
      y(o);
      break;
    }
  }
  try {
    d = f0(a);
  } catch (o) {
    return Promise.reject(o);
  }
  for (; x.length; )
    d = d.then(x.shift(), x.shift());
  return d;
};
We.prototype.getUri = function(e) {
  e = mt(this.defaults, e);
  var r = ii(e.baseURL, e.url);
  return ni(r, e.params, e.paramsSerializer);
};
ps.forEach(["delete", "get", "head", "options"], function(e) {
  We.prototype[e] = function(r, s) {
    return this.request(mt(s || {}, {
      method: e,
      url: r,
      data: (s || {}).data
    }));
  };
});
ps.forEach(["post", "put", "patch"], function(e) {
  function r(s) {
    return function(i, x, d) {
      return this.request(mt(d || {}, {
        method: e,
        headers: s ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: x
      }));
    };
  }
  We.prototype[e] = r(), We.prototype[e + "Form"] = r(!0);
});
var oi = We, Ft, x0;
function ai() {
  if (x0) return Ft;
  x0 = 1;
  var t = vt();
  function e(r) {
    if (typeof r != "function")
      throw new TypeError("executor must be a function.");
    var s;
    this.promise = new Promise(function(x) {
      s = x;
    });
    var n = this;
    this.promise.then(function(i) {
      if (n._listeners) {
        var x, d = n._listeners.length;
        for (x = 0; x < d; x++)
          n._listeners[x](i);
        n._listeners = null;
      }
    }), this.promise.then = function(i) {
      var x, d = new Promise(function(p) {
        n.subscribe(p), x = p;
      }).then(i);
      return d.cancel = function() {
        n.unsubscribe(x);
      }, d;
    }, r(function(x) {
      n.reason || (n.reason = new t(x), s(n.reason));
    });
  }
  return e.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, e.prototype.subscribe = function(s) {
    if (this.reason) {
      s(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(s) : this._listeners = [s];
  }, e.prototype.unsubscribe = function(s) {
    if (this._listeners) {
      var n = this._listeners.indexOf(s);
      n !== -1 && this._listeners.splice(n, 1);
    }
  }, e.source = function() {
    var s, n = new e(function(x) {
      s = x;
    });
    return {
      token: n,
      cancel: s
    };
  }, Ft = e, Ft;
}
var Ht, v0;
function ci() {
  return v0 || (v0 = 1, Ht = function(e) {
    return function(s) {
      return e.apply(null, s);
    };
  }), Ht;
}
var Mt, y0;
function di() {
  if (y0) return Mt;
  y0 = 1;
  var t = Q;
  return Mt = function(r) {
    return t.isObject(r) && r.isAxiosError === !0;
  }, Mt;
}
var m0 = Q, li = Q0, ut = oi, ui = ls, pi = Ir;
function fs(t) {
  var e = new ut(t), r = li(ut.prototype.request, e);
  return m0.extend(r, ut.prototype, e), m0.extend(r, e), r.create = function(n) {
    return fs(ui(t, n));
  }, r;
}
var ae = fs(pi);
ae.Axios = ut;
ae.CanceledError = vt();
ae.CancelToken = ai();
ae.isCancel = ds();
ae.VERSION = us().version;
ae.toFormData = as;
ae.AxiosError = je;
ae.Cancel = ae.CanceledError;
ae.all = function(e) {
  return Promise.all(e);
};
ae.spread = ci();
ae.isAxiosError = di();
$r.exports = ae;
$r.exports.default = ae;
var hi = $r.exports, fi = hi;
const et = /* @__PURE__ */ ze(fi);
var Nt = { exports: {} }, Lt = { exports: {} }, g0;
function Ue() {
  return g0 || (g0 = 1, function(t, e) {
    (function(r, s) {
      t.exports = s(W());
    })(N, function(r) {
      return function(s) {
        var n = r, i = n.lib, x = i.WordArray, d = i.Hasher, p = n.algo, a = [];
        (function() {
          for (var v = 0; v < 64; v++)
            a[v] = s.abs(s.sin(v + 1)) * 4294967296 | 0;
        })();
        var c = p.MD5 = d.extend({
          _doReset: function() {
            this._hash = new x.init([
              1732584193,
              4023233417,
              2562383102,
              271733878
            ]);
          },
          _doProcessBlock: function(v, g) {
            for (var $ = 0; $ < 16; $++) {
              var l = g + $, f = v[l];
              v[l] = (f << 8 | f >>> 24) & 16711935 | (f << 24 | f >>> 8) & 4278255360;
            }
            var m = this._hash.words, b = v[g + 0], E = v[g + 1], k = v[g + 2], S = v[g + 3], A = v[g + 4], _ = v[g + 5], w = v[g + 6], B = v[g + 7], I = v[g + 8], O = v[g + 9], U = v[g + 10], H = v[g + 11], Y = v[g + 12], j = v[g + 13], X = v[g + 14], K = v[g + 15], P = m[0], T = m[1], R = m[2], C = m[3];
            P = y(P, T, R, C, b, 7, a[0]), C = y(C, P, T, R, E, 12, a[1]), R = y(R, C, P, T, k, 17, a[2]), T = y(T, R, C, P, S, 22, a[3]), P = y(P, T, R, C, A, 7, a[4]), C = y(C, P, T, R, _, 12, a[5]), R = y(R, C, P, T, w, 17, a[6]), T = y(T, R, C, P, B, 22, a[7]), P = y(P, T, R, C, I, 7, a[8]), C = y(C, P, T, R, O, 12, a[9]), R = y(R, C, P, T, U, 17, a[10]), T = y(T, R, C, P, H, 22, a[11]), P = y(P, T, R, C, Y, 7, a[12]), C = y(C, P, T, R, j, 12, a[13]), R = y(R, C, P, T, X, 17, a[14]), T = y(T, R, C, P, K, 22, a[15]), P = o(P, T, R, C, E, 5, a[16]), C = o(C, P, T, R, w, 9, a[17]), R = o(R, C, P, T, H, 14, a[18]), T = o(T, R, C, P, b, 20, a[19]), P = o(P, T, R, C, _, 5, a[20]), C = o(C, P, T, R, U, 9, a[21]), R = o(R, C, P, T, K, 14, a[22]), T = o(T, R, C, P, A, 20, a[23]), P = o(P, T, R, C, O, 5, a[24]), C = o(C, P, T, R, X, 9, a[25]), R = o(R, C, P, T, S, 14, a[26]), T = o(T, R, C, P, I, 20, a[27]), P = o(P, T, R, C, j, 5, a[28]), C = o(C, P, T, R, k, 9, a[29]), R = o(R, C, P, T, B, 14, a[30]), T = o(T, R, C, P, Y, 20, a[31]), P = u(P, T, R, C, _, 4, a[32]), C = u(C, P, T, R, I, 11, a[33]), R = u(R, C, P, T, H, 16, a[34]), T = u(T, R, C, P, X, 23, a[35]), P = u(P, T, R, C, E, 4, a[36]), C = u(C, P, T, R, A, 11, a[37]), R = u(R, C, P, T, B, 16, a[38]), T = u(T, R, C, P, U, 23, a[39]), P = u(P, T, R, C, j, 4, a[40]), C = u(C, P, T, R, b, 11, a[41]), R = u(R, C, P, T, S, 16, a[42]), T = u(T, R, C, P, w, 23, a[43]), P = u(P, T, R, C, O, 4, a[44]), C = u(C, P, T, R, Y, 11, a[45]), R = u(R, C, P, T, K, 16, a[46]), T = u(T, R, C, P, k, 23, a[47]), P = h(P, T, R, C, b, 6, a[48]), C = h(C, P, T, R, B, 10, a[49]), R = h(R, C, P, T, X, 15, a[50]), T = h(T, R, C, P, _, 21, a[51]), P = h(P, T, R, C, Y, 6, a[52]), C = h(C, P, T, R, S, 10, a[53]), R = h(R, C, P, T, U, 15, a[54]), T = h(T, R, C, P, E, 21, a[55]), P = h(P, T, R, C, I, 6, a[56]), C = h(C, P, T, R, K, 10, a[57]), R = h(R, C, P, T, w, 15, a[58]), T = h(T, R, C, P, j, 21, a[59]), P = h(P, T, R, C, A, 6, a[60]), C = h(C, P, T, R, H, 10, a[61]), R = h(R, C, P, T, k, 15, a[62]), T = h(T, R, C, P, O, 21, a[63]), m[0] = m[0] + P | 0, m[1] = m[1] + T | 0, m[2] = m[2] + R | 0, m[3] = m[3] + C | 0;
          },
          _doFinalize: function() {
            var v = this._data, g = v.words, $ = this._nDataBytes * 8, l = v.sigBytes * 8;
            g[l >>> 5] |= 128 << 24 - l % 32;
            var f = s.floor($ / 4294967296), m = $;
            g[(l + 64 >>> 9 << 4) + 15] = (f << 8 | f >>> 24) & 16711935 | (f << 24 | f >>> 8) & 4278255360, g[(l + 64 >>> 9 << 4) + 14] = (m << 8 | m >>> 24) & 16711935 | (m << 24 | m >>> 8) & 4278255360, v.sigBytes = (g.length + 1) * 4, this._process();
            for (var b = this._hash, E = b.words, k = 0; k < 4; k++) {
              var S = E[k];
              E[k] = (S << 8 | S >>> 24) & 16711935 | (S << 24 | S >>> 8) & 4278255360;
            }
            return b;
          },
          clone: function() {
            var v = d.clone.call(this);
            return v._hash = this._hash.clone(), v;
          }
        });
        function y(v, g, $, l, f, m, b) {
          var E = v + (g & $ | ~g & l) + f + b;
          return (E << m | E >>> 32 - m) + g;
        }
        function o(v, g, $, l, f, m, b) {
          var E = v + (g & l | $ & ~l) + f + b;
          return (E << m | E >>> 32 - m) + g;
        }
        function u(v, g, $, l, f, m, b) {
          var E = v + (g ^ $ ^ l) + f + b;
          return (E << m | E >>> 32 - m) + g;
        }
        function h(v, g, $, l, f, m, b) {
          var E = v + ($ ^ (g | ~l)) + f + b;
          return (E << m | E >>> 32 - m) + g;
        }
        n.MD5 = d._createHelper(c), n.HmacMD5 = d._createHmacHelper(c);
      }(Math), r.MD5;
    });
  }(Lt)), Lt.exports;
}
var qt = { exports: {} }, Wt = { exports: {} }, b0;
function Tr() {
  return b0 || (b0 = 1, function(t, e) {
    (function(r, s) {
      t.exports = s(W());
    })(N, function(r) {
      return function() {
        var s = r, n = s.lib, i = n.WordArray, x = n.Hasher, d = s.algo, p = [], a = d.SHA1 = x.extend({
          _doReset: function() {
            this._hash = new i.init([
              1732584193,
              4023233417,
              2562383102,
              271733878,
              3285377520
            ]);
          },
          _doProcessBlock: function(c, y) {
            for (var o = this._hash.words, u = o[0], h = o[1], v = o[2], g = o[3], $ = o[4], l = 0; l < 80; l++) {
              if (l < 16)
                p[l] = c[y + l] | 0;
              else {
                var f = p[l - 3] ^ p[l - 8] ^ p[l - 14] ^ p[l - 16];
                p[l] = f << 1 | f >>> 31;
              }
              var m = (u << 5 | u >>> 27) + $ + p[l];
              l < 20 ? m += (h & v | ~h & g) + 1518500249 : l < 40 ? m += (h ^ v ^ g) + 1859775393 : l < 60 ? m += (h & v | h & g | v & g) - 1894007588 : m += (h ^ v ^ g) - 899497514, $ = g, g = v, v = h << 30 | h >>> 2, h = u, u = m;
            }
            o[0] = o[0] + u | 0, o[1] = o[1] + h | 0, o[2] = o[2] + v | 0, o[3] = o[3] + g | 0, o[4] = o[4] + $ | 0;
          },
          _doFinalize: function() {
            var c = this._data, y = c.words, o = this._nDataBytes * 8, u = c.sigBytes * 8;
            return y[u >>> 5] |= 128 << 24 - u % 32, y[(u + 64 >>> 9 << 4) + 14] = Math.floor(o / 4294967296), y[(u + 64 >>> 9 << 4) + 15] = o, c.sigBytes = y.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var c = x.clone.call(this);
            return c._hash = this._hash.clone(), c;
          }
        });
        s.SHA1 = x._createHelper(a), s.HmacSHA1 = x._createHmacHelper(a);
      }(), r.SHA1;
    });
  }(Wt)), Wt.exports;
}
var zt = { exports: {} }, _0;
function Rr() {
  return _0 || (_0 = 1, function(t, e) {
    (function(r, s) {
      t.exports = s(W());
    })(N, function(r) {
      (function() {
        var s = r, n = s.lib, i = n.Base, x = s.enc, d = x.Utf8, p = s.algo;
        p.HMAC = i.extend({
          /**
           * Initializes a newly created HMAC.
           *
           * @param {Hasher} hasher The hash algorithm to use.
           * @param {WordArray|string} key The secret key.
           *
           * @example
           *
           *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
           */
          init: function(a, c) {
            a = this._hasher = new a.init(), typeof c == "string" && (c = d.parse(c));
            var y = a.blockSize, o = y * 4;
            c.sigBytes > o && (c = a.finalize(c)), c.clamp();
            for (var u = this._oKey = c.clone(), h = this._iKey = c.clone(), v = u.words, g = h.words, $ = 0; $ < y; $++)
              v[$] ^= 1549556828, g[$] ^= 909522486;
            u.sigBytes = h.sigBytes = o, this.reset();
          },
          /**
           * Resets this HMAC to its initial state.
           *
           * @example
           *
           *     hmacHasher.reset();
           */
          reset: function() {
            var a = this._hasher;
            a.reset(), a.update(this._iKey);
          },
          /**
           * Updates this HMAC with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {HMAC} This HMAC instance.
           *
           * @example
           *
           *     hmacHasher.update('message');
           *     hmacHasher.update(wordArray);
           */
          update: function(a) {
            return this._hasher.update(a), this;
          },
          /**
           * Finalizes the HMAC computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The HMAC.
           *
           * @example
           *
           *     var hmac = hmacHasher.finalize();
           *     var hmac = hmacHasher.finalize('message');
           *     var hmac = hmacHasher.finalize(wordArray);
           */
          finalize: function(a) {
            var c = this._hasher, y = c.finalize(a);
            c.reset();
            var o = c.finalize(this._oKey.clone().concat(y));
            return o;
          }
        });
      })();
    });
  }(zt)), zt.exports;
}
var w0;
function De() {
  return w0 || (w0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), Tr(), Rr());
    })(N, function(r) {
      return function() {
        var s = r, n = s.lib, i = n.Base, x = n.WordArray, d = s.algo, p = d.MD5, a = d.EvpKDF = i.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hash algorithm to use. Default: MD5
           * @property {number} iterations The number of iterations to perform. Default: 1
           */
          cfg: i.extend({
            keySize: 128 / 32,
            hasher: p,
            iterations: 1
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.EvpKDF.create();
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
           */
          init: function(c) {
            this.cfg = this.cfg.extend(c);
          },
          /**
           * Derives a key from a password.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(c, y) {
            for (var o, u = this.cfg, h = u.hasher.create(), v = x.create(), g = v.words, $ = u.keySize, l = u.iterations; g.length < $; ) {
              o && h.update(o), o = h.update(c).finalize(y), h.reset();
              for (var f = 1; f < l; f++)
                o = h.finalize(o), h.reset();
              v.concat(o);
            }
            return v.sigBytes = $ * 4, v;
          }
        });
        s.EvpKDF = function(c, y, o) {
          return a.create(o).compute(c, y);
        };
      }(), r.EvpKDF;
    });
  }(qt)), qt.exports;
}
var jt = { exports: {} }, $0;
function ee() {
  return $0 || ($0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), De());
    })(N, function(r) {
      r.lib.Cipher || function(s) {
        var n = r, i = n.lib, x = i.Base, d = i.WordArray, p = i.BufferedBlockAlgorithm, a = n.enc;
        a.Utf8;
        var c = a.Base64, y = n.algo, o = y.EvpKDF, u = i.Cipher = p.extend({
          /**
           * Configuration options.
           *
           * @property {WordArray} iv The IV to use for this operation.
           */
          cfg: x.extend(),
          /**
           * Creates this cipher in encryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
           */
          createEncryptor: function(_, w) {
            return this.create(this._ENC_XFORM_MODE, _, w);
          },
          /**
           * Creates this cipher in decryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
           */
          createDecryptor: function(_, w) {
            return this.create(this._DEC_XFORM_MODE, _, w);
          },
          /**
           * Initializes a newly created cipher.
           *
           * @param {number} xformMode Either the encryption or decryption transormation mode constant.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
           */
          init: function(_, w, B) {
            this.cfg = this.cfg.extend(B), this._xformMode = _, this._key = w, this.reset();
          },
          /**
           * Resets this cipher to its initial state.
           *
           * @example
           *
           *     cipher.reset();
           */
          reset: function() {
            p.reset.call(this), this._doReset();
          },
          /**
           * Adds data to be encrypted or decrypted.
           *
           * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
           *
           * @return {WordArray} The data after processing.
           *
           * @example
           *
           *     var encrypted = cipher.process('data');
           *     var encrypted = cipher.process(wordArray);
           */
          process: function(_) {
            return this._append(_), this._process();
          },
          /**
           * Finalizes the encryption or decryption process.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
           *
           * @return {WordArray} The data after final processing.
           *
           * @example
           *
           *     var encrypted = cipher.finalize();
           *     var encrypted = cipher.finalize('data');
           *     var encrypted = cipher.finalize(wordArray);
           */
          finalize: function(_) {
            _ && this._append(_);
            var w = this._doFinalize();
            return w;
          },
          keySize: 128 / 32,
          ivSize: 128 / 32,
          _ENC_XFORM_MODE: 1,
          _DEC_XFORM_MODE: 2,
          /**
           * Creates shortcut functions to a cipher's object interface.
           *
           * @param {Cipher} cipher The cipher to create a helper for.
           *
           * @return {Object} An object with encrypt and decrypt shortcut functions.
           *
           * @static
           *
           * @example
           *
           *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
           */
          _createHelper: /* @__PURE__ */ function() {
            function _(w) {
              return typeof w == "string" ? A : E;
            }
            return function(w) {
              return {
                encrypt: function(B, I, O) {
                  return _(I).encrypt(w, B, I, O);
                },
                decrypt: function(B, I, O) {
                  return _(I).decrypt(w, B, I, O);
                }
              };
            };
          }()
        });
        i.StreamCipher = u.extend({
          _doFinalize: function() {
            var _ = this._process(!0);
            return _;
          },
          blockSize: 1
        });
        var h = n.mode = {}, v = i.BlockCipherMode = x.extend({
          /**
           * Creates this mode for encryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
           */
          createEncryptor: function(_, w) {
            return this.Encryptor.create(_, w);
          },
          /**
           * Creates this mode for decryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
           */
          createDecryptor: function(_, w) {
            return this.Decryptor.create(_, w);
          },
          /**
           * Initializes a newly created mode.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
           */
          init: function(_, w) {
            this._cipher = _, this._iv = w;
          }
        }), g = h.CBC = function() {
          var _ = v.extend();
          _.Encryptor = _.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function(B, I) {
              var O = this._cipher, U = O.blockSize;
              w.call(this, B, I, U), O.encryptBlock(B, I), this._prevBlock = B.slice(I, I + U);
            }
          }), _.Decryptor = _.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function(B, I) {
              var O = this._cipher, U = O.blockSize, H = B.slice(I, I + U);
              O.decryptBlock(B, I), w.call(this, B, I, U), this._prevBlock = H;
            }
          });
          function w(B, I, O) {
            var U, H = this._iv;
            H ? (U = H, this._iv = s) : U = this._prevBlock;
            for (var Y = 0; Y < O; Y++)
              B[I + Y] ^= U[Y];
          }
          return _;
        }(), $ = n.pad = {}, l = $.Pkcs7 = {
          /**
           * Pads data using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to pad.
           * @param {number} blockSize The multiple that the data should be padded to.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
           */
          pad: function(_, w) {
            for (var B = w * 4, I = B - _.sigBytes % B, O = I << 24 | I << 16 | I << 8 | I, U = [], H = 0; H < I; H += 4)
              U.push(O);
            var Y = d.create(U, I);
            _.concat(Y);
          },
          /**
           * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to unpad.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.unpad(wordArray);
           */
          unpad: function(_) {
            var w = _.words[_.sigBytes - 1 >>> 2] & 255;
            _.sigBytes -= w;
          }
        };
        i.BlockCipher = u.extend({
          /**
           * Configuration options.
           *
           * @property {Mode} mode The block mode to use. Default: CBC
           * @property {Padding} padding The padding strategy to use. Default: Pkcs7
           */
          cfg: u.cfg.extend({
            mode: g,
            padding: l
          }),
          reset: function() {
            var _;
            u.reset.call(this);
            var w = this.cfg, B = w.iv, I = w.mode;
            this._xformMode == this._ENC_XFORM_MODE ? _ = I.createEncryptor : (_ = I.createDecryptor, this._minBufferSize = 1), this._mode && this._mode.__creator == _ ? this._mode.init(this, B && B.words) : (this._mode = _.call(I, this, B && B.words), this._mode.__creator = _);
          },
          _doProcessBlock: function(_, w) {
            this._mode.processBlock(_, w);
          },
          _doFinalize: function() {
            var _, w = this.cfg.padding;
            return this._xformMode == this._ENC_XFORM_MODE ? (w.pad(this._data, this.blockSize), _ = this._process(!0)) : (_ = this._process(!0), w.unpad(_)), _;
          },
          blockSize: 128 / 32
        });
        var f = i.CipherParams = x.extend({
          /**
           * Initializes a newly created cipher params object.
           *
           * @param {Object} cipherParams An object with any of the possible cipher parameters.
           *
           * @example
           *
           *     var cipherParams = CryptoJS.lib.CipherParams.create({
           *         ciphertext: ciphertextWordArray,
           *         key: keyWordArray,
           *         iv: ivWordArray,
           *         salt: saltWordArray,
           *         algorithm: CryptoJS.algo.AES,
           *         mode: CryptoJS.mode.CBC,
           *         padding: CryptoJS.pad.PKCS7,
           *         blockSize: 4,
           *         formatter: CryptoJS.format.OpenSSL
           *     });
           */
          init: function(_) {
            this.mixIn(_);
          },
          /**
           * Converts this cipher params object to a string.
           *
           * @param {Format} formatter (Optional) The formatting strategy to use.
           *
           * @return {string} The stringified cipher params.
           *
           * @throws Error If neither the formatter nor the default formatter is set.
           *
           * @example
           *
           *     var string = cipherParams + '';
           *     var string = cipherParams.toString();
           *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
           */
          toString: function(_) {
            return (_ || this.formatter).stringify(this);
          }
        }), m = n.format = {}, b = m.OpenSSL = {
          /**
           * Converts a cipher params object to an OpenSSL-compatible string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The OpenSSL-compatible string.
           *
           * @static
           *
           * @example
           *
           *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
           */
          stringify: function(_) {
            var w, B = _.ciphertext, I = _.salt;
            return I ? w = d.create([1398893684, 1701076831]).concat(I).concat(B) : w = B, w.toString(c);
          },
          /**
           * Converts an OpenSSL-compatible string to a cipher params object.
           *
           * @param {string} openSSLStr The OpenSSL-compatible string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
           */
          parse: function(_) {
            var w, B = c.parse(_), I = B.words;
            return I[0] == 1398893684 && I[1] == 1701076831 && (w = d.create(I.slice(2, 4)), I.splice(0, 4), B.sigBytes -= 16), f.create({ ciphertext: B, salt: w });
          }
        }, E = i.SerializableCipher = x.extend({
          /**
           * Configuration options.
           *
           * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
           */
          cfg: x.extend({
            format: b
          }),
          /**
           * Encrypts a message.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(_, w, B, I) {
            I = this.cfg.extend(I);
            var O = _.createEncryptor(B, I), U = O.finalize(w), H = O.cfg;
            return f.create({
              ciphertext: U,
              key: B,
              iv: H.iv,
              algorithm: _,
              mode: H.mode,
              padding: H.padding,
              blockSize: _.blockSize,
              formatter: I.format
            });
          },
          /**
           * Decrypts serialized ciphertext.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(_, w, B, I) {
            I = this.cfg.extend(I), w = this._parse(w, I.format);
            var O = _.createDecryptor(B, I).finalize(w.ciphertext);
            return O;
          },
          /**
           * Converts serialized ciphertext to CipherParams,
           * else assumed CipherParams already and returns ciphertext unchanged.
           *
           * @param {CipherParams|string} ciphertext The ciphertext.
           * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
           *
           * @return {CipherParams} The unserialized ciphertext.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
           */
          _parse: function(_, w) {
            return typeof _ == "string" ? w.parse(_, this) : _;
          }
        }), k = n.kdf = {}, S = k.OpenSSL = {
          /**
           * Derives a key and IV from a password.
           *
           * @param {string} password The password to derive from.
           * @param {number} keySize The size in words of the key to generate.
           * @param {number} ivSize The size in words of the IV to generate.
           * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
           *
           * @return {CipherParams} A cipher params object with the key, IV, and salt.
           *
           * @static
           *
           * @example
           *
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
           */
          execute: function(_, w, B, I) {
            I || (I = d.random(64 / 8));
            var O = o.create({ keySize: w + B }).compute(_, I), U = d.create(O.words.slice(w), B * 4);
            return O.sigBytes = w * 4, f.create({ key: O, iv: U, salt: I });
          }
        }, A = i.PasswordBasedCipher = E.extend({
          /**
           * Configuration options.
           *
           * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
           */
          cfg: E.cfg.extend({
            kdf: S
          }),
          /**
           * Encrypts a message using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(_, w, B, I) {
            I = this.cfg.extend(I);
            var O = I.kdf.execute(B, _.keySize, _.ivSize);
            I.iv = O.iv;
            var U = E.encrypt.call(this, _, w, O.key, I);
            return U.mixIn(O), U;
          },
          /**
           * Decrypts serialized ciphertext using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(_, w, B, I) {
            I = this.cfg.extend(I), w = this._parse(w, I.format);
            var O = I.kdf.execute(B, _.keySize, _.ivSize, w.salt);
            I.iv = O.iv;
            var U = E.decrypt.call(this, _, w, O.key, I);
            return U;
          }
        });
      }();
    });
  }(jt)), jt.exports;
}
var E0;
function xs() {
  return E0 || (E0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), Re(), Ue(), De(), ee());
    })(N, function(r) {
      return function() {
        var s = r, n = s.lib, i = n.BlockCipher, x = s.algo, d = [], p = [], a = [], c = [], y = [], o = [], u = [], h = [], v = [], g = [];
        (function() {
          for (var f = [], m = 0; m < 256; m++)
            m < 128 ? f[m] = m << 1 : f[m] = m << 1 ^ 283;
          for (var b = 0, E = 0, m = 0; m < 256; m++) {
            var k = E ^ E << 1 ^ E << 2 ^ E << 3 ^ E << 4;
            k = k >>> 8 ^ k & 255 ^ 99, d[b] = k, p[k] = b;
            var S = f[b], A = f[S], _ = f[A], w = f[k] * 257 ^ k * 16843008;
            a[b] = w << 24 | w >>> 8, c[b] = w << 16 | w >>> 16, y[b] = w << 8 | w >>> 24, o[b] = w;
            var w = _ * 16843009 ^ A * 65537 ^ S * 257 ^ b * 16843008;
            u[k] = w << 24 | w >>> 8, h[k] = w << 16 | w >>> 16, v[k] = w << 8 | w >>> 24, g[k] = w, b ? (b = S ^ f[f[f[_ ^ S]]], E ^= f[f[E]]) : b = E = 1;
          }
        })();
        var $ = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], l = x.AES = i.extend({
          _doReset: function() {
            var f;
            if (!(this._nRounds && this._keyPriorReset === this._key)) {
              for (var m = this._keyPriorReset = this._key, b = m.words, E = m.sigBytes / 4, k = this._nRounds = E + 6, S = (k + 1) * 4, A = this._keySchedule = [], _ = 0; _ < S; _++)
                _ < E ? A[_] = b[_] : (f = A[_ - 1], _ % E ? E > 6 && _ % E == 4 && (f = d[f >>> 24] << 24 | d[f >>> 16 & 255] << 16 | d[f >>> 8 & 255] << 8 | d[f & 255]) : (f = f << 8 | f >>> 24, f = d[f >>> 24] << 24 | d[f >>> 16 & 255] << 16 | d[f >>> 8 & 255] << 8 | d[f & 255], f ^= $[_ / E | 0] << 24), A[_] = A[_ - E] ^ f);
              for (var w = this._invKeySchedule = [], B = 0; B < S; B++) {
                var _ = S - B;
                if (B % 4)
                  var f = A[_];
                else
                  var f = A[_ - 4];
                B < 4 || _ <= 4 ? w[B] = f : w[B] = u[d[f >>> 24]] ^ h[d[f >>> 16 & 255]] ^ v[d[f >>> 8 & 255]] ^ g[d[f & 255]];
              }
            }
          },
          encryptBlock: function(f, m) {
            this._doCryptBlock(f, m, this._keySchedule, a, c, y, o, d);
          },
          decryptBlock: function(f, m) {
            var b = f[m + 1];
            f[m + 1] = f[m + 3], f[m + 3] = b, this._doCryptBlock(f, m, this._invKeySchedule, u, h, v, g, p);
            var b = f[m + 1];
            f[m + 1] = f[m + 3], f[m + 3] = b;
          },
          _doCryptBlock: function(f, m, b, E, k, S, A, _) {
            for (var w = this._nRounds, B = f[m] ^ b[0], I = f[m + 1] ^ b[1], O = f[m + 2] ^ b[2], U = f[m + 3] ^ b[3], H = 4, Y = 1; Y < w; Y++) {
              var j = E[B >>> 24] ^ k[I >>> 16 & 255] ^ S[O >>> 8 & 255] ^ A[U & 255] ^ b[H++], X = E[I >>> 24] ^ k[O >>> 16 & 255] ^ S[U >>> 8 & 255] ^ A[B & 255] ^ b[H++], K = E[O >>> 24] ^ k[U >>> 16 & 255] ^ S[B >>> 8 & 255] ^ A[I & 255] ^ b[H++], P = E[U >>> 24] ^ k[B >>> 16 & 255] ^ S[I >>> 8 & 255] ^ A[O & 255] ^ b[H++];
              B = j, I = X, O = K, U = P;
            }
            var j = (_[B >>> 24] << 24 | _[I >>> 16 & 255] << 16 | _[O >>> 8 & 255] << 8 | _[U & 255]) ^ b[H++], X = (_[I >>> 24] << 24 | _[O >>> 16 & 255] << 16 | _[U >>> 8 & 255] << 8 | _[B & 255]) ^ b[H++], K = (_[O >>> 24] << 24 | _[U >>> 16 & 255] << 16 | _[B >>> 8 & 255] << 8 | _[I & 255]) ^ b[H++], P = (_[U >>> 24] << 24 | _[B >>> 16 & 255] << 16 | _[I >>> 8 & 255] << 8 | _[O & 255]) ^ b[H++];
            f[m] = j, f[m + 1] = X, f[m + 2] = K, f[m + 3] = P;
          },
          keySize: 256 / 32
        });
        s.AES = i._createHelper(l);
      }(), r.AES;
    });
  }(Nt)), Nt.exports;
}
var xi = xs();
const nt = /* @__PURE__ */ ze(xi);
class ye {
  constructor() {
    this.$http = et.create({
      timeout: 6e4
    });
  }
  static encryptParams(e) {
    st(e, "object") && (e = JSON.stringify(e));
    let r = nt.encrypt(e, J0());
    return {
      payload: r.ciphertext.toString(Ce),
      token: `${r.key.toString(Ce)}##${r.iv.toString(Ce)}`
    };
  }
  static toUnderscore(e) {
    return e.split(/(?=[A-Z])/).join("_").toLowerCase();
  }
  static toCamelcase(e) {
    return e.replace(/(\_[a-z])/g, function(r) {
      return r.toUpperCase().replace(/_/g, "");
    });
  }
  static objectKeyToUnderscore(e) {
    let r;
    return M(e) && (Array.isArray(e) ? (r = [], e.forEach((s) => {
      let n = {};
      Object.keys(s).forEach((i) => {
        n[this.toUnderscore(i)] = s[i];
      }), r.push(n);
    })) : (r = {}, Object.keys(e).forEach((s) => {
      r[this.toUnderscore(s)] = e[s];
    }))), r;
  }
  static objectKeyToCamel(e) {
    let r;
    return M(e) && (Array.isArray(e) ? (r = [], e.forEach((s) => {
      let n = {};
      Object.keys(s).forEach((i) => {
        n[this.toCamelcase(i)] = s[i];
      }), r.push(n);
    })) : (r = {}, Object.keys(e).forEach((s) => {
      st(e[s], "object") && Object.keys(e[s]).length > 0 ? r[this.toCamelcase(s)] = this.objectKeyToCamel(e[s]) : r[this.toCamelcase(s)] = e[s];
    }))), r;
  }
  static axiosMultipayConfigure() {
    et.defaults.headers.common["Content-Type"] = "application/json", et.defaults.headers.common.Accept = "application/json", et.interceptors.request.use((e) => (M(e.data), this.isHttpBodyUsedMethod(e.method) && (e.data = ye.encryptParams(ye.objectKeyToUnderscore(e.data))), e.headers !== void 0 && M(e.headers.progress) && delete e.headers.progress, e), (e) => Promise.reject(e)), et.interceptors.response.use((e) => e, function(e) {
      if (M(e.response)) {
        let r = e.response.data;
        return r.status = e.response.status, Promise.reject(r);
      } else
        return Promise.reject(e);
    });
  }
  static isHttpBodyUsedMethod(e) {
    return ["post", "put"].indexOf(e) > -1;
  }
}
ye.axiosMultipayConfigure();
class vi extends ye {
  constructor() {
    super();
  }
  /**
   * 결제 상태 정보를 지속적으로 가져온다
   * Comment by GOSOMI
   * @date: 2021-12-29
   */
  async pollingStatus(e, r, s, n) {
    try {
      const i = await this.$http.get([e, "s", r].join("/"), {
        params: {
          application_id: s,
          tk: n
        }
      });
      return Promise.resolve(i);
    } catch (i) {
      return Promise.reject(i);
    }
  }
}
const yi = new vi();
class mi extends ot {
  constructor() {
    super(), this.$messageEventName = "message.BootpayPaymentEvent", this.$eventPrefix = "bootpay", this.$pollingInterval = void 0, this.$pollingData = {
      applicationId: "",
      gatewayUrl: "",
      receiptId: "",
      transactionKey: ""
    }, this.$pollingEvent = yi, this.pollingInterval = 3e3, this.isDone = !1;
  }
  /**
   * 결제 이벤트를 바인딩한다
   * Comment by GOSOMI
   * @date: 2021-05-11
   */
  bind(e, r) {
    this.isDone = !1, this.setCallbackFunction(e, r), window.resetBootpayEventListener(this.$messageEventName, (s) => {
      const n = this.parseEvent(s.data);
      if (F.debug("event received", JSON.stringify(n)), M(n))
        switch (F.debug("event", n), n.event) {
          case "error":
          case "cancel":
            return this.reject({
              event: n.event,
              pg_error_code: n.pg_error_code,
              error_code: n.error_code,
              message: n.message,
              payload: n.payload
            });
          case "setConfirmParameters":
            const i = `${n.gateway_url}/confirm/${n.receipt_id}?application_id=${n.application_id}`;
            n.open_type === "redirect" ? q.setConfirmRedirect(i) : q.setConfirmFormUrl(i);
            break;
          case "confirm":
            return this.resolve({
              event: n.event,
              receipt_id: n.receipt_id,
              gateway_url: n.gateway_url,
              order_id: n.order_id
            });
          case "redirect":
            q.destroy(!1), location.href = n.url;
            return;
          case "moveRedirectUrl":
            q.closePopup(), q.hidePaymentiFrame(), he.showProgress("결제 진행 중입니다. 잠시만 기다려주세요."), location.replace(Ds(n.url, n.parameters)), setTimeout(() => {
              q.destroy(!1);
            }, 5e3);
            break;
          case "polling":
            return this.$pollingData !== void 0 && (this.$pollingData.receiptId = n.receipt_id, this.$pollingData.gatewayUrl = n.gateway_url), this.startPollingEvent();
          case "issued":
          case "done":
            if (!this.isDone)
              return this.isDone = !0, this.clearPollingEvent(), this.resolve(n);
            break;
          case "iFrameStyle":
            q.iFrameSetStyle(n.styles);
            break;
          case "windowStyle":
            q.windowStyle(n.styles);
            break;
          case "hideProgress":
            he.hideProgress();
            break;
          case "showProgress":
            he.showProgress(n.message);
            break;
          case "resize":
            q.iFrameResize(n.resizeData);
            break;
          case "hidePayment":
            q.closePopup(), q.hidePaymentiFrame();
            break;
          case "showPayment":
            q.showPaymentiFrame(this.$present(n.showCloseButton) ? n.showCloseButton : !1);
            break;
          case "popup":
            q.createPopupButton({
              gatewayUrl: n.url,
              receiptId: n.receipt_id,
              name: n.name,
              price: n.price
            });
            break;
          case "close":
            q.destroy();
            break;
          default:
            return;
        }
    });
  }
  /**
   * 결제 이벤트에 필요한 기본 값들을 받는다
   * Comment by GOSOMI
   * @date: 2021-12-29
   */
  setDefaultPaymentData(e, r) {
    this.$pollingData !== void 0 && (this.$pollingData.applicationId = e, this.$pollingData.transactionKey = r);
  }
  /**
   * bootpay dom custom 이벤트 호출
   * Comment by GOSOMI
   * @date: 2021-12-24
   * @param eventName: string
   * @param data: any
   */
  callBootpayDOMEvent(e, r = void 0) {
    document.dispatchEvent(
      new CustomEvent(
        [this.$eventPrefix, e].join(""),
        { detail: r }
      )
    );
  }
  /**
   * Polling Event를 시작한다
   * Comment by GOSOMI
   * @date: 2021-12-29
   */
  startPollingEvent() {
    this.$pollingInterval = setInterval(async () => {
      if (this.$pollingData !== void 0)
        try {
          const e = await this.$pollingEvent.pollingStatus(
            this.$pollingData.gatewayUrl,
            this.$pollingData.receiptId,
            this.$pollingData.applicationId,
            this.$pollingData.transactionKey
          );
          let r = {
            bootpay_event: !0,
            event: "",
            data: e.data
          };
          if (e.data !== void 0) {
            if (F.debug("polling event", `receive data: ${JSON.stringify(r)}`), e.data.status === 1)
              return r.event = "done", window.postMessage(JSON.stringify(r), "*");
            if (e.data.status === 5)
              return r.event = "issued", window.postMessage(JSON.stringify(r), "*");
          }
        } catch {
          return this.reject({
            error_code: "RC_RECEIPT_POLLING_INVALID",
            message: "결제 상태 체크에 실패하였습니다."
          });
        }
    }, this.pollingInterval);
  }
  /**
   * Polling Event를 초기화한다
   * Comment by GOSOMI
   * @date: 2021-12-29
   */
  clearPollingEvent() {
    this.$pollingInterval !== void 0 && clearInterval(this.$pollingInterval), this.$pollingInterval = void 0, this.$pollingData = {
      applicationId: "",
      gatewayUrl: "",
      receiptId: "",
      transactionKey: ""
    };
  }
  /**
   * PostMessage bind 이벤트 모두 삭제하기
   * Comment by GOSOMI
   * @date: 2023-04-18
   */
  allClearEvent() {
    this.clearPollingEvent(), window.removeBootpayEventListener(this.$messageEventName);
  }
}
const ie = new mi();
class gi extends ye {
  constructor() {
    super(), this.$session = Te, this.$applicationId = void 0, this.$tk = void 0, this.$platformType = 1, this.$receiptId = void 0;
  }
  /**
   * Token키를 설정
   * Comment by GOSOMI
   * @date: 2021-05-20
   * @param tokenKey: string
   * @returns void
   */
  setTokenKey(e) {
    this.$tk = e;
  }
  setReceiptId(e) {
    this.$receiptId = e;
  }
  clearInstance() {
    this.$applicationId = void 0, this.$receiptId = void 0;
  }
  send(e) {
    try {
      if (M(this.$applicationId))
        return e.application_id = this.$applicationId, e.status = M(e.status) ? e.status : 1, e.version = $e.version, e.tk = this.$tk, F.debug("send event", `${JSON.stringify(e)} 전송됨`), this.$http.post(
          D.toAnalytics("event"),
          e
        );
    } catch {
      return;
    }
  }
  sendError(e) {
    e.status = -1, this.send(e);
  }
  setApplicationId(e) {
    this.$applicationId = e;
  }
  /**
   * 결제창 닫기 이벤트를 전송한다
   * Comment by GOSOMI
   * @date: 2022-05-13
   */
  sendCloseEvent() {
    if (M(this.$receiptId))
      try {
        return this.$http.put(D.toApi(`close/${this.$receiptId}`));
      } catch (e) {
        return Promise.reject(e);
      }
    else
      return F.debug("receipt_id", "undefined receipt_id"), Promise.resolve();
  }
}
const rt = new gi(), Ar = {
  startProgress: {
    PAYMENT: {
      ko: "결제를 시작합니다",
      en: "Start Payment..."
    },
    CARD_SUBSCRIPTION: {
      ko: "자동결제 정보를 불러오는 중입니다...",
      en: "Automatic payment will start..."
    },
    AUTH: {
      ko: "본인인증을 시작합니다",
      en: "Authentication will start..."
    }
  },
  popupLocaleMessage: {
    message: {
      ko: "구매 내역에 동의하면 결제를 진행해주세요",
      en: "If you agree with the purchase details, please proceed with the payment."
    },
    button: {
      ko: "결제계속하기",
      en: "Continue"
    }
  },
  popupMessage: {
    message: {
      PAYMENT: {
        ko: "구매 내역에 동의하면 결제를 진행해주세요",
        en: "If you agree with the purchase details, please proceed with the payment"
      },
      CARD_SUBSCRIPTION: {
        ko: '자동결제에 동의하면 "계속하기" 버튼을 눌러 진행해주세요',
        en: 'If you agree to automatic card payment, press the "Continue" button to proceed'
      },
      AUTH: {
        ko: '본인인증에 동의하면 "계속하기" 버튼을 눌러 진행해주세요',
        en: 'If you agree to authenticate yourself, press the "Continue" button to proceed'
      }
    },
    button: {
      PAYMENT: {
        ko: "결제계속하기",
        en: "Continue"
      },
      CARD_SUBSCRIPTION: {
        ko: "계속하기",
        en: "Continue"
      },
      AUTH: {
        ko: "계속하기",
        en: "Continue"
      }
    }
  },
  closeMessage: {
    PAYMENT: {
      ko: "결제창을 닫았습니다",
      en: "Payment window is closed"
    },
    CARD_SUBSCRIPTION: {
      ko: "자동 결제창을 닫았습니다",
      en: "Automatic Payment window is closed"
    },
    AUTH: {
      ko: "본인인증 창을 닫았습니다",
      en: "Authenticate window is closed"
    }
  },
  confirmNotYet: {
    PAYMENT: {
      ko: "결제 승인준비가 되지 않았습니다",
      en: "Payment approval not ready "
    },
    CARD_SUBSCRIPTION: {
      ko: "자동결제 승인준비가 되지 않았습니다",
      en: "Automatic Payment approval not ready"
    },
    AUTH: {
      ko: "본인인증 승인준비가 되지 않았습니다",
      en: "Authenticate approval not ready"
    }
  },
  notSelectPayment: {
    ko: "어떤 방법으로 결제할지 선택해주세요",
    en: "Please, do select payment."
  },
  termsNotAgree: {
    ko: "필수 약관을 모두 동의해주세요",
    en: "Please agree to all required terms and conditions"
  },
  notSelectOOPay: {
    ko: "간편결제로 결제하려면, 등록된 카드 혹은 계좌를 선택해주세요",
    en: "Please select a registered card or account to pay with Easy Payment"
  },
  widgetTypeNotPayment: {
    ko: "결제 위젯 요청이 아닙니다. 결제 위젯이 아닌 경우 requestSubscription 함수를 이용해주세요.",
    en: "This is not a payment widget. If it is not a payment widget, use the requestSubscription function."
  },
  widgetTypeNotSubscription: {
    ko: "정기결제 위젯 요청이 아닙니다. 정기결제 위젯이 아닌 경우 requestPayment 함수를 이용해주세요.",
    en: "This is not a subscription widget. If it is not a subscription widget, use the requestPayment function."
  },
  getLocaleMessage: (t, e) => {
    const s = t.split(".").reduce((n, i) => n[i], Ar);
    return M(s) && M(s[e]) ? s[e] : s.ko;
  }
};
class bi extends ge {
  constructor() {
    super(), this.mode = "PAYMENT", this.modeApiUrl = {
      PAYMENT: "request/payment",
      CARD_SUBSCRIPTION: "request/subscribe",
      AUTH: "request/authentication"
    }, this.$formId = "bootpay-form", this.$iFrameId = "bootpay-iframe-id", this.$windowId = "bootpay-window-id", this.$paymentWindowId = "bootpay-payment-window-id", this.$confirmFormId = "bootpay-confirm-form-id", this.$confirmIFrame = "bootpay-confirm-iframe-id", this.$popupWindow = "bootpay-popup-window-id", this.$closeButton = "bootpay-close-btn", this.$popupItemNameId = "bootpay-item-name-id", this.$popupPriceId = "bootpay-price-id", this.$popup = void 0, this.$popupWatcher = void 0, this.$popupUrl = void 0, this.$env = D, this.$template = this.template();
  }
  template() {
    return `
<div id="${this.$windowId}" class="bootpay-payment-background">
    <div class="bootpay-payment-window ${D.isMobile() ? "__mobile" : ""}" id="${this.$paymentWindowId}">
        <button class="bootpay-close-btn" id="${this.$closeButton}" style="display: none;" onclick="Bootpay.dismiss()"></button>        
        <form id="${this.$formId}" method="POST">
        </form>        
        <iframe id="${this.$iFrameId}" name="${this.$iFrameId}"></iframe>
        <div class="bootpay-popup-window" id="${this.$popupWindow}">
            <div class="header">
                <button class="bootpay-close-btn" onclick="Bootpay.dismiss(true)"></button>
            </div>
            <div class="body">
                <h5 id="${this.$popupItemNameId}"></h5>
                <p class="price" id="${this.$popupPriceId}"></p>                 
                <div class="agree-text">${this.message("popupMessage.message")}</div>
            </div>
            <div class="footer">
                <button class="bootpay-button" onclick="Bootpay.readyToPopup()">
                    ${this.message("popupMessage.button")}
                </button>           
            </div>
        </div>
    </div>
    <div class="bootpay-confirm-window">
        <form id="${this.$confirmFormId}" method="POST">
            <input type="hidden" name="_method" value="put" />                
        </form>
        <iframe id="${this.$confirmIFrame}" name="${this.$confirmIFrame}"></iframe>
    </div>    
</div>
        `;
  }
  /**
   * Locale을 설정
   * Comment by GOSOMI
   * @date: 2022-06-09
   */
  templateReload() {
    F.debug("template reload", "template reload!"), this.$template = this.template();
  }
  /**
   * 결제를 시작한다
   * Comment by GOSOMI
   * @date: 2021-05-12
   * @param data: any
   * @param mode: string
   * @returns Promise<any>
   */
  async start(e, r = "PAYMENT") {
    return new Promise((s, n) => {
      this.mode = r, this.templateReload(), ie.clearPollingEvent(), ie.bind(s, n), ie.setDefaultPaymentData(
        e.application_id,
        e.tk
      ), this.createTemplateHtml(), this.bodyOpen(), he.showProgress(this.message("startProgress"));
      const i = ye.encryptParams(ye.objectKeyToUnderscore(e)), x = this.byId(this.$formId);
      x.innerHTML = `
            <input type="hidden" name="payload" value="${i.payload}" />
            <input type="hidden" name="token" value="${i.token}" />
            `, x.action = this.$env.toApi(this.apiUrl()), this.$present(e.extra) && e.extra.popup, x.target = this.$iFrameId, x.submit();
    });
  }
  /**
   * 결제 승인을 위한 form 데이터를 미리 만들어둔다
   * Comment by GOSOMI
   * @date: 2021-05-20
   * @param url: string
   * @returns void
   */
  setConfirmFormUrl(e) {
    const r = this.byId(this.$confirmIFrame), s = this.byId(this.$confirmFormId);
    r.style.setProperty("display", "block"), s.target = this.$confirmIFrame, s.action = e;
  }
  /**
   * 결제 승인시 redirect 인 경우 _self target으로 설정한다
   * Comment by GOSOMI
   * @date: 2024-06-12
   */
  setConfirmRedirect(e) {
    const r = this.byId(this.$confirmFormId);
    r.target = "_self", r.action = e;
  }
  /**
   * 결제 승인
   * Comment by GOSOMI
   * @date: 2021-05-20
   */
  confirm() {
    return new Promise((e, r) => {
      ie.bind(e, r);
      const s = this.byId(this.$confirmFormId);
      if (this.$blank(s.action))
        throw new pe({
          event: "error",
          error_code: "RC_CONFIRM_READY_NOT_YET",
          message: this.message("confirmNotYet")
        });
      s.submit();
    });
  }
  /**
   * REST API 받은 결제 URL을 실행한다
   * Comment by GOSOMI
   * @date: 2023-04-13
   */
  async startPaymentUrl(e, r = "PAYMENT") {
    return new Promise((s, n) => {
      this.mode = r, this.templateReload(), ie.clearPollingEvent(), ie.bind(s, n), ie.setDefaultPaymentData(
        null,
        null
      ), he.showProgress(this.message("startProgress")), this.createTemplateHtml(), this.bodyOpen();
      const i = this.byId(this.$formId);
      i.method = "GET", i.action = e, i.target = this.$iFrameId, i.submit();
    });
  }
  /**
   * 팝업창을 띄우기 위한 준비
   * Comment by GOSOMI
   * @date: 2021-05-12
   * @returns void
   */
  createPopupButton(e) {
    he.hideProgress(), this.hidePaymentiFrame(), this.showPopupMessage(e), this.$present(e.gatewayUrl) && (this.$popupUrl = `${e.gatewayUrl}?popup=1`, rt.setReceiptId(e.receiptId));
  }
  /**
   * 팝업창을 띄운다
   * Comment by GOSOMI
   * @date: 2021-06-23
   */
  readyToPopup(e = void 0) {
    this.hidePopupMessage(), this.closePopup();
    const r = "width=750,height=500,top=0,left=0,scrollbars=yes,directories=no, status=no, menubar=no, fullscreen=no";
    this.$popup = window.open(this.getPopupUrl(e), "BootPayPopupInstance", r), this.$popupWatcher = setInterval(async () => {
      if (this.$popup === void 0 || this.$popup.closed) {
        try {
          clearInterval(this.$popupWatcher), await rt.sendCloseEvent();
        } catch (s) {
          F.debug("popup", tt(s));
        }
        return this.$popupUrl = void 0, ie.reject({
          event: "cancel",
          error_code: "RC_CLOSE_WINDOW",
          message: this.message("closeMessage")
        });
      }
    }, 500), this.bindParentEventOnPopup();
  }
  /**
   * 팝업창을 닫는다
   * Comment by GOSOMI
   * @date: 2021-05-12
   * @returns void
   */
  closePopup() {
    if (this.$popupWatcher !== void 0)
      try {
        clearInterval(this.$popupWatcher), F.debug("close popup", "clear popup interval");
      } catch (e) {
        F.info("clear popup watcher", tt(e));
      }
    if (this.$popup !== void 0 && !this.$popup.closed)
      try {
        this.$popup.close(), F.debug("close popup", "close popup instance");
      } catch (e) {
        F.info("popup destroy", tt(e));
      }
  }
  /**
   * POPUP url 정보를 가져온다
   * Comment by GOSOMI
   * @date: 2021-06-23
   * @param url: string | undefined
   * @returns string
   */
  getPopupUrl(e) {
    return this.$present(e) ? e : this.$present(this.$popupUrl) ? this.$popupUrl : "about:blank";
  }
  /**
   * Popup 이후 Parent 페이지 이동 관련 이벤트 컨트롤
   * Comment by GOSOMI
   * @date: 2021-06-23
   */
  bindParentEventOnPopup() {
    let e = "beforeunload.BootpayReloadWatcher";
    D.isMobileSafari() && (e = "pagehide.BootpayReloadWatcher"), window.resetBootpayEventListener(e, () => {
      if (this.$popup !== void 0 && !this.$popup.closed)
        try {
          this.$popup.close();
        } catch (r) {
          F.info("popup destroy", tt(r));
        }
    });
  }
  /**
   * iFrame 결제창을 보여준다
   * Comment by GOSOMI
   * @date: 2021-05-12
   * @returns void
   */
  showPaymentiFrame(e = !1) {
    const r = this.byId(this.$iFrameId), s = this.byId(this.$closeButton);
    r !== void 0 && r.style.setProperty("display", "block"), s !== void 0 && e && s.style.setProperty("display", "inline-block");
  }
  /**
   * 팝업 안내 메세지를 보여준다
   * Comment by GOSOMI
   * @date: 2021-06-23
   * @returns void
   */
  showPopupMessage(e) {
    const r = this.byId(this.$popupWindow), s = this.byId(this.$popupItemNameId), n = this.byId(this.$popupPriceId);
    r !== void 0 && r.style.setProperty("display", "block"), s !== void 0 && (s.innerText = e.name), n !== void 0 && (parseFloat(e.price) > 0 ? n.innerText = String(e.price).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : n.remove());
  }
  /**
   * 팝업 버튼 창을 닫는다
   * Comment by GOSOMI
   * @date: 2021-06-23
   */
  hidePopupMessage() {
    this.byId(this.$popupWindow).style.setProperty("display", "none");
  }
  /**
   * 결제창을 삭제한다
   * Comment by GOSOMI
   * @date: 2021-05-12
   * @returns void
   */
  destroy(e = !0) {
    this.$present(document.querySelector("body").className) && (document.querySelector("body").className = document.querySelector("body").className.replace(/bootpay-open/gi, "")), this.$present(this.byId(this.$windowId)) && (this.byId(this.$windowId).outerHTML = ""), document.body.classList.remove("bootpay-open"), he.hideProgress(), this.closePopup(), ie.allClearEvent(), rt.clearInstance(), e && setTimeout(() => ie.callBootpayDOMEvent("close"), 300);
  }
  /**
   * IFrame 창을 컨트롤한다
   * Comment by GOSOMI
   * @date: 2021-05-18
   */
  iFrameResize(e) {
    const r = this.byId(this.$iFrameId);
    if (r !== void 0)
      for (let s in Object.keys(e)) {
        let n = Object.keys(e)[s], i = e[n];
        this.$present(i) && !String(i).match(/%/) && (n.match(/width/) || n.match(/Width/) || n.match(/height/) || n.match(/Height/)) && (i = `${String(e[n]).replace(/px/gi, "")}px`), String(i).match(/%/) && !this.byId(this.$paymentWindowId).className.match(/w-100/) && (this.byId(this.$paymentWindowId).className += " w-100"), r.style.setProperty(n, i);
      }
  }
  /**
   * iFrame Custom Style 추가
   * Comment by GOSOMI
   * @date: 2022-09-30
   */
  iFrameSetStyle(e) {
    F.debug("change style", e);
    const r = this.byId(this.$iFrameId);
    for (let s in Object.keys(e)) {
      let n = Object.keys(e)[s];
      try {
        F.debug(n, e[n]), r.style.setProperty(n, e[n]);
      } catch (i) {
        F.warn("iframe style", i == null ? void 0 : i.message);
      }
    }
  }
  /**
   * Window Style 정리
   * Comment by GOSOMI
   * @date: 2023-07-17
   */
  windowStyle(e) {
    F.debug("change style", e);
    const r = this.byId(this.$paymentWindowId);
    for (let s in Object.keys(e)) {
      let n = Object.keys(e)[s];
      try {
        F.debug(n, e[n]), r.style.setProperty(n, e[n]);
      } catch (i) {
        F.warn("iframe style", i == null ? void 0 : i.message);
      }
    }
  }
  /**
   * 결제 iFrame창을 감춘다
   * Comment by GOSOMI
   * @date: 2021-05-20
   * @returns void
   */
  hidePaymentiFrame() {
    const e = this.byId(this.$iFrameId), r = this.byId(this.$closeButton);
    e !== void 0 && e.style.setProperty("display", "none"), r !== void 0 && r.style.setProperty("display", "none");
  }
  /**
   * 출력할 메세지를 선택적으로 보여준다
   * Comment by GOSOMI
   * @date: 2021-10-28
   * @param messageType: string
   * @returns string
   */
  message(e) {
    return Ar.getLocaleMessage(`${e}.${this.mode}`, D.locale);
  }
  /**
   * Iframe창의 URL로 이동한다
   * Comment by GOSOMI
   * @date: 2022-01-12
   */
  moveToUrl(e) {
    const r = this.byId(this.$iFrameId);
    this.hidePaymentiFrame(), r.removeAttribute("style"), this.iFrameResize({
      width: D.isMobile() ? "100%" : 400,
      height: D.isMobile() ? "100%" : 700
    }), r.style.setProperty("display", "block"), r.src = e;
  }
  apiUrl() {
    return this.modeApiUrl[this.mode];
  }
}
const q = new bi(), Pe = class Pe extends Ae {
  constructor() {
    super(), this.$session = Te, this.$logger = F, this.$event = rt, this.platformType = te.PLATFORM.JS, this.$transactionKey = "", this.extra = {}, this.browserBootpayFilter = {
      instagram: /Instagram/i,
      kakaotalk: /KAKAOTALK/i,
      facebook: /FBAV/i,
      naver: /NAVER/i,
      mobile_safari: /(iPhone|iPad|iPod)/,
      mobile_chrome: [
        /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/,
        /Chrome/
      ]
    };
  }
  /**
   * 결제 요청 진행하기
   * Comment by GOSOMI
   * @date: 2021-05-11
   * @param data: RequestPaymentModel
   * @returns Promise<any>
   */
  async requestPayment(e) {
    var r;
    ((r = e.extra) == null ? void 0 : r.locale) !== void 0 && !D.isSetLocale && D.setLocale(e.extra.locale), this.$event.clearInstance(), this.generateTransactionKey(), e.application_id = D.currentApplicationId(e.application_id), this.$event.setTokenKey(this.$transactionKey), this.$event.setApplicationId(e.application_id), this.$event.send({
      step: "start",
      msg: "결제 요청 시작",
      request: e
    }), e.sdk = !0, e.platform_type = this.platformType, e.ver = D.packageVersion, e.sdk_version = D.sdkVersion, e.sdk_type = D.sdkName, e.locale = D.locale, e.price = parseFloat(String(e.price)), e.tax_free = parseFloat(String(e.tax_free)), e.deposit_price = parseFloat(String(e.deposit_price)), Pe.invalidRequestParamsData(e), Pe.invalidRequestItemsData(e.items, e.price), e.uuid = this.$session.currentUserUUID(), e.sk = this.$session.currentSessionKey(), e.ti = this.$session.currentTimeTerm(), e.tk = this.$transactionKey, e.env = this.getUserDeviceEnvironment(), e.extra = this.openTypeFilter(e.extra), this.extra = e.extra;
    try {
      const s = await q.start(e);
      return F.debug("confirm ready", s), q.hidePaymentiFrame(), q.closePopup(), ["done", "issued"].indexOf(s.event) === -1 && this.$event.send({
        step: s.event,
        msg: "",
        request: e,
        response: s
      }), q.setConfirmFormUrl(
        `${s.gateway_url}/confirm/${s.receipt_id}?application_id=${e.application_id}`
      ), Promise.resolve(s);
    } catch (s) {
      return this.eventError(s), Promise.reject(s);
    }
  }
  /**
   * 결제 승인
   * Comment by GOSOMI
   * @date: 2021-05-20
   */
  async confirm() {
    try {
      const e = await q.confirm();
      return Promise.resolve(e);
    } catch (e) {
      return this.eventError(e), Promise.reject(e);
    }
  }
  /**
   * 이벤트 완료 이벤트
   * Comment by GOSOMI
   * @date: 2021-07-12
   */
  eventDone(e, r = !0) {
    this.$logger.debug(e.event, e), this.$event.send({
      step: e.event,
      msg: e.event === "done" ? "결제완료" : "가상계좌발급완료",
      request: {},
      response: e
    }), he.hideProgress(), this.$logger.debug("show result", this.isDisplaySuccessResult()), this.isDisplaySuccessResult() && r ? this.displayResultView(e.data.receipt_id) : q.destroy();
  }
  /**
   * 오류를 처리한다
   * Comment by GOSOMI
   * @date: 2022-01-12
   */
  eventError(e) {
    he.hideProgress(), q.closePopup(), this.isDisplayErrorResult() && e.event === "error" ? this.displayResultErrorView(e) : q.destroy(), this.$logger.debug("done failed destroy and hide", "payment"), this.$event.sendError({
      step: this.$present(e.event) ? e.event : "error",
      msg: e.message,
      trace: function() {
        try {
          return e.stack;
        } catch {
          return !1;
        }
      }()
    });
  }
  /**
   * 트랜젝션 키를 만든다
   * Comment by GOSOMI
   * @date: 2021-05-12
   * @returns string
   */
  generateTransactionKey() {
    return this.$transactionKey = `${this.$uuid()}-${(/* @__PURE__ */ new Date()).getTime() * 1e3}`, this.$transactionKey;
  }
  async requestSubscription(e) {
    this.$event.clearInstance(), this.generateTransactionKey(), this.$event.setTokenKey(this.$transactionKey), this.$event.setApplicationId(e.application_id), this.$event.send({
      step: "start",
      msg: "정기결제 요청 시작",
      request: e
    }), e.extra = this.openTypeFilter(e.extra);
    const r = {
      application_id: e.application_id,
      subscription_id: e.subscription_id,
      pg: e.pg,
      method: e.method,
      order_name: e.order_name,
      price: e.price,
      tax_free: e.tax_free,
      user_token: e.user_token,
      metadata: e.metadata,
      redirect_url: e.redirect_url,
      wallet_id: e.wallet_id,
      widget: e.widget,
      widget_key: e.widget_key,
      widget_sandbox: e.widget_sandbox,
      platform_type: this.platformType,
      ver: D.packageVersion,
      sdk_version: D.sdkVersion,
      sdk_type: D.sdkName,
      locale: D.locale,
      sdk: !0,
      uuid: this.$session.currentUserUUID(),
      sk: this.$session.currentSessionKey(),
      tk: this.$transactionKey,
      env: this.getUserDeviceEnvironment(),
      user: e.user,
      extra: e.extra
    };
    try {
      const s = await q.start(r, "CARD_SUBSCRIPTION");
      switch (F.debug("subscription success", s), this.$event.send({
        step: "confirm",
        msg: "결제승인전",
        request: {},
        response: s
      }), q.hidePaymentiFrame(), q.closePopup(), s.event) {
        case "done":
        case "issued":
          break;
        case "confirm":
          q.setConfirmFormUrl(
            `${s.gateway_url}/confirm/${s.receipt_id}?application_id=${e.application_id}`
          );
      }
      return Promise.resolve(s);
    } catch (s) {
      return this.eventError(s), Promise.reject(s);
    }
  }
  /**
   * 본인인증 요청
   * Comment by GOSOMI
   * @date: 2021-12-06
   * @param data: RequestAuthenticationModel
   */
  async requestAuthentication(e) {
    this.$event.clearInstance(), this.generateTransactionKey(), this.$event.setTokenKey(this.$transactionKey), this.$event.setApplicationId(e.application_id), this.$event.send({
      step: "start",
      msg: "본인인증 요청 시작",
      request: e
    }), e.extra = this.openTypeFilter(e.extra);
    const r = {
      application_id: e.application_id,
      authentication_id: e.authentication_id,
      pg: e.pg,
      method: this.$present(e.method) ? e.method : "auth",
      order_name: e.order_name,
      platform_type: this.platformType,
      ver: $e.version,
      sdk_version: D.sdkVersion,
      sdk_type: D.sdkName,
      locale: D.locale,
      metadata: e.metadata,
      redirect_url: e.redirect_url,
      sdk: !0,
      uuid: this.$session.currentUserUUID(),
      sk: this.$session.currentSessionKey(),
      tk: this.$transactionKey,
      env: this.getUserDeviceEnvironment(),
      user: e.user,
      extra: e.extra
    };
    try {
      const s = await q.start(r, "AUTH");
      switch (F.debug("authentication success", s), this.$event.send({
        step: "confirm",
        msg: "본인인증 승인전",
        request: {},
        response: s
      }), q.hidePaymentiFrame(), q.closePopup(), s.event) {
        case "done":
        case "issued":
          break;
        case "confirm":
          q.setConfirmFormUrl(
            `${s.gateway_url}/confirm/${s.receipt_id}?application_id=${e.application_id}`
          );
      }
      return Promise.resolve(s);
    } catch (s) {
      return this.eventError(s), Promise.reject(s);
    }
  }
  async requestPaymentUrl(e) {
    try {
      const r = await q.startPaymentUrl(e.url);
      return ["done", "issued"].indexOf(r.event) === -1 && this.$event.send({
        step: r.event,
        msg: "",
        request: {
          url: e.url
        },
        response: r
      }), q.setConfirmFormUrl(
        `${r.gateway_url}/confirm/${r.receipt_id}?application_id=${e.application_id}`
      ), Promise.resolve(r);
    } catch (r) {
      return this.eventError(r), Promise.reject(r);
    }
  }
  getUserDeviceEnvironment() {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }
  /**
   * display result
   * Comment by GOSOMI
   * @date: 2022-01-12
   */
  isDisplaySuccessResult() {
    return this.extra !== void 0 && this.extra.display_success_result !== void 0 && this.extra.display_success_result;
  }
  isDisplayErrorResult() {
    return this.extra !== void 0 && this.extra.display_error_result !== void 0 && this.extra.display_error_result;
  }
  /**
   * Result View를 호출한다
   * Comment by GOSOMI
   * @date: 2022-01-12
   */
  displayResultView(e) {
    q.moveToUrl(D.toDoor(`result/${e}`));
  }
  /**
   * Result Error View를 보여준다
   * Comment by GOSOMI
   * @date: 2022-01-12
   */
  displayResultErrorView(e) {
    q.moveToUrl(D.toDoor(`error?error_code=${e.error_code}&pg_error_code=${e.pg_error_code}&message=${e.message}`));
  }
  /**
   * OpenTypeUserAgent Filter
   * Comment by GOSOMI
   * @date: 2022-05-09
   */
  openTypeFilter(e) {
    if (this.$present(e) && e.browser_open_type !== void 0) {
      const r = this.getUserAgent();
      for (let s in e.browser_open_type) {
        const n = e.browser_open_type[s], i = this.$present(this.browserBootpayFilter[n.browser]) ? this.browserBootpayFilter[n.browser] : new RegExp(`${n.browser}`);
        if (r.match(i)) {
          e.open_type = n.open_type;
          break;
        }
      }
    }
    return e;
  }
  /**
   * 요청 데이터 필수 값 체크
   * Comment by GOSOMI
   * @date: 2021-05-12
   * @param data: RequestPaymentModel
   */
  static invalidRequestParamsData(e) {
    if (re(e))
      throw new pe({
        event: "error",
        error_code: "NEED_MORE_PARAMS",
        message: "결제 요청을 위한 최소한의 결제 정보를 입력해주세요."
      });
    Object.keys(Pe.invalidRequestParams).forEach((r) => {
      const s = e[r];
      if (re(s))
        throw new pe({
          event: "error",
          error_code: "INVALID_REQUEST_PARAMS",
          message: Pe.invalidRequestParams[r]
        });
    });
  }
  /**
   * 첨부된 item data invalidate
   * Comment by GOSOMI
   * @date: 2021-05-12
   * @param items: Array<ItemModel>
   * @param price: number
   */
  static invalidRequestItemsData(e, r) {
    if (e !== void 0 && M(e)) {
      let s = 0;
      if (e.forEach((n, i) => {
        if (re(n.id))
          throw new pe({
            event: "error",
            error_code: "NEED_ITEM_ID",
            message: `${i + 1}번째 상품 고유 ID를 입력해주세요. [ key: id ]`
          });
        if (re(n.name))
          throw new pe({
            event: "error",
            error_code: "NEED_ITEM_NAME",
            message: `${i + 1}번째 상품명을 입력해주세요. [ key: name ]`
          });
        if (re(n.qty))
          throw new pe({
            event: "error",
            error_code: "NEED_ITEM_QTY",
            message: `${i + 1}번째 상품수량을 입력해주세요. [ key: qty ]`
          });
        if (re(n.price))
          throw new pe({
            event: "error",
            error_code: "NEED_ITEM_PRICE",
            message: `${i + 1}번째 상품금액을 입력해주세요. [ key: price ]`
          });
        e[i].price = parseFloat(String(e[i].price)), e[i].qty = parseFloat(String(e[i].qty)), s += e[i].price * e[i].qty;
      }), s !== r)
        throw new pe({
          event: "error",
          error_code: "NEED_ITEM_TOTAL_PRICE_NOT_MATCH",
          message: `결제 금액과 상품 수량 및 상품 금액의 총합과 일치하지 않습니다. [ 요청금액: ${r} ${typeof r}, 상품 총합계 금액: ${s} ${typeof s} ]`
        });
    }
  }
};
Pe.invalidRequestParams = {
  application_id: "application_id를 입력해주세요. [ key: application_id ]",
  order_name: "판매할 상품명을 입력해주세요. [ key: order_name ]",
  price: "판매할 상품의 금액을 입력해주세요. [ key: price ]",
  order_id: "가맹점에서 설정할 주문 ID를 입력해주세요. [ key: order_id ]"
};
let it = Pe;
const _i = new it();
class wi extends ye {
  constructor() {
    super(), this.$session = Te;
  }
  /**
   * 인앱을 위한 통계 정보 추가
   * Comment by GOSOMI
   * @date: 2022-05-09
   */
  setAnalyticsData(e) {
    this.$session.setTime(e.time), this.$session.setUUID(e.uuid);
  }
  /**
   * 일반적인 통계 데이터를 전송
   * Comment by GOSOMI
   * @date: 2022-03-02
   */
  async send(e) {
    const r = document.URL;
    if (r !== void 0 && r.search(/bootapi.co.kr/) === -1) {
      const s = this.$session.getUser();
      e.application_id = D.currentApplicationId(e.application_id), e.sk = this.$session.currentSessionKey(), e.uuid = this.$session.currentUserUUID(), e.time = this.$session.currentTime(), e.url = r, e.referer = document.referrer !== void 0 && M(document.referrer) && document.referrer.search(new RegExp(window.location.hostname)) == -1 ? document.referrer : "", e.user_id = s === void 0 || re(s) ? void 0 : s.id, e.items = this.generateItemKeyToVersion1(e.items);
      try {
        const n = await this.$http.post(
          D.toAnalytics(`call?ver=${$e.version}`),
          e
        );
        return n.data.status === 200 ? (F.info("Analytics Common Send", "통계 데이터가 전송되었습니다."), Promise.resolve()) : (F.warn("Analytics Common Send", `통계 데이터가 전송 실패. ${JSON.stringify(n.data)}`), Promise.reject());
      } catch (n) {
        return F.error("Analytics Common Error", `데이터 전송 실패: ${n.message}`), Promise.reject();
      }
    }
  }
  /**
   * User Login 정보 보내기
   * Comment by GOSOMI
   * @date: 2022-03-02
   */
  async login(e) {
    if (e.application_id = D.currentApplicationId(e.application_id), re(e.application_id))
      return F.error("Analytics Params", "application_id 값을 입력해주세요.");
    if (re(e.id))
      return F.error("Analytics Params", "id 값을 입력해주세요.");
    try {
      const r = await this.$http.post(
        D.toAnalytics(`login?ver=${$e.version}`),
        e
      ), { user_id: s } = r.data.data;
      return this.$session.setUser({
        id: s,
        time: (/* @__PURE__ */ new Date()).getTime()
      }), Promise.resolve();
    } catch (r) {
      return F.error("Analytics Login Error", `데이터 전송 실패: ${r.message}`), Promise.reject();
    }
  }
  /**
   * Logout
   * Comment by GOSOMI
   * @date: 2022-03-02
   */
  logout() {
    this.$session.setUser(void 0);
  }
  /**
   * Analytics Key to V1 Filter
   * Comment by GOSOMI
   * @date: 2022-05-09
   */
  generateItemKeyToVersion1(e) {
    if (e !== void 0)
      return e.map((r) => ({
        cat1: r.cat1,
        cat2: r.cat2,
        cat3: r.cat3,
        item_img: r.img,
        item_name: r.name,
        unique: r.id,
        price: r.price
      }));
  }
}
const $i = new wi();
(function() {
  if (typeof window > "u" || typeof window.CustomEvent == "function") return !1;
  function t(e, r) {
    r = r || { bubbles: !1, cancelable: !1, detail: void 0 };
    let s = document.createEvent("CustomEvent");
    return s.initCustomEvent(e, r.bubbles, r.cancelable, r.detail), s;
  }
  t.prototype = window.Event.prototype, window.CustomEvent = t;
})();
const Ee = {
  $payment: _i,
  $analytics: $i,
  $environment: D,
  /**
   * 결제 요청
   * Comment by GOSOMI
   * @date: 2021-05-11
   * @param data: RequestPaymentModel
   * @returns Promise<any>
   */
  async requestPayment(t) {
    return new Promise(async (e, r) => {
      try {
        t.extra !== void 0 && t.extra.override_global_event === !0 && (F.debug("override global event", "override global event!"), Ee.overrideGlobalInstance());
        const s = await this.$payment.requestPayment(t);
        setTimeout(() => {
          e(s), ["done", "issued"].indexOf(s.event) > -1 && this.$payment.eventDone(s);
        }, 100);
      } catch (s) {
        setTimeout(() => {
          r(this.errorHandler(s));
        }, 100);
      }
    });
  },
  /**
   * 결제 승인 요청
   * Comment by GOSOMI
   * @date: 2021-05-20
   */
  async confirm() {
    return new Promise(async (t, e) => {
      try {
        const r = await this.$payment.confirm();
        setTimeout(() => {
          t(r), this.$payment.eventDone(r);
        }, 100);
      } catch (r) {
        setTimeout(() => e(this.errorHandler(r)), 100);
      }
    });
  },
  /**
   * 정기결제창 요청
   * Comment by GOSOMI
   * @date: 2021-10-28
   * @param data: RequestSubscriptionModel
   */
  async requestSubscription(t) {
    return new Promise(async (e, r) => {
      try {
        const s = await this.$payment.requestSubscription(t);
        e(s), this.$payment.eventDone(s);
      } catch (s) {
        return r(this.errorHandler(s));
      }
    });
  },
  /**
   * 본인인증 요청
   * Comment by GOSOMI
   * @date: 2021-12-06
   * @param data: RequestAuthenticationModel
   */
  async requestAuthentication(t) {
    return new Promise(async (e, r) => {
      try {
        const s = await this.$payment.requestAuthentication(t);
        e(s), this.$payment.eventDone(s);
      } catch (s) {
        return r(this.errorHandler(s));
      }
    });
  },
  async requestPaymentUrl(t) {
    return new Promise(async (e, r) => {
      try {
        const s = await this.$payment.requestPaymentUrl(t);
        setTimeout(() => {
          e(s), ["done", "issued"].indexOf(s.event) > -1 && this.$payment.eventDone(s);
        }, 100);
      } catch (s) {
        setTimeout(() => {
          r(this.errorHandler(s));
        }, 100);
      }
    });
  },
  /**
   * 환경 설정
   * Comment by GOSOMI
   * @date: 2021-05-11
   * @returns void
   */
  setEnvironmentMode(t, e = void 0) {
    this.$environment.set(t), e !== void 0 && this.$environment.setDevelopmentHost(e);
  },
  /**
   * ApplicationID를 지정
   * Comment by GOSOMI
   * @date: 2022-03-02
   */
  setApplicationId(t) {
    return this.$environment.setApplicationId(t);
  },
  /**
   * SDK 버전과 SDK 이름 기록
   * Comment by GOSOMI
   * @date: 2022-05-15
   */
  setVersion(t, e, r) {
    return this.$environment.setVersion(t, e, r);
  },
  /**
   * DeviceType을 설정
   * Comment by GOSOMI
   * @date: 2021-12-23
   * @param deviceType: string
   * @returns number
   */
  setDevice(t) {
    switch (t) {
      case "IOS":
        this.$payment.platformType = te.PLATFORM.IOS;
        break;
      case "ANDROID":
        this.$payment.platformType = te.PLATFORM.ANDROID;
        break;
      default:
        this.$payment.platformType = te.PLATFORM.JS;
    }
    return this.$payment.platformType;
  },
  /**
   * 이벤트 오류를 받아서 처리한다
   * Comment by GOSOMI
   * @date: 2021-05-12
   * @param e: any
   */
  errorHandler(t) {
    let e;
    switch (he.hideProgress(), t.name) {
      case "BootpayEventError":
        e = t.eventMessage;
        break;
      default:
        if (M(t.event))
          e = t;
        else
          throw t;
    }
    return e;
  },
  /**
   * 팝업을 준비한다
   * Comment by GOSOMI
   * @date: 2021-06-23
   */
  readyToPopup() {
    q.readyToPopup();
  },
  /**
   * 로그 레벨을 설정한다
   * Comment by GOSOMI
   * @date: 2021-05-12
   * @param level: number
   * @returns void
   */
  setLogLevel(t) {
    F.setLogLevel(t);
  },
  /**
   * UUID 설정
   * Comment by GOSOMI
   * @date: 2021-12-22
   * @param uuid: string
   * @returns string
   */
  setUUID(t) {
    return Te.setUUID(t);
  },
  /**
   * 페이지 통계 데이터를 전송
   * Comment by GOSOMI
   * @date: 2022-03-02
   */
  send(t = void 0) {
    return this.$analytics.send(t !== void 0 ? t : {});
  },
  login(t) {
    return this.$analytics.login(t);
  },
  logout() {
    return this.$analytics.logout();
  },
  /**
   * Locale 설정
   * Comment by GOSOMI
   * @date: 2022-06-09
   */
  setLocale(t) {
    D.setLocale(t), q.templateReload();
  },
  /**
   * 결제창을 닫는다
   * Comment by GOSOMI
   * @date: 2021-12-29
   */
  async dismiss(t = !1) {
    if (t)
      try {
        await rt.sendCloseEvent();
      } catch (e) {
        F.debug("error", e.message);
      }
    ie.reject({
      event: "cancel",
      error_code: "RC_CLOSE_WINDOW",
      message: "사용자가 결제창을 닫았습니다."
    });
  },
  getCurrentUUID() {
    return Te.currentUserUUID();
  },
  /**
   * 결제창을 닫는다
   * Comment by GOSOMI
   * @date: 2022-06-14
   */
  destroy() {
    q.destroy();
  },
  overrideGlobalInstance() {
    window.Bootpay = Ee;
  }
};
typeof window < "u" && (window.Bootpay = Ee);
class Ei extends ot {
  constructor() {
    super(), this.$messageEventName = "message.BootpayUserTokenEvent";
  }
  bind(e, r) {
    this.setCallbackFunction(e, r), window.resetBootpayEventListener(this.$messageEventName, (s) => {
      const n = this.parseEvent(s.data);
      if (M(n))
        switch (F.debug("event", n), n.event) {
          case "error":
          case "cancel":
            return this.reject({
              event: n.event,
              pg_error_code: n.pg_error_code,
              error_code: n.error_code,
              message: n.message,
              payload: n.payload
            });
          case "data":
            return this.resolve(n.data);
          case "confirmPasswordToken":
            return this.resolve(n.token);
          case "confirmAddCard":
            return this.resolve(n);
          case "resize":
            vs.iFrameResize(n.resizeData);
            break;
          default:
            return;
        }
    });
  }
}
class ki extends ge {
  constructor() {
    super(), this.$windowId = "bootpay-user-token-background-id", this.$userWindowId = "bootpay-user-token-window-id", this.$iFrameId = "bootpay-user-token-iframe-id", this.$bootpaySdkFormId = "bootpay-user-token-sdk-form", this.$template = this.template(), this.$event = new Ei(), this.$session = Te, this.deviceType = te.PLATFORM.JS;
  }
  /**
   * DeviceType을 지정한다
   * Comment by GOSOMI
   * @date: 2022-02-24
   */
  setDevice(e) {
    return this.deviceType = e, this.deviceType;
  }
  template() {
    return `
        <div id="${this.$windowId}" class="bootpay-payment-background">
            <div class="bootpay-payment-window" id="${this.$userWindowId}">
                <iframe id="${this.$iFrameId}" name="${this.$iFrameId}"></iframe>
                <form name="${this.$bootpaySdkFormId}" id="${this.$bootpaySdkFormId}" method="GET">                          
                </form>
            </div>
        </div>
        `;
  }
  /**
   * 보낼 데이터를 셋팅한다
   * Comment by GOSOMI
   * @date: 2022-02-25
   */
  setParams(e, r) {
    if (r !== void 0) {
      const s = this.byId(this.$bootpaySdkFormId);
      if (["POST", "PUT"].indexOf(e.toUpperCase()) > -1) {
        const n = ye.encryptParams(ye.objectKeyToUnderscore(r));
        s.innerHTML = `
                <input type="hidden" name="payload" value="${n.payload}" />
                <input type="hidden" name="token" value="${n.token}" /> 
                `;
      } else {
        let n = "";
        e.toUpperCase() === "DELETE" && (n += '<input type="hidden" name="_method" value="patch"/>'), Object.keys(r).forEach((i) => {
          n += `<input type="hidden" name="${i}" value="${r[i]}"/>`;
        }), s.innerHTML = n;
      }
    }
  }
  /**
   * 요청
   * Comment by GOSOMI
   * @date: 2022-02-16
   */
  request(e, r) {
    return new Promise((s, n) => {
      this.createTemplateHtml(), this.bodyOpen(), this.$event.bind(s, n), this.goiFrameUrl(
        "GET",
        D.toDoor(`sdk/password/${r}`),
        {
          type: e,
          uuid: this.$session.currentUserUUID()
        }
      );
    });
  }
  /**
   * 카드 추가 SDK
   * Comment by GOSOMI
   * @date: 2022-02-18
   */
  addCard(e) {
    return new Promise((r, s) => {
      this.createTemplateHtml(), this.bodyOpen(), this.$event.bind(r, s), this.goiFrameUrl(
        "GET",
        D.toDoor(`sdk/card/${e}`),
        { uuid: this.$session.currentUserUUID() }
      );
    });
  }
  /**
   * 간편결제 리스트 가져오기
   * Comment by GOSOMI
   * @date: 2022-02-25
   */
  wallets(e) {
    return new Promise((r, s) => {
      this.createTemplateHtml(), this.bodyOpen(), this.$event.bind(r, s), this.goiFrameUrl(
        "GET",
        D.toApi("sdk/easy/wallet"),
        {
          user_token: e,
          sdk: !0,
          uuid: this.$session.currentUserUUID()
        }
      );
    });
  }
  /**
   * 간편결제 Wallet 삭제 요청
   * Comment by GOSOMI
   * @date: 2022-02-28
   */
  destroyWallet(e) {
    return new Promise((r, s) => {
      this.createTemplateHtml(), this.bodyOpen(), this.$event.bind(r, s), this.goiFrameUrl(
        "POST",
        D.toApi("sdk/easy/wallet"),
        {
          method: "DELETE",
          sdk: !0,
          user_token: e.user_token,
          wallet_id: e.wallet_id,
          token: e.token,
          uuid: this.$session.currentUserUUID()
        }
      );
    });
  }
  /**
   * 생체 인식 정보 등록하기
   * Comment by GOSOMI
   * @date: 2022-02-25
   */
  createBiometricAuthenticate(e) {
    return new Promise((r, s) => {
      this.createTemplateHtml(), this.bodyOpen(), this.$event.bind(r, s), this.goiFrameUrl(
        "POST",
        D.toApi("sdk/easy/biometric"),
        {
          user_token: e.userToken,
          sdk: !0,
          uuid: this.$session.currentUserUUID(),
          os: e.os,
          token: e.token
        }
      );
    });
  }
  /**
   * 생체 인식 정보 삭제
   * Comment by GOSOMI
   * @date: 2022-02-25
   */
  destroyBiometricAuthenticate(e) {
    return new Promise((r, s) => {
      this.createTemplateHtml(), this.bodyOpen(), this.$event.bind(r, s), this.goiFrameUrl(
        "POST",
        D.toApi("sdk/easy/biometric"),
        {
          method: "DELETE",
          uuid: this.$session.currentUserUUID(),
          user_token: e.userToken,
          token: e.token
        }
      );
    });
  }
  /**
   * Wallet Payment 요청
   * Comment by GOSOMI
   * @date: 2022-02-25
   */
  requestWalletPayment(e) {
    return new Promise((r, s) => {
      this.createTemplateHtml(), this.bodyOpen(), this.$event.bind(r, s), this.goiFrameUrl(
        "POST",
        D.toApi("sdk/easy/card"),
        this.regenerateRequestPayment(e)
      );
    });
  }
  /**
   * iFrame src로 이동
   * Comment by GOSOMI
   * @date: 2022-02-16
   */
  goiFrameUrl(e, r, s = void 0) {
    this.setParams(e, s);
    const n = this.byId(this.$bootpaySdkFormId);
    n.method = this.toMethod(e), n.action = r, n.target = this.$iFrameId, n.submit(), this.show();
  }
  toMethod(e) {
    switch (e.toUpperCase()) {
      case "PUT":
        return "POST";
      case "DELETE":
        return "POST";
      default:
        return e;
    }
  }
  /**
   * iFrame을 Resize
   * Comment by GOSOMI
   * @date: 2022-02-16
   */
  iFrameResize(e) {
    const r = this.byId(this.$iFrameId);
    if (r !== void 0)
      for (let s in Object.keys(e)) {
        let n = Object.keys(e)[s], i = e[n];
        this.$present(i) && !String(i).match(/%/) && (n.match(/width/) || n.match(/Width/) || n.match(/height/) || n.match(/Height/)) && (i = `${String(e[n]).replace(/px/gi, "")}px`), String(i).match(/%/) && !this.byId(this.$userWindowId).className.match(/w-100/) && (this.byId(this.$userWindowId).className += " w-100"), r.style.setProperty(n, i);
      }
  }
  /**
   * request payment data를 재구성한다
   * Comment by GOSOMI
   * @date: 2022-02-25
   */
  regenerateRequestPayment(e) {
    return e.ver = $e.version, e.platform_type = this.deviceType, e.sdk = !0, e.price = parseFloat(String(e.price)), e.tax_free = parseFloat(String(e.tax_free)), it.invalidRequestParamsData(e), it.invalidRequestItemsData(e.items, e.price), e.uuid = this.$session.currentUserUUID(), e.sk = this.$session.currentSessionKey(), e.ti = this.$session.currentTimeTerm(), e.tk = `${this.$uuid()}-${(/* @__PURE__ */ new Date()).getTime() * 1e3}`, e;
  }
  /**
   * show Password Token Window
   * Comment by GOSOMI
   * @date: 2022-02-16
   */
  show() {
    const e = this.byId(this.$iFrameId);
    e !== void 0 && e.style.setProperty("display", "block");
  }
  /**
   * Destroy
   * Comment by GOSOMI
   * @date: 2022-02-16
   */
  destroy() {
    this.$present(document.querySelector("body").className) && (document.querySelector("body").className = document.querySelector("body").className.replace(/bootpay-open/gi, "")), this.$present(this.byId(this.$windowId)) && (this.byId(this.$windowId).outerHTML = ""), document.body.classList.remove("bootpay-open"), ie.clearPollingEvent(), setTimeout(() => ie.callBootpayDOMEvent("close"), 300);
  }
}
const vs = new ki(), Si = {
  $templateUserToken: vs,
  /**
   * Password Token을 가져온다
   * Comment by GOSOMI
   * @date: 2022-02-16
   * @param userToken: string
   */
  async requestPasswordToken(t) {
    try {
      const e = await this.$templateUserToken.request("passwordToken", t);
      return this.$templateUserToken.destroy(), Promise.resolve(e);
    } catch (e) {
      return this.$templateUserToken.destroy(), Promise.reject(this.errorHandler(e));
    }
  },
  /**
   * 간편결제 비밀번호 변경 SDK
   * Comment by GOSOMI
   * @date: 2022-02-17
   */
  async requestChangePassword(t) {
    try {
      const e = await this.$templateUserToken.request("changePasswordToken", t);
      return this.$templateUserToken.destroy(), Promise.resolve(e);
    } catch (e) {
      return this.$templateUserToken.destroy(), Promise.reject(this.errorHandler(e));
    }
  },
  /**
   * 카드 등록 SDK
   * Comment by GOSOMI
   * @date: 2022-02-18
   * @param
   * @returns
   */
  async requestAddCard(t) {
    try {
      const e = await this.$templateUserToken.addCard(t);
      return this.$templateUserToken.destroy(), Promise.resolve(e);
    } catch (e) {
      return this.$templateUserToken.destroy(), Promise.reject(this.errorHandler(e));
    }
  },
  async wallets(t) {
    try {
      const e = await this.$templateUserToken.wallets(t);
      return this.$templateUserToken.destroy(), Promise.resolve(e);
    } catch (e) {
      return this.$templateUserToken.destroy(), Promise.reject(this.errorHandler(e));
    }
  },
  async destroyWallet(t) {
    try {
      const e = await this.$templateUserToken.destroyWallet(t);
      return this.$templateUserToken.destroy(), Promise.resolve(e);
    } catch (e) {
      return this.$templateUserToken.destroy(), Promise.reject(this.errorHandler(e));
    }
  },
  async createBiometricAuthenticate(t) {
    try {
      const e = await this.$templateUserToken.createBiometricAuthenticate(t);
      return this.$templateUserToken.destroy(), Promise.resolve(e);
    } catch (e) {
      return this.$templateUserToken.destroy(), Promise.reject(this.errorHandler(e));
    }
  },
  async destroyBiometricAuthenticate(t) {
    try {
      const e = await this.$templateUserToken.destroyBiometricAuthenticate(t);
      return this.$templateUserToken.destroy(), Promise.resolve(e);
    } catch (e) {
      return this.$templateUserToken.destroy(), Promise.reject(this.errorHandler(e));
    }
  },
  async requestWalletPayment(t) {
    try {
      const e = await this.$templateUserToken.requestWalletPayment(t);
      return this.$templateUserToken.destroy(), Promise.resolve(e);
    } catch (e) {
      return this.$templateUserToken.destroy(), Promise.reject(this.errorHandler(e));
    }
  },
  /**
   * 환경 설정
   * Comment by GOSOMI
   * @date: 2021-05-11
   * @param env: string
   * @param hostname: string | undefined
   * @returns void
   */
  setEnvironmentMode(t, e = void 0) {
    D.set(t), e !== void 0 && D.setDevelopmentHost(e);
  },
  /**
   * DeviceType을 설정
   * Comment by GOSOMI
   * @date: 2021-12-23
   * @param deviceType: string
   * @returns number
   */
  setDevice(t) {
    let e = te.PLATFORM.JS;
    switch (t.toUpperCase()) {
      case "IOS":
        e = te.PLATFORM.IOS;
        break;
      case "ANDROID":
        e = te.PLATFORM.ANDROID;
        break;
    }
    return this.$templateUserToken.setDevice(e);
  },
  /**
   * 이벤트 오류를 받아서 처리한다
   * Comment by GOSOMI
   * @date: 2021-05-12
   * @param e: any
   */
  errorHandler(t) {
    let e;
    switch (he.hideProgress(), t.name) {
      case "BootpayEventError":
        e = t.eventMessage;
        break;
      default:
        if (M(t.event))
          e = t;
        else
          throw t;
    }
    return e;
  },
  /**
   * 로그 레벨을 설정한다
   * Comment by GOSOMI
   * @date: 2021-05-12
   * @param level: number
   * @returns void
   */
  setLogLevel(t) {
    F.setLogLevel(t);
  },
  /**
   * UUID 설정
   * Comment by GOSOMI
   * @date: 2021-12-22
   * @param uuid: string
   * @returns string
   */
  setUUID(t) {
    return Te.setUUID(t);
  },
  /**
   * 결제창을 닫는다
   * Comment by GOSOMI
   * @date: 2021-12-29
   */
  dismiss() {
    ie.reject({
      event: "cancel",
      error_code: "RC_CLOSE_WINDOW",
      message: "사용자가 결제창을 닫았습니다."
    });
  }
};
typeof window < "u" && (window.BootpaySDK = Si);
var Bi = Ue();
const Or = /* @__PURE__ */ ze(Bi), br = {
  parameterPrefix: "__b_",
  // query string url 업데이트를 진행한다
  updateParameters({ parameters: t, replace: e }) {
    const r = new URL(window.location), s = Object.fromEntries(new URLSearchParams(location.search));
    Object.keys(s).forEach((n) => {
      n.match(this.parameterPrefix) ? r.searchParams.delete(n) : r.searchParams.set(n, s[n]);
    }), t && Object.keys(t).forEach((n) => {
      const i = `${this.parameterPrefix}${n}`;
      r.searchParams.set(i, t[n]);
    }), e ? window.history.replaceState(r.toString(), "", r.toString()) : window.history.pushState(t, "", r.toString());
  }
};
var ys = { exports: {} }, Kt = { exports: {} }, k0;
function gt() {
  return k0 || (k0 = 1, function(t, e) {
    (function(r, s) {
      t.exports = s(W());
    })(N, function(r) {
      return function(s) {
        var n = r, i = n.lib, x = i.Base, d = i.WordArray, p = n.x64 = {};
        p.Word = x.extend({
          /**
           * Initializes a newly created 64-bit word.
           *
           * @param {number} high The high 32 bits.
           * @param {number} low The low 32 bits.
           *
           * @example
           *
           *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
           */
          init: function(a, c) {
            this.high = a, this.low = c;
          }
          /**
           * Bitwise NOTs this word.
           *
           * @return {X64Word} A new x64-Word object after negating.
           *
           * @example
           *
           *     var negated = x64Word.not();
           */
          // not: function () {
          // var high = ~this.high;
          // var low = ~this.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ANDs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to AND with this word.
           *
           * @return {X64Word} A new x64-Word object after ANDing.
           *
           * @example
           *
           *     var anded = x64Word.and(anotherX64Word);
           */
          // and: function (word) {
          // var high = this.high & word.high;
          // var low = this.low & word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to OR with this word.
           *
           * @return {X64Word} A new x64-Word object after ORing.
           *
           * @example
           *
           *     var ored = x64Word.or(anotherX64Word);
           */
          // or: function (word) {
          // var high = this.high | word.high;
          // var low = this.low | word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise XORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to XOR with this word.
           *
           * @return {X64Word} A new x64-Word object after XORing.
           *
           * @example
           *
           *     var xored = x64Word.xor(anotherX64Word);
           */
          // xor: function (word) {
          // var high = this.high ^ word.high;
          // var low = this.low ^ word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the left.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftL(25);
           */
          // shiftL: function (n) {
          // if (n < 32) {
          // var high = (this.high << n) | (this.low >>> (32 - n));
          // var low = this.low << n;
          // } else {
          // var high = this.low << (n - 32);
          // var low = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the right.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftR(7);
           */
          // shiftR: function (n) {
          // if (n < 32) {
          // var low = (this.low >>> n) | (this.high << (32 - n));
          // var high = this.high >>> n;
          // } else {
          // var low = this.high >>> (n - 32);
          // var high = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Rotates this word n bits to the left.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotL(25);
           */
          // rotL: function (n) {
          // return this.shiftL(n).or(this.shiftR(64 - n));
          // },
          /**
           * Rotates this word n bits to the right.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotR(7);
           */
          // rotR: function (n) {
          // return this.shiftR(n).or(this.shiftL(64 - n));
          // },
          /**
           * Adds this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to add with this word.
           *
           * @return {X64Word} A new x64-Word object after adding.
           *
           * @example
           *
           *     var added = x64Word.add(anotherX64Word);
           */
          // add: function (word) {
          // var low = (this.low + word.low) | 0;
          // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
          // var high = (this.high + word.high + carry) | 0;
          // return X64Word.create(high, low);
          // }
        }), p.WordArray = x.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.x64.WordArray.create();
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ]);
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ], 10);
           */
          init: function(a, c) {
            a = this.words = a || [], c != s ? this.sigBytes = c : this.sigBytes = a.length * 8;
          },
          /**
           * Converts this 64-bit word array to a 32-bit word array.
           *
           * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
           *
           * @example
           *
           *     var x32WordArray = x64WordArray.toX32();
           */
          toX32: function() {
            for (var a = this.words, c = a.length, y = [], o = 0; o < c; o++) {
              var u = a[o];
              y.push(u.high), y.push(u.low);
            }
            return d.create(y, this.sigBytes);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {X64WordArray} The clone.
           *
           * @example
           *
           *     var clone = x64WordArray.clone();
           */
          clone: function() {
            for (var a = x.clone.call(this), c = a.words = this.words.slice(0), y = c.length, o = 0; o < y; o++)
              c[o] = c[o].clone();
            return a;
          }
        });
      }(), r;
    });
  }(Kt)), Kt.exports;
}
var Gt = { exports: {} }, S0;
function Pi() {
  return S0 || (S0 = 1, function(t, e) {
    (function(r, s) {
      t.exports = s(W());
    })(N, function(r) {
      return function() {
        if (typeof ArrayBuffer == "function") {
          var s = r, n = s.lib, i = n.WordArray, x = i.init, d = i.init = function(p) {
            if (p instanceof ArrayBuffer && (p = new Uint8Array(p)), (p instanceof Int8Array || typeof Uint8ClampedArray < "u" && p instanceof Uint8ClampedArray || p instanceof Int16Array || p instanceof Uint16Array || p instanceof Int32Array || p instanceof Uint32Array || p instanceof Float32Array || p instanceof Float64Array) && (p = new Uint8Array(p.buffer, p.byteOffset, p.byteLength)), p instanceof Uint8Array) {
              for (var a = p.byteLength, c = [], y = 0; y < a; y++)
                c[y >>> 2] |= p[y] << 24 - y % 4 * 8;
              x.call(this, c, a);
            } else
              x.apply(this, arguments);
          };
          d.prototype = i;
        }
      }(), r.lib.WordArray;
    });
  }(Gt)), Gt.exports;
}
var Xt = { exports: {} }, B0;
function Ii() {
  return B0 || (B0 = 1, function(t, e) {
    (function(r, s) {
      t.exports = s(W());
    })(N, function(r) {
      return function() {
        var s = r, n = s.lib, i = n.WordArray, x = s.enc;
        x.Utf16 = x.Utf16BE = {
          /**
           * Converts a word array to a UTF-16 BE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 BE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
           */
          stringify: function(p) {
            for (var a = p.words, c = p.sigBytes, y = [], o = 0; o < c; o += 2) {
              var u = a[o >>> 2] >>> 16 - o % 4 * 8 & 65535;
              y.push(String.fromCharCode(u));
            }
            return y.join("");
          },
          /**
           * Converts a UTF-16 BE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 BE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
           */
          parse: function(p) {
            for (var a = p.length, c = [], y = 0; y < a; y++)
              c[y >>> 1] |= p.charCodeAt(y) << 16 - y % 2 * 16;
            return i.create(c, a * 2);
          }
        }, x.Utf16LE = {
          /**
           * Converts a word array to a UTF-16 LE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 LE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
           */
          stringify: function(p) {
            for (var a = p.words, c = p.sigBytes, y = [], o = 0; o < c; o += 2) {
              var u = d(a[o >>> 2] >>> 16 - o % 4 * 8 & 65535);
              y.push(String.fromCharCode(u));
            }
            return y.join("");
          },
          /**
           * Converts a UTF-16 LE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 LE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
           */
          parse: function(p) {
            for (var a = p.length, c = [], y = 0; y < a; y++)
              c[y >>> 1] |= d(p.charCodeAt(y) << 16 - y % 2 * 16);
            return i.create(c, a * 2);
          }
        };
        function d(p) {
          return p << 8 & 4278255360 | p >>> 8 & 16711935;
        }
      }(), r.enc.Utf16;
    });
  }(Xt)), Xt.exports;
}
var Vt = { exports: {} }, P0;
function Ci() {
  return P0 || (P0 = 1, function(t, e) {
    (function(r, s) {
      t.exports = s(W());
    })(N, function(r) {
      return function() {
        var s = r, n = s.lib, i = n.WordArray, x = s.enc;
        x.Base64url = {
          /**
           * Converts a word array to a Base64url string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {string} The Base64url string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
           */
          stringify: function(p, a = !0) {
            var c = p.words, y = p.sigBytes, o = a ? this._safe_map : this._map;
            p.clamp();
            for (var u = [], h = 0; h < y; h += 3)
              for (var v = c[h >>> 2] >>> 24 - h % 4 * 8 & 255, g = c[h + 1 >>> 2] >>> 24 - (h + 1) % 4 * 8 & 255, $ = c[h + 2 >>> 2] >>> 24 - (h + 2) % 4 * 8 & 255, l = v << 16 | g << 8 | $, f = 0; f < 4 && h + f * 0.75 < y; f++)
                u.push(o.charAt(l >>> 6 * (3 - f) & 63));
            var m = o.charAt(64);
            if (m)
              for (; u.length % 4; )
                u.push(m);
            return u.join("");
          },
          /**
           * Converts a Base64url string to a word array.
           *
           * @param {string} base64Str The Base64url string.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
           */
          parse: function(p, a = !0) {
            var c = p.length, y = a ? this._safe_map : this._map, o = this._reverseMap;
            if (!o) {
              o = this._reverseMap = [];
              for (var u = 0; u < y.length; u++)
                o[y.charCodeAt(u)] = u;
            }
            var h = y.charAt(64);
            if (h) {
              var v = p.indexOf(h);
              v !== -1 && (c = v);
            }
            return d(p, c, o);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
          _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
        };
        function d(p, a, c) {
          for (var y = [], o = 0, u = 0; u < a; u++)
            if (u % 4) {
              var h = c[p.charCodeAt(u - 1)] << u % 4 * 2, v = c[p.charCodeAt(u)] >>> 6 - u % 4 * 2, g = h | v;
              y[o >>> 2] |= g << 24 - o % 4 * 8, o++;
            }
          return i.create(y, o);
        }
      }(), r.enc.Base64url;
    });
  }(Vt)), Vt.exports;
}
var Yt = { exports: {} }, I0;
function ms() {
  return I0 || (I0 = 1, function(t, e) {
    (function(r, s) {
      t.exports = s(W());
    })(N, function(r) {
      return function(s) {
        var n = r, i = n.lib, x = i.WordArray, d = i.Hasher, p = n.algo, a = [], c = [];
        (function() {
          function u($) {
            for (var l = s.sqrt($), f = 2; f <= l; f++)
              if (!($ % f))
                return !1;
            return !0;
          }
          function h($) {
            return ($ - ($ | 0)) * 4294967296 | 0;
          }
          for (var v = 2, g = 0; g < 64; )
            u(v) && (g < 8 && (a[g] = h(s.pow(v, 1 / 2))), c[g] = h(s.pow(v, 1 / 3)), g++), v++;
        })();
        var y = [], o = p.SHA256 = d.extend({
          _doReset: function() {
            this._hash = new x.init(a.slice(0));
          },
          _doProcessBlock: function(u, h) {
            for (var v = this._hash.words, g = v[0], $ = v[1], l = v[2], f = v[3], m = v[4], b = v[5], E = v[6], k = v[7], S = 0; S < 64; S++) {
              if (S < 16)
                y[S] = u[h + S] | 0;
              else {
                var A = y[S - 15], _ = (A << 25 | A >>> 7) ^ (A << 14 | A >>> 18) ^ A >>> 3, w = y[S - 2], B = (w << 15 | w >>> 17) ^ (w << 13 | w >>> 19) ^ w >>> 10;
                y[S] = _ + y[S - 7] + B + y[S - 16];
              }
              var I = m & b ^ ~m & E, O = g & $ ^ g & l ^ $ & l, U = (g << 30 | g >>> 2) ^ (g << 19 | g >>> 13) ^ (g << 10 | g >>> 22), H = (m << 26 | m >>> 6) ^ (m << 21 | m >>> 11) ^ (m << 7 | m >>> 25), Y = k + H + I + c[S] + y[S], j = U + O;
              k = E, E = b, b = m, m = f + Y | 0, f = l, l = $, $ = g, g = Y + j | 0;
            }
            v[0] = v[0] + g | 0, v[1] = v[1] + $ | 0, v[2] = v[2] + l | 0, v[3] = v[3] + f | 0, v[4] = v[4] + m | 0, v[5] = v[5] + b | 0, v[6] = v[6] + E | 0, v[7] = v[7] + k | 0;
          },
          _doFinalize: function() {
            var u = this._data, h = u.words, v = this._nDataBytes * 8, g = u.sigBytes * 8;
            return h[g >>> 5] |= 128 << 24 - g % 32, h[(g + 64 >>> 9 << 4) + 14] = s.floor(v / 4294967296), h[(g + 64 >>> 9 << 4) + 15] = v, u.sigBytes = h.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var u = d.clone.call(this);
            return u._hash = this._hash.clone(), u;
          }
        });
        n.SHA256 = d._createHelper(o), n.HmacSHA256 = d._createHmacHelper(o);
      }(Math), r.SHA256;
    });
  }(Yt)), Yt.exports;
}
var Jt = { exports: {} }, C0;
function Ti() {
  return C0 || (C0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), ms());
    })(N, function(r) {
      return function() {
        var s = r, n = s.lib, i = n.WordArray, x = s.algo, d = x.SHA256, p = x.SHA224 = d.extend({
          _doReset: function() {
            this._hash = new i.init([
              3238371032,
              914150663,
              812702999,
              4144912697,
              4290775857,
              1750603025,
              1694076839,
              3204075428
            ]);
          },
          _doFinalize: function() {
            var a = d._doFinalize.call(this);
            return a.sigBytes -= 4, a;
          }
        });
        s.SHA224 = d._createHelper(p), s.HmacSHA224 = d._createHmacHelper(p);
      }(), r.SHA224;
    });
  }(Jt)), Jt.exports;
}
var Zt = { exports: {} }, T0;
function gs() {
  return T0 || (T0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), gt());
    })(N, function(r) {
      return function() {
        var s = r, n = s.lib, i = n.Hasher, x = s.x64, d = x.Word, p = x.WordArray, a = s.algo;
        function c() {
          return d.create.apply(d, arguments);
        }
        var y = [
          c(1116352408, 3609767458),
          c(1899447441, 602891725),
          c(3049323471, 3964484399),
          c(3921009573, 2173295548),
          c(961987163, 4081628472),
          c(1508970993, 3053834265),
          c(2453635748, 2937671579),
          c(2870763221, 3664609560),
          c(3624381080, 2734883394),
          c(310598401, 1164996542),
          c(607225278, 1323610764),
          c(1426881987, 3590304994),
          c(1925078388, 4068182383),
          c(2162078206, 991336113),
          c(2614888103, 633803317),
          c(3248222580, 3479774868),
          c(3835390401, 2666613458),
          c(4022224774, 944711139),
          c(264347078, 2341262773),
          c(604807628, 2007800933),
          c(770255983, 1495990901),
          c(1249150122, 1856431235),
          c(1555081692, 3175218132),
          c(1996064986, 2198950837),
          c(2554220882, 3999719339),
          c(2821834349, 766784016),
          c(2952996808, 2566594879),
          c(3210313671, 3203337956),
          c(3336571891, 1034457026),
          c(3584528711, 2466948901),
          c(113926993, 3758326383),
          c(338241895, 168717936),
          c(666307205, 1188179964),
          c(773529912, 1546045734),
          c(1294757372, 1522805485),
          c(1396182291, 2643833823),
          c(1695183700, 2343527390),
          c(1986661051, 1014477480),
          c(2177026350, 1206759142),
          c(2456956037, 344077627),
          c(2730485921, 1290863460),
          c(2820302411, 3158454273),
          c(3259730800, 3505952657),
          c(3345764771, 106217008),
          c(3516065817, 3606008344),
          c(3600352804, 1432725776),
          c(4094571909, 1467031594),
          c(275423344, 851169720),
          c(430227734, 3100823752),
          c(506948616, 1363258195),
          c(659060556, 3750685593),
          c(883997877, 3785050280),
          c(958139571, 3318307427),
          c(1322822218, 3812723403),
          c(1537002063, 2003034995),
          c(1747873779, 3602036899),
          c(1955562222, 1575990012),
          c(2024104815, 1125592928),
          c(2227730452, 2716904306),
          c(2361852424, 442776044),
          c(2428436474, 593698344),
          c(2756734187, 3733110249),
          c(3204031479, 2999351573),
          c(3329325298, 3815920427),
          c(3391569614, 3928383900),
          c(3515267271, 566280711),
          c(3940187606, 3454069534),
          c(4118630271, 4000239992),
          c(116418474, 1914138554),
          c(174292421, 2731055270),
          c(289380356, 3203993006),
          c(460393269, 320620315),
          c(685471733, 587496836),
          c(852142971, 1086792851),
          c(1017036298, 365543100),
          c(1126000580, 2618297676),
          c(1288033470, 3409855158),
          c(1501505948, 4234509866),
          c(1607167915, 987167468),
          c(1816402316, 1246189591)
        ], o = [];
        (function() {
          for (var h = 0; h < 80; h++)
            o[h] = c();
        })();
        var u = a.SHA512 = i.extend({
          _doReset: function() {
            this._hash = new p.init([
              new d.init(1779033703, 4089235720),
              new d.init(3144134277, 2227873595),
              new d.init(1013904242, 4271175723),
              new d.init(2773480762, 1595750129),
              new d.init(1359893119, 2917565137),
              new d.init(2600822924, 725511199),
              new d.init(528734635, 4215389547),
              new d.init(1541459225, 327033209)
            ]);
          },
          _doProcessBlock: function(h, v) {
            for (var g = this._hash.words, $ = g[0], l = g[1], f = g[2], m = g[3], b = g[4], E = g[5], k = g[6], S = g[7], A = $.high, _ = $.low, w = l.high, B = l.low, I = f.high, O = f.low, U = m.high, H = m.low, Y = b.high, j = b.low, X = E.high, K = E.low, P = k.high, T = k.low, R = S.high, C = S.low, J = A, V = _, ne = w, L = B, Ke = I, Fe = O, bt = U, Ge = H, fe = Y, ce = j, at = X, Xe = K, ct = P, Ve = T, _t = R, Ye = C, xe = 0; xe < 80; xe++) {
              var ue, be, dt = o[xe];
              if (xe < 16)
                be = dt.high = h[v + xe * 2] | 0, ue = dt.low = h[v + xe * 2 + 1] | 0;
              else {
                var Ur = o[xe - 15], He = Ur.high, Je = Ur.low, $s = (He >>> 1 | Je << 31) ^ (He >>> 8 | Je << 24) ^ He >>> 7, Dr = (Je >>> 1 | He << 31) ^ (Je >>> 8 | He << 24) ^ (Je >>> 7 | He << 25), Fr = o[xe - 2], Me = Fr.high, Ze = Fr.low, Es = (Me >>> 19 | Ze << 13) ^ (Me << 3 | Ze >>> 29) ^ Me >>> 6, Hr = (Ze >>> 19 | Me << 13) ^ (Ze << 3 | Me >>> 29) ^ (Ze >>> 6 | Me << 26), Mr = o[xe - 7], ks = Mr.high, Ss = Mr.low, Nr = o[xe - 16], Bs = Nr.high, Lr = Nr.low;
                ue = Dr + Ss, be = $s + ks + (ue >>> 0 < Dr >>> 0 ? 1 : 0), ue = ue + Hr, be = be + Es + (ue >>> 0 < Hr >>> 0 ? 1 : 0), ue = ue + Lr, be = be + Bs + (ue >>> 0 < Lr >>> 0 ? 1 : 0), dt.high = be, dt.low = ue;
              }
              var Ps = fe & at ^ ~fe & ct, qr = ce & Xe ^ ~ce & Ve, Is = J & ne ^ J & Ke ^ ne & Ke, Cs = V & L ^ V & Fe ^ L & Fe, Ts = (J >>> 28 | V << 4) ^ (J << 30 | V >>> 2) ^ (J << 25 | V >>> 7), Wr = (V >>> 28 | J << 4) ^ (V << 30 | J >>> 2) ^ (V << 25 | J >>> 7), Rs = (fe >>> 14 | ce << 18) ^ (fe >>> 18 | ce << 14) ^ (fe << 23 | ce >>> 9), As = (ce >>> 14 | fe << 18) ^ (ce >>> 18 | fe << 14) ^ (ce << 23 | fe >>> 9), zr = y[xe], Os = zr.high, jr = zr.low, de = Ye + As, _e = _t + Rs + (de >>> 0 < Ye >>> 0 ? 1 : 0), de = de + qr, _e = _e + Ps + (de >>> 0 < qr >>> 0 ? 1 : 0), de = de + jr, _e = _e + Os + (de >>> 0 < jr >>> 0 ? 1 : 0), de = de + ue, _e = _e + be + (de >>> 0 < ue >>> 0 ? 1 : 0), Kr = Wr + Cs, Us = Ts + Is + (Kr >>> 0 < Wr >>> 0 ? 1 : 0);
              _t = ct, Ye = Ve, ct = at, Ve = Xe, at = fe, Xe = ce, ce = Ge + de | 0, fe = bt + _e + (ce >>> 0 < Ge >>> 0 ? 1 : 0) | 0, bt = Ke, Ge = Fe, Ke = ne, Fe = L, ne = J, L = V, V = de + Kr | 0, J = _e + Us + (V >>> 0 < de >>> 0 ? 1 : 0) | 0;
            }
            _ = $.low = _ + V, $.high = A + J + (_ >>> 0 < V >>> 0 ? 1 : 0), B = l.low = B + L, l.high = w + ne + (B >>> 0 < L >>> 0 ? 1 : 0), O = f.low = O + Fe, f.high = I + Ke + (O >>> 0 < Fe >>> 0 ? 1 : 0), H = m.low = H + Ge, m.high = U + bt + (H >>> 0 < Ge >>> 0 ? 1 : 0), j = b.low = j + ce, b.high = Y + fe + (j >>> 0 < ce >>> 0 ? 1 : 0), K = E.low = K + Xe, E.high = X + at + (K >>> 0 < Xe >>> 0 ? 1 : 0), T = k.low = T + Ve, k.high = P + ct + (T >>> 0 < Ve >>> 0 ? 1 : 0), C = S.low = C + Ye, S.high = R + _t + (C >>> 0 < Ye >>> 0 ? 1 : 0);
          },
          _doFinalize: function() {
            var h = this._data, v = h.words, g = this._nDataBytes * 8, $ = h.sigBytes * 8;
            v[$ >>> 5] |= 128 << 24 - $ % 32, v[($ + 128 >>> 10 << 5) + 30] = Math.floor(g / 4294967296), v[($ + 128 >>> 10 << 5) + 31] = g, h.sigBytes = v.length * 4, this._process();
            var l = this._hash.toX32();
            return l;
          },
          clone: function() {
            var h = i.clone.call(this);
            return h._hash = this._hash.clone(), h;
          },
          blockSize: 1024 / 32
        });
        s.SHA512 = i._createHelper(u), s.HmacSHA512 = i._createHmacHelper(u);
      }(), r.SHA512;
    });
  }(Zt)), Zt.exports;
}
var Qt = { exports: {} }, R0;
function Ri() {
  return R0 || (R0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), gt(), gs());
    })(N, function(r) {
      return function() {
        var s = r, n = s.x64, i = n.Word, x = n.WordArray, d = s.algo, p = d.SHA512, a = d.SHA384 = p.extend({
          _doReset: function() {
            this._hash = new x.init([
              new i.init(3418070365, 3238371032),
              new i.init(1654270250, 914150663),
              new i.init(2438529370, 812702999),
              new i.init(355462360, 4144912697),
              new i.init(1731405415, 4290775857),
              new i.init(2394180231, 1750603025),
              new i.init(3675008525, 1694076839),
              new i.init(1203062813, 3204075428)
            ]);
          },
          _doFinalize: function() {
            var c = p._doFinalize.call(this);
            return c.sigBytes -= 16, c;
          }
        });
        s.SHA384 = p._createHelper(a), s.HmacSHA384 = p._createHmacHelper(a);
      }(), r.SHA384;
    });
  }(Qt)), Qt.exports;
}
var er = { exports: {} }, A0;
function Ai() {
  return A0 || (A0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), gt());
    })(N, function(r) {
      return function(s) {
        var n = r, i = n.lib, x = i.WordArray, d = i.Hasher, p = n.x64, a = p.Word, c = n.algo, y = [], o = [], u = [];
        (function() {
          for (var g = 1, $ = 0, l = 0; l < 24; l++) {
            y[g + 5 * $] = (l + 1) * (l + 2) / 2 % 64;
            var f = $ % 5, m = (2 * g + 3 * $) % 5;
            g = f, $ = m;
          }
          for (var g = 0; g < 5; g++)
            for (var $ = 0; $ < 5; $++)
              o[g + 5 * $] = $ + (2 * g + 3 * $) % 5 * 5;
          for (var b = 1, E = 0; E < 24; E++) {
            for (var k = 0, S = 0, A = 0; A < 7; A++) {
              if (b & 1) {
                var _ = (1 << A) - 1;
                _ < 32 ? S ^= 1 << _ : k ^= 1 << _ - 32;
              }
              b & 128 ? b = b << 1 ^ 113 : b <<= 1;
            }
            u[E] = a.create(k, S);
          }
        })();
        var h = [];
        (function() {
          for (var g = 0; g < 25; g++)
            h[g] = a.create();
        })();
        var v = c.SHA3 = d.extend({
          /**
           * Configuration options.
           *
           * @property {number} outputLength
           *   The desired number of bits in the output hash.
           *   Only values permitted are: 224, 256, 384, 512.
           *   Default: 512
           */
          cfg: d.cfg.extend({
            outputLength: 512
          }),
          _doReset: function() {
            for (var g = this._state = [], $ = 0; $ < 25; $++)
              g[$] = new a.init();
            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
          },
          _doProcessBlock: function(g, $) {
            for (var l = this._state, f = this.blockSize / 2, m = 0; m < f; m++) {
              var b = g[$ + 2 * m], E = g[$ + 2 * m + 1];
              b = (b << 8 | b >>> 24) & 16711935 | (b << 24 | b >>> 8) & 4278255360, E = (E << 8 | E >>> 24) & 16711935 | (E << 24 | E >>> 8) & 4278255360;
              var k = l[m];
              k.high ^= E, k.low ^= b;
            }
            for (var S = 0; S < 24; S++) {
              for (var A = 0; A < 5; A++) {
                for (var _ = 0, w = 0, B = 0; B < 5; B++) {
                  var k = l[A + 5 * B];
                  _ ^= k.high, w ^= k.low;
                }
                var I = h[A];
                I.high = _, I.low = w;
              }
              for (var A = 0; A < 5; A++)
                for (var O = h[(A + 4) % 5], U = h[(A + 1) % 5], H = U.high, Y = U.low, _ = O.high ^ (H << 1 | Y >>> 31), w = O.low ^ (Y << 1 | H >>> 31), B = 0; B < 5; B++) {
                  var k = l[A + 5 * B];
                  k.high ^= _, k.low ^= w;
                }
              for (var j = 1; j < 25; j++) {
                var _, w, k = l[j], X = k.high, K = k.low, P = y[j];
                P < 32 ? (_ = X << P | K >>> 32 - P, w = K << P | X >>> 32 - P) : (_ = K << P - 32 | X >>> 64 - P, w = X << P - 32 | K >>> 64 - P);
                var T = h[o[j]];
                T.high = _, T.low = w;
              }
              var R = h[0], C = l[0];
              R.high = C.high, R.low = C.low;
              for (var A = 0; A < 5; A++)
                for (var B = 0; B < 5; B++) {
                  var j = A + 5 * B, k = l[j], J = h[j], V = h[(A + 1) % 5 + 5 * B], ne = h[(A + 2) % 5 + 5 * B];
                  k.high = J.high ^ ~V.high & ne.high, k.low = J.low ^ ~V.low & ne.low;
                }
              var k = l[0], L = u[S];
              k.high ^= L.high, k.low ^= L.low;
            }
          },
          _doFinalize: function() {
            var g = this._data, $ = g.words;
            this._nDataBytes * 8;
            var l = g.sigBytes * 8, f = this.blockSize * 32;
            $[l >>> 5] |= 1 << 24 - l % 32, $[(s.ceil((l + 1) / f) * f >>> 5) - 1] |= 128, g.sigBytes = $.length * 4, this._process();
            for (var m = this._state, b = this.cfg.outputLength / 8, E = b / 8, k = [], S = 0; S < E; S++) {
              var A = m[S], _ = A.high, w = A.low;
              _ = (_ << 8 | _ >>> 24) & 16711935 | (_ << 24 | _ >>> 8) & 4278255360, w = (w << 8 | w >>> 24) & 16711935 | (w << 24 | w >>> 8) & 4278255360, k.push(w), k.push(_);
            }
            return new x.init(k, b);
          },
          clone: function() {
            for (var g = d.clone.call(this), $ = g._state = this._state.slice(0), l = 0; l < 25; l++)
              $[l] = $[l].clone();
            return g;
          }
        });
        n.SHA3 = d._createHelper(v), n.HmacSHA3 = d._createHmacHelper(v);
      }(Math), r.SHA3;
    });
  }(er)), er.exports;
}
var tr = { exports: {} }, O0;
function Oi() {
  return O0 || (O0 = 1, function(t, e) {
    (function(r, s) {
      t.exports = s(W());
    })(N, function(r) {
      /** @preserve
      			(c) 2012 by Cédric Mesnil. All rights reserved.
      
      			Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
      
      			    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
      			    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
      
      			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      			*/
      return function(s) {
        var n = r, i = n.lib, x = i.WordArray, d = i.Hasher, p = n.algo, a = x.create([
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          7,
          4,
          13,
          1,
          10,
          6,
          15,
          3,
          12,
          0,
          9,
          5,
          2,
          14,
          11,
          8,
          3,
          10,
          14,
          4,
          9,
          15,
          8,
          1,
          2,
          7,
          0,
          6,
          13,
          11,
          5,
          12,
          1,
          9,
          11,
          10,
          0,
          8,
          12,
          4,
          13,
          3,
          7,
          15,
          14,
          5,
          6,
          2,
          4,
          0,
          5,
          9,
          7,
          12,
          2,
          10,
          14,
          1,
          3,
          8,
          11,
          6,
          15,
          13
        ]), c = x.create([
          5,
          14,
          7,
          0,
          9,
          2,
          11,
          4,
          13,
          6,
          15,
          8,
          1,
          10,
          3,
          12,
          6,
          11,
          3,
          7,
          0,
          13,
          5,
          10,
          14,
          15,
          8,
          12,
          4,
          9,
          1,
          2,
          15,
          5,
          1,
          3,
          7,
          14,
          6,
          9,
          11,
          8,
          12,
          2,
          10,
          0,
          4,
          13,
          8,
          6,
          4,
          1,
          3,
          11,
          15,
          0,
          5,
          12,
          2,
          13,
          9,
          7,
          10,
          14,
          12,
          15,
          10,
          4,
          1,
          5,
          8,
          7,
          6,
          2,
          13,
          14,
          0,
          3,
          9,
          11
        ]), y = x.create([
          11,
          14,
          15,
          12,
          5,
          8,
          7,
          9,
          11,
          13,
          14,
          15,
          6,
          7,
          9,
          8,
          7,
          6,
          8,
          13,
          11,
          9,
          7,
          15,
          7,
          12,
          15,
          9,
          11,
          7,
          13,
          12,
          11,
          13,
          6,
          7,
          14,
          9,
          13,
          15,
          14,
          8,
          13,
          6,
          5,
          12,
          7,
          5,
          11,
          12,
          14,
          15,
          14,
          15,
          9,
          8,
          9,
          14,
          5,
          6,
          8,
          6,
          5,
          12,
          9,
          15,
          5,
          11,
          6,
          8,
          13,
          12,
          5,
          12,
          13,
          14,
          11,
          8,
          5,
          6
        ]), o = x.create([
          8,
          9,
          9,
          11,
          13,
          15,
          15,
          5,
          7,
          7,
          8,
          11,
          14,
          14,
          12,
          6,
          9,
          13,
          15,
          7,
          12,
          8,
          9,
          11,
          7,
          7,
          12,
          7,
          6,
          15,
          13,
          11,
          9,
          7,
          15,
          11,
          8,
          6,
          6,
          14,
          12,
          13,
          5,
          14,
          13,
          13,
          7,
          5,
          15,
          5,
          8,
          11,
          14,
          14,
          6,
          14,
          6,
          9,
          12,
          9,
          12,
          5,
          15,
          8,
          8,
          5,
          12,
          9,
          12,
          5,
          14,
          6,
          8,
          13,
          6,
          5,
          15,
          13,
          11,
          11
        ]), u = x.create([0, 1518500249, 1859775393, 2400959708, 2840853838]), h = x.create([1352829926, 1548603684, 1836072691, 2053994217, 0]), v = p.RIPEMD160 = d.extend({
          _doReset: function() {
            this._hash = x.create([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
          },
          _doProcessBlock: function(E, k) {
            for (var S = 0; S < 16; S++) {
              var A = k + S, _ = E[A];
              E[A] = (_ << 8 | _ >>> 24) & 16711935 | (_ << 24 | _ >>> 8) & 4278255360;
            }
            var w = this._hash.words, B = u.words, I = h.words, O = a.words, U = c.words, H = y.words, Y = o.words, j, X, K, P, T, R, C, J, V, ne;
            R = j = w[0], C = X = w[1], J = K = w[2], V = P = w[3], ne = T = w[4];
            for (var L, S = 0; S < 80; S += 1)
              L = j + E[k + O[S]] | 0, S < 16 ? L += g(X, K, P) + B[0] : S < 32 ? L += $(X, K, P) + B[1] : S < 48 ? L += l(X, K, P) + B[2] : S < 64 ? L += f(X, K, P) + B[3] : L += m(X, K, P) + B[4], L = L | 0, L = b(L, H[S]), L = L + T | 0, j = T, T = P, P = b(K, 10), K = X, X = L, L = R + E[k + U[S]] | 0, S < 16 ? L += m(C, J, V) + I[0] : S < 32 ? L += f(C, J, V) + I[1] : S < 48 ? L += l(C, J, V) + I[2] : S < 64 ? L += $(C, J, V) + I[3] : L += g(C, J, V) + I[4], L = L | 0, L = b(L, Y[S]), L = L + ne | 0, R = ne, ne = V, V = b(J, 10), J = C, C = L;
            L = w[1] + K + V | 0, w[1] = w[2] + P + ne | 0, w[2] = w[3] + T + R | 0, w[3] = w[4] + j + C | 0, w[4] = w[0] + X + J | 0, w[0] = L;
          },
          _doFinalize: function() {
            var E = this._data, k = E.words, S = this._nDataBytes * 8, A = E.sigBytes * 8;
            k[A >>> 5] |= 128 << 24 - A % 32, k[(A + 64 >>> 9 << 4) + 14] = (S << 8 | S >>> 24) & 16711935 | (S << 24 | S >>> 8) & 4278255360, E.sigBytes = (k.length + 1) * 4, this._process();
            for (var _ = this._hash, w = _.words, B = 0; B < 5; B++) {
              var I = w[B];
              w[B] = (I << 8 | I >>> 24) & 16711935 | (I << 24 | I >>> 8) & 4278255360;
            }
            return _;
          },
          clone: function() {
            var E = d.clone.call(this);
            return E._hash = this._hash.clone(), E;
          }
        });
        function g(E, k, S) {
          return E ^ k ^ S;
        }
        function $(E, k, S) {
          return E & k | ~E & S;
        }
        function l(E, k, S) {
          return (E | ~k) ^ S;
        }
        function f(E, k, S) {
          return E & S | k & ~S;
        }
        function m(E, k, S) {
          return E ^ (k | ~S);
        }
        function b(E, k) {
          return E << k | E >>> 32 - k;
        }
        n.RIPEMD160 = d._createHelper(v), n.HmacRIPEMD160 = d._createHmacHelper(v);
      }(), r.RIPEMD160;
    });
  }(tr)), tr.exports;
}
var rr = { exports: {} }, U0;
function Ui() {
  return U0 || (U0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), Tr(), Rr());
    })(N, function(r) {
      return function() {
        var s = r, n = s.lib, i = n.Base, x = n.WordArray, d = s.algo, p = d.SHA1, a = d.HMAC, c = d.PBKDF2 = i.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hasher to use. Default: SHA1
           * @property {number} iterations The number of iterations to perform. Default: 1
           */
          cfg: i.extend({
            keySize: 128 / 32,
            hasher: p,
            iterations: 1
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.PBKDF2.create();
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
           */
          init: function(y) {
            this.cfg = this.cfg.extend(y);
          },
          /**
           * Computes the Password-Based Key Derivation Function 2.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(y, o) {
            for (var u = this.cfg, h = a.create(u.hasher, y), v = x.create(), g = x.create([1]), $ = v.words, l = g.words, f = u.keySize, m = u.iterations; $.length < f; ) {
              var b = h.update(o).finalize(g);
              h.reset();
              for (var E = b.words, k = E.length, S = b, A = 1; A < m; A++) {
                S = h.finalize(S), h.reset();
                for (var _ = S.words, w = 0; w < k; w++)
                  E[w] ^= _[w];
              }
              v.concat(b), l[0]++;
            }
            return v.sigBytes = f * 4, v;
          }
        });
        s.PBKDF2 = function(y, o, u) {
          return c.create(u).compute(y, o);
        };
      }(), r.PBKDF2;
    });
  }(rr)), rr.exports;
}
var sr = { exports: {} }, D0;
function Di() {
  return D0 || (D0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), ee());
    })(N, function(r) {
      return r.mode.CFB = function() {
        var s = r.lib.BlockCipherMode.extend();
        s.Encryptor = s.extend({
          processBlock: function(i, x) {
            var d = this._cipher, p = d.blockSize;
            n.call(this, i, x, p, d), this._prevBlock = i.slice(x, x + p);
          }
        }), s.Decryptor = s.extend({
          processBlock: function(i, x) {
            var d = this._cipher, p = d.blockSize, a = i.slice(x, x + p);
            n.call(this, i, x, p, d), this._prevBlock = a;
          }
        });
        function n(i, x, d, p) {
          var a, c = this._iv;
          c ? (a = c.slice(0), this._iv = void 0) : a = this._prevBlock, p.encryptBlock(a, 0);
          for (var y = 0; y < d; y++)
            i[x + y] ^= a[y];
        }
        return s;
      }(), r.mode.CFB;
    });
  }(sr)), sr.exports;
}
var nr = { exports: {} }, F0;
function Fi() {
  return F0 || (F0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), ee());
    })(N, function(r) {
      return r.mode.CTR = function() {
        var s = r.lib.BlockCipherMode.extend(), n = s.Encryptor = s.extend({
          processBlock: function(i, x) {
            var d = this._cipher, p = d.blockSize, a = this._iv, c = this._counter;
            a && (c = this._counter = a.slice(0), this._iv = void 0);
            var y = c.slice(0);
            d.encryptBlock(y, 0), c[p - 1] = c[p - 1] + 1 | 0;
            for (var o = 0; o < p; o++)
              i[x + o] ^= y[o];
          }
        });
        return s.Decryptor = n, s;
      }(), r.mode.CTR;
    });
  }(nr)), nr.exports;
}
var ir = { exports: {} }, H0;
function Hi() {
  return H0 || (H0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), ee());
    })(N, function(r) {
      /** @preserve
       * Counter block mode compatible with  Dr Brian Gladman fileenc.c
       * derived from CryptoJS.mode.CTR
       * Jan Hruby jhruby.web@gmail.com
       */
      return r.mode.CTRGladman = function() {
        var s = r.lib.BlockCipherMode.extend();
        function n(d) {
          if ((d >> 24 & 255) === 255) {
            var p = d >> 16 & 255, a = d >> 8 & 255, c = d & 255;
            p === 255 ? (p = 0, a === 255 ? (a = 0, c === 255 ? c = 0 : ++c) : ++a) : ++p, d = 0, d += p << 16, d += a << 8, d += c;
          } else
            d += 1 << 24;
          return d;
        }
        function i(d) {
          return (d[0] = n(d[0])) === 0 && (d[1] = n(d[1])), d;
        }
        var x = s.Encryptor = s.extend({
          processBlock: function(d, p) {
            var a = this._cipher, c = a.blockSize, y = this._iv, o = this._counter;
            y && (o = this._counter = y.slice(0), this._iv = void 0), i(o);
            var u = o.slice(0);
            a.encryptBlock(u, 0);
            for (var h = 0; h < c; h++)
              d[p + h] ^= u[h];
          }
        });
        return s.Decryptor = x, s;
      }(), r.mode.CTRGladman;
    });
  }(ir)), ir.exports;
}
var or = { exports: {} }, M0;
function Mi() {
  return M0 || (M0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), ee());
    })(N, function(r) {
      return r.mode.OFB = function() {
        var s = r.lib.BlockCipherMode.extend(), n = s.Encryptor = s.extend({
          processBlock: function(i, x) {
            var d = this._cipher, p = d.blockSize, a = this._iv, c = this._keystream;
            a && (c = this._keystream = a.slice(0), this._iv = void 0), d.encryptBlock(c, 0);
            for (var y = 0; y < p; y++)
              i[x + y] ^= c[y];
          }
        });
        return s.Decryptor = n, s;
      }(), r.mode.OFB;
    });
  }(or)), or.exports;
}
var ar = { exports: {} }, N0;
function Ni() {
  return N0 || (N0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), ee());
    })(N, function(r) {
      return r.mode.ECB = function() {
        var s = r.lib.BlockCipherMode.extend();
        return s.Encryptor = s.extend({
          processBlock: function(n, i) {
            this._cipher.encryptBlock(n, i);
          }
        }), s.Decryptor = s.extend({
          processBlock: function(n, i) {
            this._cipher.decryptBlock(n, i);
          }
        }), s;
      }(), r.mode.ECB;
    });
  }(ar)), ar.exports;
}
var cr = { exports: {} }, L0;
function Li() {
  return L0 || (L0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), ee());
    })(N, function(r) {
      return r.pad.AnsiX923 = {
        pad: function(s, n) {
          var i = s.sigBytes, x = n * 4, d = x - i % x, p = i + d - 1;
          s.clamp(), s.words[p >>> 2] |= d << 24 - p % 4 * 8, s.sigBytes += d;
        },
        unpad: function(s) {
          var n = s.words[s.sigBytes - 1 >>> 2] & 255;
          s.sigBytes -= n;
        }
      }, r.pad.Ansix923;
    });
  }(cr)), cr.exports;
}
var dr = { exports: {} }, q0;
function qi() {
  return q0 || (q0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), ee());
    })(N, function(r) {
      return r.pad.Iso10126 = {
        pad: function(s, n) {
          var i = n * 4, x = i - s.sigBytes % i;
          s.concat(r.lib.WordArray.random(x - 1)).concat(r.lib.WordArray.create([x << 24], 1));
        },
        unpad: function(s) {
          var n = s.words[s.sigBytes - 1 >>> 2] & 255;
          s.sigBytes -= n;
        }
      }, r.pad.Iso10126;
    });
  }(dr)), dr.exports;
}
var lr = { exports: {} }, W0;
function Wi() {
  return W0 || (W0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), ee());
    })(N, function(r) {
      return r.pad.Iso97971 = {
        pad: function(s, n) {
          s.concat(r.lib.WordArray.create([2147483648], 1)), r.pad.ZeroPadding.pad(s, n);
        },
        unpad: function(s) {
          r.pad.ZeroPadding.unpad(s), s.sigBytes--;
        }
      }, r.pad.Iso97971;
    });
  }(lr)), lr.exports;
}
var ur = { exports: {} }, z0;
function zi() {
  return z0 || (z0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), ee());
    })(N, function(r) {
      return r.pad.ZeroPadding = {
        pad: function(s, n) {
          var i = n * 4;
          s.clamp(), s.sigBytes += i - (s.sigBytes % i || i);
        },
        unpad: function(s) {
          for (var n = s.words, i = s.sigBytes - 1, i = s.sigBytes - 1; i >= 0; i--)
            if (n[i >>> 2] >>> 24 - i % 4 * 8 & 255) {
              s.sigBytes = i + 1;
              break;
            }
        }
      }, r.pad.ZeroPadding;
    });
  }(ur)), ur.exports;
}
var pr = { exports: {} }, j0;
function ji() {
  return j0 || (j0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), ee());
    })(N, function(r) {
      return r.pad.NoPadding = {
        pad: function() {
        },
        unpad: function() {
        }
      }, r.pad.NoPadding;
    });
  }(pr)), pr.exports;
}
var hr = { exports: {} }, K0;
function Ki() {
  return K0 || (K0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), ee());
    })(N, function(r) {
      return function(s) {
        var n = r, i = n.lib, x = i.CipherParams, d = n.enc, p = d.Hex, a = n.format;
        a.Hex = {
          /**
           * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The hexadecimally encoded string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
           */
          stringify: function(c) {
            return c.ciphertext.toString(p);
          },
          /**
           * Converts a hexadecimally encoded ciphertext string to a cipher params object.
           *
           * @param {string} input The hexadecimally encoded string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
           */
          parse: function(c) {
            var y = p.parse(c);
            return x.create({ ciphertext: y });
          }
        };
      }(), r.format.Hex;
    });
  }(hr)), hr.exports;
}
var fr = { exports: {} }, G0;
function Gi() {
  return G0 || (G0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), Re(), Ue(), De(), ee());
    })(N, function(r) {
      return function() {
        var s = r, n = s.lib, i = n.WordArray, x = n.BlockCipher, d = s.algo, p = [
          57,
          49,
          41,
          33,
          25,
          17,
          9,
          1,
          58,
          50,
          42,
          34,
          26,
          18,
          10,
          2,
          59,
          51,
          43,
          35,
          27,
          19,
          11,
          3,
          60,
          52,
          44,
          36,
          63,
          55,
          47,
          39,
          31,
          23,
          15,
          7,
          62,
          54,
          46,
          38,
          30,
          22,
          14,
          6,
          61,
          53,
          45,
          37,
          29,
          21,
          13,
          5,
          28,
          20,
          12,
          4
        ], a = [
          14,
          17,
          11,
          24,
          1,
          5,
          3,
          28,
          15,
          6,
          21,
          10,
          23,
          19,
          12,
          4,
          26,
          8,
          16,
          7,
          27,
          20,
          13,
          2,
          41,
          52,
          31,
          37,
          47,
          55,
          30,
          40,
          51,
          45,
          33,
          48,
          44,
          49,
          39,
          56,
          34,
          53,
          46,
          42,
          50,
          36,
          29,
          32
        ], c = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28], y = [
          {
            0: 8421888,
            268435456: 32768,
            536870912: 8421378,
            805306368: 2,
            1073741824: 512,
            1342177280: 8421890,
            1610612736: 8389122,
            1879048192: 8388608,
            2147483648: 514,
            2415919104: 8389120,
            2684354560: 33280,
            2952790016: 8421376,
            3221225472: 32770,
            3489660928: 8388610,
            3758096384: 0,
            4026531840: 33282,
            134217728: 0,
            402653184: 8421890,
            671088640: 33282,
            939524096: 32768,
            1207959552: 8421888,
            1476395008: 512,
            1744830464: 8421378,
            2013265920: 2,
            2281701376: 8389120,
            2550136832: 33280,
            2818572288: 8421376,
            3087007744: 8389122,
            3355443200: 8388610,
            3623878656: 32770,
            3892314112: 514,
            4160749568: 8388608,
            1: 32768,
            268435457: 2,
            536870913: 8421888,
            805306369: 8388608,
            1073741825: 8421378,
            1342177281: 33280,
            1610612737: 512,
            1879048193: 8389122,
            2147483649: 8421890,
            2415919105: 8421376,
            2684354561: 8388610,
            2952790017: 33282,
            3221225473: 514,
            3489660929: 8389120,
            3758096385: 32770,
            4026531841: 0,
            134217729: 8421890,
            402653185: 8421376,
            671088641: 8388608,
            939524097: 512,
            1207959553: 32768,
            1476395009: 8388610,
            1744830465: 2,
            2013265921: 33282,
            2281701377: 32770,
            2550136833: 8389122,
            2818572289: 514,
            3087007745: 8421888,
            3355443201: 8389120,
            3623878657: 0,
            3892314113: 33280,
            4160749569: 8421378
          },
          {
            0: 1074282512,
            16777216: 16384,
            33554432: 524288,
            50331648: 1074266128,
            67108864: 1073741840,
            83886080: 1074282496,
            100663296: 1073758208,
            117440512: 16,
            134217728: 540672,
            150994944: 1073758224,
            167772160: 1073741824,
            184549376: 540688,
            201326592: 524304,
            218103808: 0,
            234881024: 16400,
            251658240: 1074266112,
            8388608: 1073758208,
            25165824: 540688,
            41943040: 16,
            58720256: 1073758224,
            75497472: 1074282512,
            92274688: 1073741824,
            109051904: 524288,
            125829120: 1074266128,
            142606336: 524304,
            159383552: 0,
            176160768: 16384,
            192937984: 1074266112,
            209715200: 1073741840,
            226492416: 540672,
            243269632: 1074282496,
            260046848: 16400,
            268435456: 0,
            285212672: 1074266128,
            301989888: 1073758224,
            318767104: 1074282496,
            335544320: 1074266112,
            352321536: 16,
            369098752: 540688,
            385875968: 16384,
            402653184: 16400,
            419430400: 524288,
            436207616: 524304,
            452984832: 1073741840,
            469762048: 540672,
            486539264: 1073758208,
            503316480: 1073741824,
            520093696: 1074282512,
            276824064: 540688,
            293601280: 524288,
            310378496: 1074266112,
            327155712: 16384,
            343932928: 1073758208,
            360710144: 1074282512,
            377487360: 16,
            394264576: 1073741824,
            411041792: 1074282496,
            427819008: 1073741840,
            444596224: 1073758224,
            461373440: 524304,
            478150656: 0,
            494927872: 16400,
            511705088: 1074266128,
            528482304: 540672
          },
          {
            0: 260,
            1048576: 0,
            2097152: 67109120,
            3145728: 65796,
            4194304: 65540,
            5242880: 67108868,
            6291456: 67174660,
            7340032: 67174400,
            8388608: 67108864,
            9437184: 67174656,
            10485760: 65792,
            11534336: 67174404,
            12582912: 67109124,
            13631488: 65536,
            14680064: 4,
            15728640: 256,
            524288: 67174656,
            1572864: 67174404,
            2621440: 0,
            3670016: 67109120,
            4718592: 67108868,
            5767168: 65536,
            6815744: 65540,
            7864320: 260,
            8912896: 4,
            9961472: 256,
            11010048: 67174400,
            12058624: 65796,
            13107200: 65792,
            14155776: 67109124,
            15204352: 67174660,
            16252928: 67108864,
            16777216: 67174656,
            17825792: 65540,
            18874368: 65536,
            19922944: 67109120,
            20971520: 256,
            22020096: 67174660,
            23068672: 67108868,
            24117248: 0,
            25165824: 67109124,
            26214400: 67108864,
            27262976: 4,
            28311552: 65792,
            29360128: 67174400,
            30408704: 260,
            31457280: 65796,
            32505856: 67174404,
            17301504: 67108864,
            18350080: 260,
            19398656: 67174656,
            20447232: 0,
            21495808: 65540,
            22544384: 67109120,
            23592960: 256,
            24641536: 67174404,
            25690112: 65536,
            26738688: 67174660,
            27787264: 65796,
            28835840: 67108868,
            29884416: 67109124,
            30932992: 67174400,
            31981568: 4,
            33030144: 65792
          },
          {
            0: 2151682048,
            65536: 2147487808,
            131072: 4198464,
            196608: 2151677952,
            262144: 0,
            327680: 4198400,
            393216: 2147483712,
            458752: 4194368,
            524288: 2147483648,
            589824: 4194304,
            655360: 64,
            720896: 2147487744,
            786432: 2151678016,
            851968: 4160,
            917504: 4096,
            983040: 2151682112,
            32768: 2147487808,
            98304: 64,
            163840: 2151678016,
            229376: 2147487744,
            294912: 4198400,
            360448: 2151682112,
            425984: 0,
            491520: 2151677952,
            557056: 4096,
            622592: 2151682048,
            688128: 4194304,
            753664: 4160,
            819200: 2147483648,
            884736: 4194368,
            950272: 4198464,
            1015808: 2147483712,
            1048576: 4194368,
            1114112: 4198400,
            1179648: 2147483712,
            1245184: 0,
            1310720: 4160,
            1376256: 2151678016,
            1441792: 2151682048,
            1507328: 2147487808,
            1572864: 2151682112,
            1638400: 2147483648,
            1703936: 2151677952,
            1769472: 4198464,
            1835008: 2147487744,
            1900544: 4194304,
            1966080: 64,
            2031616: 4096,
            1081344: 2151677952,
            1146880: 2151682112,
            1212416: 0,
            1277952: 4198400,
            1343488: 4194368,
            1409024: 2147483648,
            1474560: 2147487808,
            1540096: 64,
            1605632: 2147483712,
            1671168: 4096,
            1736704: 2147487744,
            1802240: 2151678016,
            1867776: 4160,
            1933312: 2151682048,
            1998848: 4194304,
            2064384: 4198464
          },
          {
            0: 128,
            4096: 17039360,
            8192: 262144,
            12288: 536870912,
            16384: 537133184,
            20480: 16777344,
            24576: 553648256,
            28672: 262272,
            32768: 16777216,
            36864: 537133056,
            40960: 536871040,
            45056: 553910400,
            49152: 553910272,
            53248: 0,
            57344: 17039488,
            61440: 553648128,
            2048: 17039488,
            6144: 553648256,
            10240: 128,
            14336: 17039360,
            18432: 262144,
            22528: 537133184,
            26624: 553910272,
            30720: 536870912,
            34816: 537133056,
            38912: 0,
            43008: 553910400,
            47104: 16777344,
            51200: 536871040,
            55296: 553648128,
            59392: 16777216,
            63488: 262272,
            65536: 262144,
            69632: 128,
            73728: 536870912,
            77824: 553648256,
            81920: 16777344,
            86016: 553910272,
            90112: 537133184,
            94208: 16777216,
            98304: 553910400,
            102400: 553648128,
            106496: 17039360,
            110592: 537133056,
            114688: 262272,
            118784: 536871040,
            122880: 0,
            126976: 17039488,
            67584: 553648256,
            71680: 16777216,
            75776: 17039360,
            79872: 537133184,
            83968: 536870912,
            88064: 17039488,
            92160: 128,
            96256: 553910272,
            100352: 262272,
            104448: 553910400,
            108544: 0,
            112640: 553648128,
            116736: 16777344,
            120832: 262144,
            124928: 537133056,
            129024: 536871040
          },
          {
            0: 268435464,
            256: 8192,
            512: 270532608,
            768: 270540808,
            1024: 268443648,
            1280: 2097152,
            1536: 2097160,
            1792: 268435456,
            2048: 0,
            2304: 268443656,
            2560: 2105344,
            2816: 8,
            3072: 270532616,
            3328: 2105352,
            3584: 8200,
            3840: 270540800,
            128: 270532608,
            384: 270540808,
            640: 8,
            896: 2097152,
            1152: 2105352,
            1408: 268435464,
            1664: 268443648,
            1920: 8200,
            2176: 2097160,
            2432: 8192,
            2688: 268443656,
            2944: 270532616,
            3200: 0,
            3456: 270540800,
            3712: 2105344,
            3968: 268435456,
            4096: 268443648,
            4352: 270532616,
            4608: 270540808,
            4864: 8200,
            5120: 2097152,
            5376: 268435456,
            5632: 268435464,
            5888: 2105344,
            6144: 2105352,
            6400: 0,
            6656: 8,
            6912: 270532608,
            7168: 8192,
            7424: 268443656,
            7680: 270540800,
            7936: 2097160,
            4224: 8,
            4480: 2105344,
            4736: 2097152,
            4992: 268435464,
            5248: 268443648,
            5504: 8200,
            5760: 270540808,
            6016: 270532608,
            6272: 270540800,
            6528: 270532616,
            6784: 8192,
            7040: 2105352,
            7296: 2097160,
            7552: 0,
            7808: 268435456,
            8064: 268443656
          },
          {
            0: 1048576,
            16: 33555457,
            32: 1024,
            48: 1049601,
            64: 34604033,
            80: 0,
            96: 1,
            112: 34603009,
            128: 33555456,
            144: 1048577,
            160: 33554433,
            176: 34604032,
            192: 34603008,
            208: 1025,
            224: 1049600,
            240: 33554432,
            8: 34603009,
            24: 0,
            40: 33555457,
            56: 34604032,
            72: 1048576,
            88: 33554433,
            104: 33554432,
            120: 1025,
            136: 1049601,
            152: 33555456,
            168: 34603008,
            184: 1048577,
            200: 1024,
            216: 34604033,
            232: 1,
            248: 1049600,
            256: 33554432,
            272: 1048576,
            288: 33555457,
            304: 34603009,
            320: 1048577,
            336: 33555456,
            352: 34604032,
            368: 1049601,
            384: 1025,
            400: 34604033,
            416: 1049600,
            432: 1,
            448: 0,
            464: 34603008,
            480: 33554433,
            496: 1024,
            264: 1049600,
            280: 33555457,
            296: 34603009,
            312: 1,
            328: 33554432,
            344: 1048576,
            360: 1025,
            376: 34604032,
            392: 33554433,
            408: 34603008,
            424: 0,
            440: 34604033,
            456: 1049601,
            472: 1024,
            488: 33555456,
            504: 1048577
          },
          {
            0: 134219808,
            1: 131072,
            2: 134217728,
            3: 32,
            4: 131104,
            5: 134350880,
            6: 134350848,
            7: 2048,
            8: 134348800,
            9: 134219776,
            10: 133120,
            11: 134348832,
            12: 2080,
            13: 0,
            14: 134217760,
            15: 133152,
            2147483648: 2048,
            2147483649: 134350880,
            2147483650: 134219808,
            2147483651: 134217728,
            2147483652: 134348800,
            2147483653: 133120,
            2147483654: 133152,
            2147483655: 32,
            2147483656: 134217760,
            2147483657: 2080,
            2147483658: 131104,
            2147483659: 134350848,
            2147483660: 0,
            2147483661: 134348832,
            2147483662: 134219776,
            2147483663: 131072,
            16: 133152,
            17: 134350848,
            18: 32,
            19: 2048,
            20: 134219776,
            21: 134217760,
            22: 134348832,
            23: 131072,
            24: 0,
            25: 131104,
            26: 134348800,
            27: 134219808,
            28: 134350880,
            29: 133120,
            30: 2080,
            31: 134217728,
            2147483664: 131072,
            2147483665: 2048,
            2147483666: 134348832,
            2147483667: 133152,
            2147483668: 32,
            2147483669: 134348800,
            2147483670: 134217728,
            2147483671: 134219808,
            2147483672: 134350880,
            2147483673: 134217760,
            2147483674: 134219776,
            2147483675: 0,
            2147483676: 133120,
            2147483677: 2080,
            2147483678: 131104,
            2147483679: 134350848
          }
        ], o = [
          4160749569,
          528482304,
          33030144,
          2064384,
          129024,
          8064,
          504,
          2147483679
        ], u = d.DES = x.extend({
          _doReset: function() {
            for (var $ = this._key, l = $.words, f = [], m = 0; m < 56; m++) {
              var b = p[m] - 1;
              f[m] = l[b >>> 5] >>> 31 - b % 32 & 1;
            }
            for (var E = this._subKeys = [], k = 0; k < 16; k++) {
              for (var S = E[k] = [], A = c[k], m = 0; m < 24; m++)
                S[m / 6 | 0] |= f[(a[m] - 1 + A) % 28] << 31 - m % 6, S[4 + (m / 6 | 0)] |= f[28 + (a[m + 24] - 1 + A) % 28] << 31 - m % 6;
              S[0] = S[0] << 1 | S[0] >>> 31;
              for (var m = 1; m < 7; m++)
                S[m] = S[m] >>> (m - 1) * 4 + 3;
              S[7] = S[7] << 5 | S[7] >>> 27;
            }
            for (var _ = this._invSubKeys = [], m = 0; m < 16; m++)
              _[m] = E[15 - m];
          },
          encryptBlock: function($, l) {
            this._doCryptBlock($, l, this._subKeys);
          },
          decryptBlock: function($, l) {
            this._doCryptBlock($, l, this._invSubKeys);
          },
          _doCryptBlock: function($, l, f) {
            this._lBlock = $[l], this._rBlock = $[l + 1], h.call(this, 4, 252645135), h.call(this, 16, 65535), v.call(this, 2, 858993459), v.call(this, 8, 16711935), h.call(this, 1, 1431655765);
            for (var m = 0; m < 16; m++) {
              for (var b = f[m], E = this._lBlock, k = this._rBlock, S = 0, A = 0; A < 8; A++)
                S |= y[A][((k ^ b[A]) & o[A]) >>> 0];
              this._lBlock = k, this._rBlock = E ^ S;
            }
            var _ = this._lBlock;
            this._lBlock = this._rBlock, this._rBlock = _, h.call(this, 1, 1431655765), v.call(this, 8, 16711935), v.call(this, 2, 858993459), h.call(this, 16, 65535), h.call(this, 4, 252645135), $[l] = this._lBlock, $[l + 1] = this._rBlock;
          },
          keySize: 64 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        function h($, l) {
          var f = (this._lBlock >>> $ ^ this._rBlock) & l;
          this._rBlock ^= f, this._lBlock ^= f << $;
        }
        function v($, l) {
          var f = (this._rBlock >>> $ ^ this._lBlock) & l;
          this._lBlock ^= f, this._rBlock ^= f << $;
        }
        s.DES = x._createHelper(u);
        var g = d.TripleDES = x.extend({
          _doReset: function() {
            var $ = this._key, l = $.words;
            if (l.length !== 2 && l.length !== 4 && l.length < 6)
              throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
            var f = l.slice(0, 2), m = l.length < 4 ? l.slice(0, 2) : l.slice(2, 4), b = l.length < 6 ? l.slice(0, 2) : l.slice(4, 6);
            this._des1 = u.createEncryptor(i.create(f)), this._des2 = u.createEncryptor(i.create(m)), this._des3 = u.createEncryptor(i.create(b));
          },
          encryptBlock: function($, l) {
            this._des1.encryptBlock($, l), this._des2.decryptBlock($, l), this._des3.encryptBlock($, l);
          },
          decryptBlock: function($, l) {
            this._des3.decryptBlock($, l), this._des2.encryptBlock($, l), this._des1.decryptBlock($, l);
          },
          keySize: 192 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        s.TripleDES = x._createHelper(g);
      }(), r.TripleDES;
    });
  }(fr)), fr.exports;
}
var xr = { exports: {} }, X0;
function Xi() {
  return X0 || (X0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), Re(), Ue(), De(), ee());
    })(N, function(r) {
      return function() {
        var s = r, n = s.lib, i = n.StreamCipher, x = s.algo, d = x.RC4 = i.extend({
          _doReset: function() {
            for (var c = this._key, y = c.words, o = c.sigBytes, u = this._S = [], h = 0; h < 256; h++)
              u[h] = h;
            for (var h = 0, v = 0; h < 256; h++) {
              var g = h % o, $ = y[g >>> 2] >>> 24 - g % 4 * 8 & 255;
              v = (v + u[h] + $) % 256;
              var l = u[h];
              u[h] = u[v], u[v] = l;
            }
            this._i = this._j = 0;
          },
          _doProcessBlock: function(c, y) {
            c[y] ^= p.call(this);
          },
          keySize: 256 / 32,
          ivSize: 0
        });
        function p() {
          for (var c = this._S, y = this._i, o = this._j, u = 0, h = 0; h < 4; h++) {
            y = (y + 1) % 256, o = (o + c[y]) % 256;
            var v = c[y];
            c[y] = c[o], c[o] = v, u |= c[(c[y] + c[o]) % 256] << 24 - h * 8;
          }
          return this._i = y, this._j = o, u;
        }
        s.RC4 = i._createHelper(d);
        var a = x.RC4Drop = d.extend({
          /**
           * Configuration options.
           *
           * @property {number} drop The number of keystream words to drop. Default 192
           */
          cfg: d.cfg.extend({
            drop: 192
          }),
          _doReset: function() {
            d._doReset.call(this);
            for (var c = this.cfg.drop; c > 0; c--)
              p.call(this);
          }
        });
        s.RC4Drop = i._createHelper(a);
      }(), r.RC4;
    });
  }(xr)), xr.exports;
}
var vr = { exports: {} }, V0;
function Vi() {
  return V0 || (V0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), Re(), Ue(), De(), ee());
    })(N, function(r) {
      return function() {
        var s = r, n = s.lib, i = n.StreamCipher, x = s.algo, d = [], p = [], a = [], c = x.Rabbit = i.extend({
          _doReset: function() {
            for (var o = this._key.words, u = this.cfg.iv, h = 0; h < 4; h++)
              o[h] = (o[h] << 8 | o[h] >>> 24) & 16711935 | (o[h] << 24 | o[h] >>> 8) & 4278255360;
            var v = this._X = [
              o[0],
              o[3] << 16 | o[2] >>> 16,
              o[1],
              o[0] << 16 | o[3] >>> 16,
              o[2],
              o[1] << 16 | o[0] >>> 16,
              o[3],
              o[2] << 16 | o[1] >>> 16
            ], g = this._C = [
              o[2] << 16 | o[2] >>> 16,
              o[0] & 4294901760 | o[1] & 65535,
              o[3] << 16 | o[3] >>> 16,
              o[1] & 4294901760 | o[2] & 65535,
              o[0] << 16 | o[0] >>> 16,
              o[2] & 4294901760 | o[3] & 65535,
              o[1] << 16 | o[1] >>> 16,
              o[3] & 4294901760 | o[0] & 65535
            ];
            this._b = 0;
            for (var h = 0; h < 4; h++)
              y.call(this);
            for (var h = 0; h < 8; h++)
              g[h] ^= v[h + 4 & 7];
            if (u) {
              var $ = u.words, l = $[0], f = $[1], m = (l << 8 | l >>> 24) & 16711935 | (l << 24 | l >>> 8) & 4278255360, b = (f << 8 | f >>> 24) & 16711935 | (f << 24 | f >>> 8) & 4278255360, E = m >>> 16 | b & 4294901760, k = b << 16 | m & 65535;
              g[0] ^= m, g[1] ^= E, g[2] ^= b, g[3] ^= k, g[4] ^= m, g[5] ^= E, g[6] ^= b, g[7] ^= k;
              for (var h = 0; h < 4; h++)
                y.call(this);
            }
          },
          _doProcessBlock: function(o, u) {
            var h = this._X;
            y.call(this), d[0] = h[0] ^ h[5] >>> 16 ^ h[3] << 16, d[1] = h[2] ^ h[7] >>> 16 ^ h[5] << 16, d[2] = h[4] ^ h[1] >>> 16 ^ h[7] << 16, d[3] = h[6] ^ h[3] >>> 16 ^ h[1] << 16;
            for (var v = 0; v < 4; v++)
              d[v] = (d[v] << 8 | d[v] >>> 24) & 16711935 | (d[v] << 24 | d[v] >>> 8) & 4278255360, o[u + v] ^= d[v];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function y() {
          for (var o = this._X, u = this._C, h = 0; h < 8; h++)
            p[h] = u[h];
          u[0] = u[0] + 1295307597 + this._b | 0, u[1] = u[1] + 3545052371 + (u[0] >>> 0 < p[0] >>> 0 ? 1 : 0) | 0, u[2] = u[2] + 886263092 + (u[1] >>> 0 < p[1] >>> 0 ? 1 : 0) | 0, u[3] = u[3] + 1295307597 + (u[2] >>> 0 < p[2] >>> 0 ? 1 : 0) | 0, u[4] = u[4] + 3545052371 + (u[3] >>> 0 < p[3] >>> 0 ? 1 : 0) | 0, u[5] = u[5] + 886263092 + (u[4] >>> 0 < p[4] >>> 0 ? 1 : 0) | 0, u[6] = u[6] + 1295307597 + (u[5] >>> 0 < p[5] >>> 0 ? 1 : 0) | 0, u[7] = u[7] + 3545052371 + (u[6] >>> 0 < p[6] >>> 0 ? 1 : 0) | 0, this._b = u[7] >>> 0 < p[7] >>> 0 ? 1 : 0;
          for (var h = 0; h < 8; h++) {
            var v = o[h] + u[h], g = v & 65535, $ = v >>> 16, l = ((g * g >>> 17) + g * $ >>> 15) + $ * $, f = ((v & 4294901760) * v | 0) + ((v & 65535) * v | 0);
            a[h] = l ^ f;
          }
          o[0] = a[0] + (a[7] << 16 | a[7] >>> 16) + (a[6] << 16 | a[6] >>> 16) | 0, o[1] = a[1] + (a[0] << 8 | a[0] >>> 24) + a[7] | 0, o[2] = a[2] + (a[1] << 16 | a[1] >>> 16) + (a[0] << 16 | a[0] >>> 16) | 0, o[3] = a[3] + (a[2] << 8 | a[2] >>> 24) + a[1] | 0, o[4] = a[4] + (a[3] << 16 | a[3] >>> 16) + (a[2] << 16 | a[2] >>> 16) | 0, o[5] = a[5] + (a[4] << 8 | a[4] >>> 24) + a[3] | 0, o[6] = a[6] + (a[5] << 16 | a[5] >>> 16) + (a[4] << 16 | a[4] >>> 16) | 0, o[7] = a[7] + (a[6] << 8 | a[6] >>> 24) + a[5] | 0;
        }
        s.Rabbit = i._createHelper(c);
      }(), r.Rabbit;
    });
  }(vr)), vr.exports;
}
var yr = { exports: {} }, Y0;
function Yi() {
  return Y0 || (Y0 = 1, function(t, e) {
    (function(r, s, n) {
      t.exports = s(W(), Re(), Ue(), De(), ee());
    })(N, function(r) {
      return function() {
        var s = r, n = s.lib, i = n.StreamCipher, x = s.algo, d = [], p = [], a = [], c = x.RabbitLegacy = i.extend({
          _doReset: function() {
            var o = this._key.words, u = this.cfg.iv, h = this._X = [
              o[0],
              o[3] << 16 | o[2] >>> 16,
              o[1],
              o[0] << 16 | o[3] >>> 16,
              o[2],
              o[1] << 16 | o[0] >>> 16,
              o[3],
              o[2] << 16 | o[1] >>> 16
            ], v = this._C = [
              o[2] << 16 | o[2] >>> 16,
              o[0] & 4294901760 | o[1] & 65535,
              o[3] << 16 | o[3] >>> 16,
              o[1] & 4294901760 | o[2] & 65535,
              o[0] << 16 | o[0] >>> 16,
              o[2] & 4294901760 | o[3] & 65535,
              o[1] << 16 | o[1] >>> 16,
              o[3] & 4294901760 | o[0] & 65535
            ];
            this._b = 0;
            for (var g = 0; g < 4; g++)
              y.call(this);
            for (var g = 0; g < 8; g++)
              v[g] ^= h[g + 4 & 7];
            if (u) {
              var $ = u.words, l = $[0], f = $[1], m = (l << 8 | l >>> 24) & 16711935 | (l << 24 | l >>> 8) & 4278255360, b = (f << 8 | f >>> 24) & 16711935 | (f << 24 | f >>> 8) & 4278255360, E = m >>> 16 | b & 4294901760, k = b << 16 | m & 65535;
              v[0] ^= m, v[1] ^= E, v[2] ^= b, v[3] ^= k, v[4] ^= m, v[5] ^= E, v[6] ^= b, v[7] ^= k;
              for (var g = 0; g < 4; g++)
                y.call(this);
            }
          },
          _doProcessBlock: function(o, u) {
            var h = this._X;
            y.call(this), d[0] = h[0] ^ h[5] >>> 16 ^ h[3] << 16, d[1] = h[2] ^ h[7] >>> 16 ^ h[5] << 16, d[2] = h[4] ^ h[1] >>> 16 ^ h[7] << 16, d[3] = h[6] ^ h[3] >>> 16 ^ h[1] << 16;
            for (var v = 0; v < 4; v++)
              d[v] = (d[v] << 8 | d[v] >>> 24) & 16711935 | (d[v] << 24 | d[v] >>> 8) & 4278255360, o[u + v] ^= d[v];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function y() {
          for (var o = this._X, u = this._C, h = 0; h < 8; h++)
            p[h] = u[h];
          u[0] = u[0] + 1295307597 + this._b | 0, u[1] = u[1] + 3545052371 + (u[0] >>> 0 < p[0] >>> 0 ? 1 : 0) | 0, u[2] = u[2] + 886263092 + (u[1] >>> 0 < p[1] >>> 0 ? 1 : 0) | 0, u[3] = u[3] + 1295307597 + (u[2] >>> 0 < p[2] >>> 0 ? 1 : 0) | 0, u[4] = u[4] + 3545052371 + (u[3] >>> 0 < p[3] >>> 0 ? 1 : 0) | 0, u[5] = u[5] + 886263092 + (u[4] >>> 0 < p[4] >>> 0 ? 1 : 0) | 0, u[6] = u[6] + 1295307597 + (u[5] >>> 0 < p[5] >>> 0 ? 1 : 0) | 0, u[7] = u[7] + 3545052371 + (u[6] >>> 0 < p[6] >>> 0 ? 1 : 0) | 0, this._b = u[7] >>> 0 < p[7] >>> 0 ? 1 : 0;
          for (var h = 0; h < 8; h++) {
            var v = o[h] + u[h], g = v & 65535, $ = v >>> 16, l = ((g * g >>> 17) + g * $ >>> 15) + $ * $, f = ((v & 4294901760) * v | 0) + ((v & 65535) * v | 0);
            a[h] = l ^ f;
          }
          o[0] = a[0] + (a[7] << 16 | a[7] >>> 16) + (a[6] << 16 | a[6] >>> 16) | 0, o[1] = a[1] + (a[0] << 8 | a[0] >>> 24) + a[7] | 0, o[2] = a[2] + (a[1] << 16 | a[1] >>> 16) + (a[0] << 16 | a[0] >>> 16) | 0, o[3] = a[3] + (a[2] << 8 | a[2] >>> 24) + a[1] | 0, o[4] = a[4] + (a[3] << 16 | a[3] >>> 16) + (a[2] << 16 | a[2] >>> 16) | 0, o[5] = a[5] + (a[4] << 8 | a[4] >>> 24) + a[3] | 0, o[6] = a[6] + (a[5] << 16 | a[5] >>> 16) + (a[4] << 16 | a[4] >>> 16) | 0, o[7] = a[7] + (a[6] << 8 | a[6] >>> 24) + a[5] | 0;
        }
        s.RabbitLegacy = i._createHelper(c);
      }(), r.RabbitLegacy;
    });
  }(yr)), yr.exports;
}
(function(t, e) {
  (function(r, s, n) {
    t.exports = s(W(), gt(), Pi(), Ii(), Re(), Ci(), Ue(), Tr(), ms(), Ti(), gs(), Ri(), Ai(), Oi(), Rr(), Ui(), De(), ee(), Di(), Fi(), Hi(), Mi(), Ni(), Li(), qi(), Wi(), zi(), ji(), Ki(), xs(), Gi(), Xi(), Vi(), Yi());
  })(N, function(r) {
    return r;
  });
})(ys);
var Ji = ys.exports;
const oe = /* @__PURE__ */ ze(Ji);
class bs {
  constructor() {
    this.data = {
      client_key: ""
    };
  }
  encryptKey() {
    return Or(this.data.client_key).toString().substring(0, 16);
  }
  encrypt(e) {
    if (re(this.encryptKey()))
      throw new Error("privateKey is not set");
    const r = typeof e == "string" ? e : JSON.stringify(e), s = nt.encrypt(
      r,
      oe.enc.Utf8.parse(this.encryptKey()),
      {
        mode: oe.mode.ECB,
        padding: oe.pad.Pkcs7
      }
    );
    return Ce.stringify(s.ciphertext);
  }
  decrypt(e) {
    if (re(this.encryptKey()))
      throw new Error("privateKey is not set");
    const s = nt.decrypt(
      e,
      oe.enc.Utf8.parse(this.encryptKey()),
      {
        mode: oe.mode.ECB,
        padding: oe.pad.Pkcs7
      }
    ).toString(oe.enc.Utf8);
    try {
      return JSON.parse(s);
    } catch {
      return s;
    }
  }
}
class Zi extends bs {
  constructor() {
    super(), this.el = "", this.data = {}, this.path = "";
  }
  setExData(e, r) {
    this.el = (e ?? "").replace(/#/gi, ""), this.data = r;
  }
  encryptParameters() {
    return encodeURIComponent(
      this.encrypt({
        categories: this.data.categories,
        extra: this.data.extra
      })
    );
  }
  encryptKey() {
    return M(this.data.client_key) ? Or(this.data.client_key).toString().substring(0, 16) : "";
  }
  currentBootpayStoreParameters() {
    let e = [];
    const r = Object.fromEntries(new URLSearchParams(location.search));
    return Object.keys(r).forEach((s) => {
      s.match(br.parameterPrefix) && e.push(`${s.replace(br.parameterPrefix, "")}=${r[s]}`);
    }), e.push("__frame=true"), e.join("&");
  }
}
const _r = new Zi(), wr = {
  mode: "production",
  locale: "ko",
  packageVersion: $e.version,
  EX_SHOP_URL: {
    development: "https://dev-i.bootpay.co.kr",
    stage: "https://stage-i.bootpay.co.kr",
    production: "https://i.bootpay.co.kr"
  },
  set(t) {
    this.mode = t;
  },
  setClientKey(t) {
    return this.clientKey = t, this.clientKey;
  },
  setLocale(t) {
    this.locale = t;
  },
  toExShopUrl(t) {
    return [this.EX_SHOP_URL[this.mode], t].join("/");
  }
};
class Qi extends ge {
  constructor() {
    super(), this.$iFrameId = "bootpay-store-iframe", this.$iFrameContainerId = "bootpay-store-iframe-container", this.$exOverlayId = "bootpay-store-overlay", this.$exOverlayContainerId = "bootpay-store-overlay-container", this.$exStore = _r, this.$template = `
            <div class="bootpay-store-iframe-container" id="${this.$iFrameContainerId}">
                <iframe id="${this.$iFrameId}" src="" allowtransparency="true" scrolling="yes" style="background: transparent; width: 100%; height: 100%;"></iframe>
                <div class="bootpay-store-overlay" id="${this.$exOverlayId}">
                </div>
            </div>                        
        `;
  }
  render() {
    const e = document.getElementById(this.$exStore.el);
    if (this.$blank(this.$exStore.el) || e === null)
      throw new Error("부트페이 Ex를 설정할 Element ID를 입력하지 않았거나 해당 Element DOM이 존재하지 않습니다.");
    this.templateRender();
  }
  templateRender() {
    var s, n, i, x, d, p, a, c, y, o;
    const e = document.getElementById(this.$exStore.el);
    e.style.setProperty("height", "0px"), e.innerHTML = this.$template, this.byId(this.$iFrameId).setAttribute("src", this.shopUrl()), (i = (n = (s = this.$exStore.data) == null ? void 0 : s.extra) == null ? void 0 : n.window) != null && i.fullscreen ? (e.classList.add("__bootpay-store-el-fullscreen"), e.style.removeProperty("height"), (x = document.getElementById(this.$exStore.el)) == null || x.style.setProperty("height", "100%")) : ((a = (p = (d = this.$exStore.data) == null ? void 0 : d.extra) == null ? void 0 : p.window) != null && a.width || (o = (y = (c = this.$exStore.data) == null ? void 0 : c.extra) == null ? void 0 : y.window) != null && o.height) && this.resize({
      width: this.$exStore.data.extra.window.width,
      height: this.$exStore.data.extra.window.height
    });
  }
  resize(e) {
    this.templateResize(this.$exStore.el, e);
  }
  postMessage(e, r) {
    var n;
    const s = this.byId(this.$iFrameId);
    (n = s == null ? void 0 : s.contentWindow) == null || n.postMessage(JSON.stringify({
      bootpay_event: !0,
      event: e,
      data: r
    }), "*");
  }
  showAlert(e, r = "알림", s = {
    type: "notice",
    confirmText: "확인",
    cancelText: "취소"
  }) {
    const n = document.getElementById(this.$exOverlayId);
    n.innerHTML = `
                    <div class="bootpay-store-alert-container" id="${this.$exOverlayContainerId}">
                        <div class="bootpay-store-alert-header">
                            <span>${r}</span>
                            <button class="bootpay-close-btn" onClick="BootpayStore.hideAlert('cancel')"></button>
                        </div>                  
                        <div class="bootpay-store-alert-body">
                            ${e}
                        </div>                      
                        ${this.alertTypeTemplate(s)}
                    </div>
        `;
    const i = document.getElementById(this.$exOverlayContainerId);
    n.style.display = "block", n.classList.remove("fade-out"), i.classList.remove("zoom-out"), n.classList.add("fade-in"), i.classList.add("zoom-in");
  }
  hideAlert(e = "confirm") {
    const r = document.getElementById(this.$exOverlayId);
    document.getElementById(this.$exOverlayContainerId).classList.replace("zoom-in", "zoom-out"), r.classList.replace("fade-in", "fade-out"), setTimeout(() => {
      r.style.display = "none", r.innerHTML = "", this.postMessage("alertResponse", {
        mode: e
      });
    }, 150);
  }
  showOverlayiFrameToUrl(e, r = { width: "100%", height: "100%" }) {
    const s = document.getElementById(this.$exOverlayId), n = Object.keys(r).map((x) => `${x}: ${r[x]};`).join(" ");
    s.innerHTML = `
                    <div class="bootpay-store-overlay-iframe-container" id="${this.$exOverlayContainerId}" style="${n}">
                        <iframe src="${e}" frameborder="0" allowtransparency="true" scrolling="no" style="background: transparent; width: 100%; height: 100%;"></iframe>
                    </div>
        `;
    const i = document.getElementById(this.$exOverlayContainerId);
    s.style.display = "block", s.classList.add("fade-in"), i.classList.add("zoom-in");
  }
  hideOverlayiFrame() {
    const e = document.getElementById(this.$exOverlayId);
    document.getElementById(this.$exOverlayContainerId).classList.replace("zoom-in", "zoom-out"), e.classList.replace("fade-in", "fade-out"), setTimeout(() => {
      e.style.display = "none", e.innerHTML = "";
    }, 200);
  }
  alertTypeTemplate(e = { type: "notice", confirmText: "확인", cancelText: "취소" }) {
    return e.type === "notice" ? `
                <div class="bootpay-store-alert-footer">
                    <button class="bootpay-alert-confirm-button bootpay-btn" onClick="BootpayStore.hideAlert('confirm')">${e.confirmText}</button>
                </div>
            ` : `
                <div class="bootpay-store-alert-footer">
                    <div class="bootpay-store-alert-button-grid">
                        <div class="bootpay-store-cols">
                            <button class="bootpay-alert-cancel-button bootpay-btn" onClick="BootpayStore.hideAlert('cancel')">${e.cancelText}</button>
                        </div>
                        <div class="bootpay-store-cols">
                            <button class="bootpay-alert-confirm-button bootpay-btn" onClick="BootpayStore.hideAlert('confirm')">${e.confirmText}</button>
                        </div>
                    </div>
                </div>
            `;
  }
  shopUrl() {
    const e = Object.fromEntries(new URLSearchParams(location.search));
    return M(e.__b_u) ? wr.toExShopUrl(e.__b_u) : wr.toExShopUrl(
      `em/${this.$exStore.data.client_key}/${this.$exStore.encryptParameters()}?${this.$exStore.currentBootpayStoreParameters()}`
    );
  }
}
const me = new Qi(), _s = {
  hooks: {},
  setHooks(t) {
    this.hooks = t;
  },
  callHook(t, e) {
    this.hooks[t] && this.hooks[t](e);
  }
}, eo = {
  resize: (t) => {
    me.resize(t);
  },
  showAlert({ message: t, title: e, options: r }) {
    me.showAlert(t, e, r);
  },
  hideAlert() {
    me.hideAlert();
  },
  showOverlayiFrame({ url: t, options: e }) {
    me.showOverlayiFrameToUrl(t, e);
  },
  hideOverlayiFrame() {
    me.hideOverlayiFrame();
  },
  responseOverlayiFrame({ event: t, data: e }) {
    me.postMessage(t, e), this.hideOverlayiFrame();
  },
  addFavicon({ url: t }) {
    const e = document.querySelector("link[rel~='icon']");
    if (e)
      e.href = t;
    else {
      const r = document.createElement("link");
      r.rel = "icon", r.href = t, document.head.appendChild(r);
    }
  },
  hookOnReady(t = null) {
    _s.callHook("onReady", t);
  }
};
class to extends ot {
  constructor() {
    super({
      messageEventName: "message.BootpayStoreEvent",
      messageEventHooks: {
        StoreWindowEvent: eo,
        StoreWindowRouter: br
      },
      afterBind: () => {
        window.resetBootpayEventListener("popstate.BootpayStoreEvent", (e) => {
          const r = Object.fromEntries(new URLSearchParams(location.search));
          M(r.__b_u) && me.postMessage("BootpayRouterChange", { url: `/${r.__b_u}` });
        });
      }
    });
  }
}
const ro = new to();
class so extends Ae {
  constructor() {
    super();
  }
  initialize() {
    _r.setExData(void 0, {
      client_key: void 0,
      categories: [],
      extra: {}
    });
  }
  render(e, r) {
    if (this.$blank(r.client_key))
      throw new Error("client_key가 입력되지 않았습니다.");
    this.initialize(), _r.setExData(e, r), _s.setHooks(r.hooks), ro.bind(), me.render();
  }
  hideAlert(e = "confirm") {
    me.hideAlert(e);
  }
  sendEvent(e, r) {
    me.postMessage(e, r);
  }
}
const mr = new so(), no = {
  render(t, e) {
    mr.render(t, e);
  },
  setEnvironmentMode(t) {
    wr.set(t);
  },
  hideAlert(t = "confirm") {
    mr.hideAlert(t);
  },
  sendEvent(t, e) {
    mr.sendEvent(t, e);
  }
};
typeof window < "u" && (window.BootpayStore = no);
const z = {
  el: void 0,
  data: void 0,
  termsPassed: !1,
  widgetExtra: {
    card_quota: []
  },
  widgetType: 1,
  setWidgetData(t, e) {
    this.el = String(t).replace(/#/gi, ""), this.data = e, this.termsPassed = !1, this.data.terms = this.data.terms ?? [], this.widgetType = 1, this.data.widget = 1, this.data.use_terms = this.data.use_terms ?? !0;
  },
  setPayment(t, e, r, s = !1, n, i) {
    this.data.pg = t, this.data.method = e, this.data.wallet_id = r, this.termsPassed = s, this.data.terms = n, this.widgetExtra = i;
  },
  updateOnProcessing(t) {
    M(t.price) && (this.data.price = t.price), M(t.tax_free) && (this.data.tax_free = t.tax_free), M(t.currency) && (this.data.currency = t.currency), t.user_token !== void 0 && (this.data.user_token = t.user_token), M(t.use_terms) && (this.data.use_terms = t.use_terms !== !1), M(t.sandbox) && (this.data.sandbox = t.sandbox === !0), M(t.widget_key) && (this.data.widget_key = t.widget_key), M(t.widget_type) && (this.widgetType = t.widget_type), t.external_terms !== void 0 && (this.data.external_terms = t.external_terms), t.use_bootpay_inapp_sdk !== void 0 && (this.data.use_bootpay_inapp_sdk = t.use_bootpay_inapp_sdk), t.widget_key !== void 0 && (this.data.widget_key = t.widget_key);
  },
  encryptParameters() {
    return encodeURIComponent(
      this.encrypt({
        order_name: this.data.order_name,
        use_only_oopay: this.data.use_only_oopay,
        user_token: this.data.user_token,
        sandbox: this.data.sandbox,
        use_terms: this.data.use_terms,
        external_terms: this.data.external_terms,
        key: this.data.widget_key,
        use_bootpay_inapp_sdk: this.data.use_bootpay_inapp_sdk,
        extra: this.data.extra,
        log_level: F.level
      })
    );
  },
  encrypt(t) {
    if (re(this.data.application_id))
      throw new Error("privateKey is not set");
    const e = typeof t == "string" ? t : JSON.stringify(t), r = nt.encrypt(
      e,
      oe.enc.Utf8.parse(this.data.application_id.substring(0, 16)),
      {
        mode: oe.mode.ECB,
        padding: oe.pad.Pkcs7
      }
    );
    return Ce.stringify(r.ciphertext);
  },
  decrypt(t) {
    if (re(this.data.application_id))
      throw new Error("privateKey is not set");
    const r = nt.decrypt(
      t,
      oe.enc.Utf8.parse(this.data.application_id.substring(0, 16)),
      {
        mode: oe.mode.ECB,
        padding: oe.pad.Pkcs7
      }
    ).toString(oe.enc.Utf8);
    try {
      return JSON.parse(r);
    } catch {
      return r;
    }
  },
  /**
   * 결제 요청시 가져올 extra 값
   * Comment by GOSOMI
   * @date: 2024-08-19
   */
  getExtra(t = void 0) {
    return wt(t ?? {}, wt(this.widgetExtra ?? {}, this.data.extra ?? {}));
  },
  getRequestPaymentData(t = void 0) {
    return this.data.widget_sandbox = this.data.sandbox, this.data.extra = this.getExtra(t.extra), wt(t, this.data);
  }
};
class io extends ge {
  constructor() {
    super(), this.$iFrameId = "bootpay-widget-iframe", this.$widgetStore = z, this.$template = this.defaultIframeHtml();
  }
  /**
   * 첫 Rendering을 진행한다
   * Comment by GOSOMI
   * @date: 2023-06-15
   */
  render() {
    const e = document.getElementById(this.$widgetStore.el);
    if (this.$blank(this.$widgetStore.el) || e === null)
      throw new Error("부트페이 위젯을 설정할 Element ID를 입력하지 않았거나 해당 Element DOM이 존재하지 않습니다.");
    this.templateRender();
  }
  /**
   * 렌더링 공통 함수
   * Comment by GOSOMI
   * @date: 2023-06-15
   */
  templateRender() {
    const e = document.getElementById(this.$widgetStore.el);
    e.style.setProperty("height", "0px"), e.innerHTML = this.$template, this.byId(this.$iFrameId).setAttribute(
      "src",
      D.toWidget(
        `p/${this.$widgetStore.data.application_id}/${this.$widgetStore.encryptParameters()}`
      )
    );
  }
  resize(e) {
    this.templateResize(this.$widgetStore.el, e);
  }
  /**
   * widget을 재 렌더링한다
   * Comment by GOSOMI
   * @date: 2023-06-15
   */
  rerender() {
    this.postMessage("bootpayWidgetRerender");
  }
  /**
   * 창을 삭제한다
   * Comment by GOSOMI
   * @date: 2023-06-15
   */
  destroy() {
    const e = document.getElementById(this.$widgetStore.el);
    e.innerHTML = "";
  }
}
const G = new io();
class oo extends ge {
  constructor() {
    super(), this.$oopayWindowId = "__bootpay-card-easy-window", this.$iFrameId = "__bootpay-card-easy-iframe", this.$windowId = "__bootpay-card-easy-container-window", this.$additionalClass = D.isMobile() ? "transparent" : "rounded-iframe transparent", this.$template = this.template(), this.$widgetStore = z;
  }
  template() {
    return `
<div id="${this.$windowId}" class="bootpay-payment-background">
    <div class="bootpay-payment-window ${D.isMobile() ? "__mobile" : ""}" id="${this.$oopayWindowId}">                
        <iframe class="${this.$additionalClass}" id="${this.$iFrameId}" name="${this.$iFrameId}"></iframe>        
    </div>    
</div>
        `;
  }
  createIFrame(e) {
    this.createTemplateHtml();
    const r = document.getElementById(this.$iFrameId);
    r == null || r.setAttribute("src", D.toWidget(`${e}`)), r == null || r.style.setProperty("display", "block"), this.bodyOpen("bootpay-mobile");
  }
  addWallet(e) {
    this.createIFrame(e);
  }
  removeWallet(e) {
    this.createIFrame(`oopay/destroy/${this.$widgetStore.data.application_id}/${e}`);
  }
  showCardInterestInformation(e) {
    this.createIFrame(`card/interest/${this.$widgetStore.data.application_id}`);
  }
  destroy() {
    const e = document.getElementById(this.$windowId);
    e !== void 0 && (e.outerHTML = "", e.remove());
  }
  resize(e) {
    F.debug("resize", e), this.templateResize(this.$iFrameId, e);
  }
  postMessage(e, r = void 0) {
    var n;
    const s = this.byId(this.$iFrameId);
    (n = s == null ? void 0 : s.contentWindow) == null || n.postMessage(JSON.stringify({
      bootpay_event: !0,
      event: e,
      data: r
    }), "*");
  }
}
const ke = new oo();
class ao extends ge {
  constructor() {
    super(), this.$windowId = "__bootpay-modal-window-container", this.$modalWindowId = "__bootpay-modal-window", this.$iFrameId = "__bootpay-modal-iframe", this.$additionalClass = D.isMobile() ? "" : "rounded-iframe", this.$template = this.template();
  }
  template() {
    return `
<div id="${this.$windowId}" class="bootpay-payment-background">
    <div class="bootpay-payment-window ${D.isMobile() ? "__mobile" : ""}" id="${this.$modalWindowId}">                
        <iframe class="${this.$additionalClass}" id="${this.$iFrameId}" name="${this.$iFrameId}"></iframe>        
    </div>    
</div>
        `;
  }
  createIFrame(e) {
    this.createTemplateHtml();
    const r = document.getElementById(this.$iFrameId);
    r == null || r.setAttribute("src", e), r == null || r.classList.add("slide-up"), r == null || r.style.setProperty("display", "block"), this.bodyOpen();
  }
  destroy() {
    const e = document.getElementById(this.$iFrameId);
    e == null || e.classList.remove("slide-up"), e == null || e.classList.add("slide-down"), setTimeout(() => {
      const r = document.getElementById(this.$windowId);
      r !== void 0 && (r.outerHTML = "", r.remove());
    }, 300);
  }
  resize(e) {
    F.debug("resize", e), this.templateResize(this.$iFrameId, e);
  }
  postMessage(e, r = void 0) {
    var n;
    const s = this.byId(this.$iFrameId);
    (n = s == null ? void 0 : s.contentWindow) == null || n.postMessage(JSON.stringify({
      bootpay_event: !0,
      event: e,
      data: r
    }), "*");
  }
}
const Ie = new ao();
class co extends ge {
  constructor() {
    super(), this.$windowId = "__bootpay-confirm-modal-window-container", this.$modalWindowId = "__bootpay-confirm-modal-window", this.$additionalClass = "rounded-iframe", this.$title = "알림", this.$confirmButtonText = "확인", this.$cancelButtonText = "취소", this.$hookConfirmButtonId = "__bootpay-confirm-modal-hook-button", this.$hookCancelButtonId = "__bootpay-cancel-modal-hook-button", this.$hookCloseButtonId = "__bootpay-close-modal-hook-button", this.$template = this.template(), this.$message = "";
  }
  template() {
    return `
<div id="${this.$windowId}" class="bootpay-payment-background __alert">
    <div class="bootpay-confirm-window fade-in" id="${this.$modalWindowId}">
        <div class="bootpay__alert-header">
            ${this.$title}
            <button class="bootpay-close-btn" id="${this.$hookCloseButtonId}"></button>
        </div>       
        <div class="bootpay__alert-body">
            ${this.$message}
        </div> 
        <div class="bootpay__alert-footer">
            <button class="bootpay__alert-close border-right" id="${this.$hookCancelButtonId}">${this.$cancelButtonText}</button>
            <button class="bootpay__alert-close bootpay-primary" id="${this.$hookConfirmButtonId}">${this.$confirmButtonText}</button>            
        </div>
    </div>
</div>
        `;
  }
  show(e, r = "알림", s = "확인", n = "취소", i, x, d = !0) {
    this.$title = r, this.$message = e, this.$confirmButtonText = s, this.$cancelButtonText = n, this.$template = this.template(), this.createTemplateHtml(), document.getElementById(this.$hookConfirmButtonId).addEventListener("click", () => {
      this.destroy(), i !== void 0 && i();
    }), document.getElementById(this.$hookCancelButtonId).addEventListener("click", () => {
      this.destroy(), x !== void 0 && x();
    }), document.getElementById(this.$hookCloseButtonId).addEventListener("click", () => {
      this.destroy(), x !== void 0 && x();
    }), d ? (document.getElementById(this.$hookCancelButtonId).removeAttribute("style"), document.getElementById(this.$hookConfirmButtonId).removeAttribute("style")) : (document.getElementById(this.$hookCancelButtonId).style.display = "none", document.getElementById(this.$hookConfirmButtonId).style.flex = "0 1 100%"), this.bodyOpen();
  }
  destroy() {
    const e = document.getElementById(this.$modalWindowId);
    e.classList.remove("fade-in"), e.classList.add("fade-out"), setTimeout(() => {
      const r = document.getElementById(this.$windowId);
      r !== void 0 && (r.outerHTML = "", r.remove()), this.bodyClose();
    }, 100);
  }
}
const ht = new co(), lo = {
  $eventPrefix: "bootpay",
  bootpayWidgetSelectMethod(t) {
    return this.triggerGlobalChangeEvent(t), se.selectPayment(
      t.pg,
      t.method,
      t.wallet_id,
      t.term_passed === !0,
      t.select_terms,
      t.extra
    );
  },
  // bootpayRequestGetEnvironment(): void {
  //     return TemplateWidget.postMessage('bootpayResponseGetEnvironment', {
  //         use_only_oopay:        TemplateWidget.$widgetStore.data.use_only_oopay,
  //         user_token:            TemplateWidget.$widgetStore.data.user_token,
  //         sandbox:               TemplateWidget.$widgetStore.data.sandbox,
  //         use_terms:             TemplateWidget.$widgetStore.data.use_terms,
  //         external_terms:        TemplateWidget.$widgetStore.data.external_terms,
  //         key:                   TemplateWidget.$widgetStore.data.widget_key,
  //         use_bootpay_inapp_sdk: TemplateWidget.$widgetStore.data.use_bootpay_inapp_sdk,
  //         log_level:             Logger.level
  //     })
  // },
  // bootpayRequestGetEnvironmentWidget(data: any): void {
  //     return TemplateWidget.postMessage('bootpayWidgetGetEnvironmentWidget', data)
  // },
  bootpayWidgetResponseGetEnvironmentWidget(t) {
    return ke.postMessage("bootpayResponseGetEnvironmentWidget", {
      use_only_oopay: G.$widgetStore.data.use_only_oopay,
      user_token: G.$widgetStore.data.user_token,
      sandbox: G.$widgetStore.data.sandbox,
      use_terms: G.$widgetStore.data.use_terms,
      platform: t.platform
    });
  },
  // bootpayRequestCurrentStores(data: any): void {
  //     return TemplateWidget.postMessage('bootpayWidgetRequestCurrentStores', data)
  // },
  bootpayWidgetResponseCurrentStores(t) {
    return ke.postMessage("bootpayResponseCurrentStores", t);
  },
  bootpayWidgetError(t, e) {
    return e.reject(t);
  },
  bootpayWidgetOOpayReload(t) {
    return G.postMessage("bootpayWidgetOOpayReload", t);
  },
  bootpayWidgetResize(t) {
    return this.callBootpayDOMEvent("widget-resize", t), G.resize(t);
  },
  bootpayWidgetShowInterestInformation(t) {
    return ke.showCardInterestInformation(t);
  },
  bootpayWidgetAddWallet(t) {
    return ke.addWallet(t.url);
  },
  bootpayWidgetRemoveWallet(t) {
    return ke.removeWallet(t.wallet_id);
  },
  bootpayWidgetPaymentWindowResize(t) {
    return ke.resize(t);
  },
  bootpayWidgetOOpayWindowClose() {
    return ke.destroy();
  },
  bootpayWidgetModalOpen(t) {
    return Ie.createIFrame(t.url);
  },
  bootpayWidgetModalClose() {
    return Ie.destroy();
  },
  bootpayRequestModalCurrentStores(t) {
    return G.postMessage("bootpayWidgetRequestModalCurrentStores", t);
  },
  bootpayRequestGetEnvironmentModalWidget(t) {
    return G.postMessage("bootpayWidgetGetEnvironmentModalWidget", t);
  },
  bootpayWidgetResponseGetEnvironmentModalWidget(t) {
    return Ie.postMessage("bootpayResponseGetEnvironmentModalWidget", {
      application_id: G.$widgetStore.data.application_id,
      use_only_oopay: G.$widgetStore.data.use_only_oopay,
      user_token: G.$widgetStore.data.user_token,
      sandbox: G.$widgetStore.data.sandbox,
      use_terms: G.$widgetStore.data.use_terms,
      external_terms: G.$widgetStore.data.external_terms,
      key: G.$widgetStore.data.widget_key,
      platform: t.platform,
      log_level: F.level
    });
  },
  bootpayWidgetModalResize(t) {
    return Ie.resize(t);
  },
  bootpayWidgetPaymentGetStoreData() {
    const {
      application_id: t,
      price: e,
      tax_free: r,
      user_token: s
    } = G.$widgetStore.data;
    return G.postMessage("bootpayWidgetResponseStoreData", {
      applicationId: t,
      price: e,
      widgetExtra: G.$widgetStore.widgetExtra,
      taxFree: r,
      userToken: s
    });
  },
  bootpayWidgetTermAllAgree(t) {
    this.callBootpayDOMEvent("all-agree-terms", t);
  },
  bootpayWidgetSelectPayment(t) {
    const { method_alias: e, payment_type: r, wallet_id: s } = t;
    return G.postMessage("bootpayWidgetSelectPayment", {
      method_alias: e,
      payment_type: r,
      wallet_id: s
    });
  },
  bootpayWidgetReady(t) {
    this.callBootpayDOMEvent("widget-ready", t);
  },
  bootpayWidgetUpdateStore(t) {
    z.updateOnProcessing({
      ...t
    });
  },
  bootpayWidgetToUrl(t) {
    location.href = t.url;
  },
  bootpayWidgetShowModal(t) {
    return ht.show(
      t.message,
      t.title,
      t.confirmButtonText,
      t.cancelButtonText,
      () => {
        window.BootpayWidget.alertConfirm();
      },
      () => {
        window.BootpayWidget.alertCancel();
      }
    );
  },
  /**
   * 결제 선택시 global 이벤트를 분리하여 호출한다
   * Comment by GOSOMI
   * @date: 2024-04-24
   */
  triggerGlobalChangeEvent(t) {
    var e;
    t.completed = M(t.pg) && M(t.method) && (t.term_passed === !0 || !z.data.use_terms) && (["OOPAY_CARD", "OOPAY_AUTOMATIC_TRANSFER"].indexOf(t.method) === -1 || t.wallet_id !== void 0), (z.data.pg !== t.pg || z.data.method !== t.method || z.data.wallet_id !== t.wallet_id || JSON.stringify(z.widgetExtra) !== JSON.stringify(t.extra)) && this.callBootpayDOMEvent("widget-change-payment", t), JSON.stringify((e = t.select_terms) == null ? void 0 : e.filter((r) => r.agree === !0)) !== JSON.stringify(z.data.terms.filter((r) => r.agree === !0)) && this.callBootpayDOMEvent("widget-change-terms", t);
  },
  callBootpayDOMEvent(t, e = void 0) {
    document.dispatchEvent(
      new CustomEvent(
        [this.$eventPrefix, t].join("-"),
        { detail: e }
      )
    );
  }
};
class uo extends ot {
  constructor() {
    super({
      messageEventName: "message.BootpayWidgetEvent",
      messageEventHooks: {
        WidgetWindowMessage: lo
      }
    });
  }
}
const po = new uo();
class ho extends Ae {
  constructor() {
    super(), this.message = Ar;
  }
  initialize() {
    z.setWidgetData(
      void 0,
      {
        application_id: void 0,
        order_name: "",
        order_id: void 0,
        price: 0,
        tax_free: 0,
        currency: "KRW",
        user_token: void 0,
        pg: void 0,
        method: void 0,
        widget_key: void 0
      }
    );
  }
  render(e, r) {
    if (this.$blank(r == null ? void 0 : r.price) || r.price < 0)
      throw new Error("결제금액은 1원 이상을 입력해주세요.");
    if (this.$blank(r == null ? void 0 : r.application_id))
      throw new Error("application_id가 입력되지 않았습니다.");
    this.initialize(), z.setWidgetData(
      e,
      r
    ), G.render(), po.bind();
  }
  update(e) {
    const {
      price: r,
      tax_free: s,
      currency: n,
      user_token: i,
      use_only_oopay: x,
      use_terms: d,
      sandbox: p,
      widget_key: a,
      external_terms: c
    } = e;
    z.updateOnProcessing({
      price: r,
      tax_free: s,
      currency: n,
      user_token: i,
      use_only_oopay: x,
      use_terms: d,
      external_terms: c,
      sandbox: p,
      widget_key: a
    }), (this.$present(i) || this.$present(x) || this.$present(d) || this.$present(p)) && G.postMessage("bootpayWidgetUpdateUserToken", {
      user_token: i,
      use_only_oopay: x,
      use_terms: d,
      external_terms: c,
      sandbox: p,
      key: a
    });
  }
  // 결제창을 다시 rendering 한다
  rerender() {
    G.rerender();
  }
  destroy() {
    G.destroy();
  }
  selectPayment(e, r, s, n = !1, i, x) {
    z.setPayment(e, r, s, n, i, x), F.debug("selectPayment", `pg: ${e}, method: ${r}, wallet_id: ${s}, terms: ${n}, select_terms: ${JSON.stringify(i)}, extra: ${JSON.stringify(x)}`);
  }
  currentTermsCondition() {
    return z.data.terms;
  }
  /**
   * 부트페이 결제 요청을 한다
   * Comment by GOSOMI
   * @date: 2023-06-21
   */
  async requestPayment(e) {
    return this.widgetRequestPaymentValidate(1), Ee.requestPayment(z.getRequestPaymentData(e));
  }
  /**
   * 부트페이 정기결제 요청
   * Comment by GOSOMI
   * @date: 2024-08-19
   */
  async requestSubscription(e) {
    return this.widgetRequestPaymentValidate(2), Ee.requestSubscription(z.getRequestPaymentData(e));
  }
  isRendered() {
    return G.isRendered();
  }
  /**
   * 실시간으로 위젯 정보전송
   * Comment by GOSOMI
   * @date: 2023-12-20
   */
  synchronizedRealTimeTransfer(e) {
    G.postMessage("bootpayWidgetSynchronizedRealTimeTransfer", e);
  }
  /**
   * 결제 수단 선택하기
   * Comment by GOSOMI
   * @date: 2024-01-08
   */
  sendSelectPayment(e) {
    G.postMessage("bootpayWidgetSelectPayment", e);
  }
  sendMessage(e, r) {
    G.postMessage(e, r);
  }
  /**
   * 현재 선택된 위젯 파라메터들을 리턴한다
   * Comment by GOSOMI
   * @date: 2024-07-22
   */
  currentPaymentParameters() {
    return this.widgetRequestPaymentValidate(), {
      pg: z.data.pg,
      method: z.data.method,
      wallet_id: z.data.wallet_id,
      terms: z.data.terms,
      widget_key: z.data.widget_key,
      widget_sandbox: z.data.sandbox,
      extra: z.getExtra({})
    };
  }
  widgetRequestPaymentValidate(e = void 0) {
    if (e !== void 0 && z.widgetType !== e)
      throw new pe({
        event: "error",
        error_code: "RC_WIDGET_TYPE_INVALID",
        message: e === 1 ? this.message.getLocaleMessage("widgetTypeNotPayment", "ko") : this.message.getLocaleMessage("widgetTypeNotSubscription", "ko")
      });
    if (this.$blank(z.data.pg) || this.$blank(z.data.method))
      throw new pe({
        event: "error",
        error_code: "RC_PG_METHOD_NOT_SELECTED",
        message: this.message.getLocaleMessage("notSelectPayment", "ko")
      });
    if (!z.termsPassed && z.data.use_terms)
      throw new pe({
        event: "error",
        error_code: "RC_TERMS_NOT_AGREE",
        message: this.message.getLocaleMessage("termsNotAgree", "ko")
      });
    if (["OOPAY_CARD", "OOPAY_AUTOMATIC_TRANSFER"].indexOf(z.data.method) > -1 && z.data.wallet_id === void 0)
      throw new pe({
        event: "error",
        error_code: "RC_OOPAY_NEED_SELECT_WALLET",
        message: this.message.getLocaleMessage("notSelectOOPay", "ko")
      });
  }
}
const se = new ho(), fo = {
  render(t, e) {
    se.render(t, e);
  },
  rerender() {
    se.rerender();
  },
  setEnvironmentMode(t, e) {
    Ee.setEnvironmentMode(t, e), D.set(t);
  },
  async requestPayment(t) {
    return new Promise(async (e, r) => {
      try {
        const s = await se.requestPayment(t);
        return e(s);
      } catch (s) {
        return r(this.errorHandler(s));
      }
    });
  },
  async requestSubscription(t) {
    return new Promise(async (e, r) => {
      try {
        const s = await se.requestSubscription(t);
        return e(s);
      } catch (s) {
        return r(this.errorHandler(s));
      }
    });
  },
  errorHandler(t) {
    let e;
    switch (he.hideProgress(), t.name) {
      case "BootpayEventError":
        e = t.eventMessage;
        break;
      default:
        if (M(t.event))
          e = t;
        else
          throw t;
    }
    return e;
  },
  update(t, e = !0) {
    se.update(t), e && this.rerender();
  },
  currentTermsCondition() {
    return se.currentTermsCondition();
  },
  destroy() {
    se.destroy();
  },
  isRendered() {
    return se.isRendered();
  },
  /**
   * 실시간으로 위젯 정보를 전송한다 ( 관리자 동기화용 )
   * Comment by GOSOMI
   * @date: 2023-12-20
   */
  synchronizedRealTimeTransfer(t) {
    se.synchronizedRealTimeTransfer(t);
  },
  /**
   * 결제 수단을 외부에서 선택하는 API
   * Comment by GOSOMI
   * @date: 2024-01-08
   */
  selectPayment(t) {
    se.sendSelectPayment(t);
  },
  /**
   * 로그 레벨을 설정한다
   * Comment by GOSOMI
   * @date: 2021-05-12
   * @param level: number
   * @returns void
   */
  setLogLevel(t) {
    F.setLogLevel(t);
  },
  /**
   * WidgetTemplate으로 메세지를 보낸다
   * Comment by GOSOMI
   * @date: 2024-03-14
   */
  sendMessage(t, e = void 0) {
    se.sendMessage(t, e);
  },
  /**
   * DeviceType을 설정
   * Comment by GOSOMI
   * @date: 2021-12-23
   */
  setDevice(t) {
    return Ee.setDevice(t);
  },
  alertConfirm() {
    ht.destroy(), se.sendMessage("BootpayWidgetAlertConfirm", {
      confirm: !0
    });
  },
  alertCancel() {
    ht.destroy(), se.sendMessage("BootpayWidgetAlertConfirm", {
      confirm: !1
    });
  },
  currentPaymentParameters() {
    return se.currentPaymentParameters();
  },
  isWidgetTypeSubscription() {
    return z.widgetType === 2;
  },
  isWidgetTypePayment() {
    return z.widgetType === 1;
  }
};
typeof window < "u" && (window.BootpayWidget = fo);
class xo extends bs {
  constructor() {
    super(), this.data = {
      application_id: "",
      user_token: "",
      hooks: {}
    };
  }
  encryptKey() {
    return M(this.data.application_id) ? Or(this.data.application_id).toString().substring(0, 16) : "";
  }
  set(e) {
    this.data = e;
  }
  callHook(e, r) {
    this.data.hooks && this.data.hooks[e] && typeof this.data.hooks[e] == "function" && this.data.hooks[e](r);
  }
  encryptParameters() {
    return encodeURIComponent(
      this.encrypt({
        user_token: this.data.user_token,
        sandbox: this.data.sandbox,
        extra: this.data.extra,
        log_level: F.level
      })
    );
  }
}
const ft = new xo(), ws = {
  resize: (t) => {
    Be.resize(t);
  },
  showModal: (t) => {
    Ie.createIFrame(t.url);
  },
  resizeModal: (t) => {
    Ie.resize(t);
  },
  closeModal: () => {
    Ie.destroy();
  },
  confirmModal: (t) => ht.show(
    t.message,
    t.title,
    t.confirmButtonText,
    t.cancelButtonText,
    () => {
      Be.postMessage("BootpayWalletAlertConfirm", {
        confirm: !0
      });
    },
    () => {
      Be.postMessage("BootpayWalletAlertConfirm", {
        confirm: !1
      });
    },
    t.confirm
  ),
  /**
   * 결제수단정보 추가가 완료된 경우
   * Comment by GOSOMI
   * @date: 2025-01-17
   */
  addedSuccess: (t) => {
    Be.postMessage("addedSuccess", t);
  },
  synchronize: (t) => {
    Be.postMessage("walletDataSynchronize", t);
  },
  onReady: (t) => {
    ft.callHook("ready", t);
  },
  onChange: (t) => {
    ft.callHook("change", t);
  }
};
class vo extends ot {
  constructor() {
    super({
      messageEventName: "message.BootpayWalletEvent",
      messageEventHooks: {
        WalletWindowMessage: ws
      }
    });
  }
}
const yo = new vo();
class mo extends ge {
  constructor() {
    super(), this.$iFrameId = "bootpay-wallet-iframe", this.$template = this.defaultIframeHtml(), this.$walletStore = ft, this.el = void 0;
  }
  render(e) {
    this.el = String(e).replace(/#/g, "");
    const r = document.getElementById(this.el);
    if (this.$blank(e) || r === null)
      throw new Error("부트페이 지갑을 렌더링할 DOM Element ID를 입력해주세요.");
    this.templateRender(), yo.bind();
  }
  templateRender() {
    const e = document.getElementById(this.el);
    e.style.setProperty("height", "0"), e.innerHTML = this.$template, this.byId(this.$iFrameId).setAttribute(
      "src",
      D.toWidget(
        `wallet/${this.$walletStore.data.application_id}/${this.$walletStore.encryptParameters()}`
      )
    );
  }
  destroy() {
    const e = document.getElementById(this.el);
    e.innerHTML = "";
  }
  resize(e) {
    this.templateResize(this.el, e);
  }
}
const Be = new mo();
class go extends Ae {
  constructor() {
    super();
  }
  render(e, r) {
    if (this.$blank(r.application_id))
      throw new Error("application id가 입력되지 않았습니다.");
    if (this.$blank(e))
      throw new Error("지갑을 렌더링할 DOM Element ID를 입력해주세요.");
    ft.set(r), Be.render(e);
  }
}
const bo = new go(), _o = {
  render(t, e) {
    bo.render(t, e);
  },
  rerender() {
  },
  setEnvironmentMode(t, e) {
    Ee.setEnvironmentMode(t, e), D.set(t);
  },
  isRendered() {
    return Be.isRendered();
  },
  synchronizedFromBootpay(t) {
    ws.synchronize(t);
  }
};
typeof window < "u" && (window.BootpayWallet = _o);
export {
  Ee as Bootpay,
  D as BootpayEnvironment,
  Si as BootpaySDK,
  no as BootpayStore,
  _o as BootpayWallet,
  fo as BootpayWidget,
  Ee as default
};
